namespace TabAurous.Texts {

    declare namespace Controls {

        namespace Fields {
            export const BOMLaborTab: string;
            export const ImageTab: string;
            export const ProductDetailsTab: string;
        }

        namespace IdleTimeout {
            export const CountdownMessage: string;
            export const KeepAliveButton: string;
            export const SignoutButton: string;
            export const WarningMessage: string;
            export const WarningTitle: string;
        }

        namespace ImageUpload {
            export const AddFileButton: string;
            export const ColorboxClose: string;
            export const ColorboxCurrent: string;
            export const ColorboxNext: string;
            export const ColorboxPrior: string;
            export const DeleteButtonHint: string;
            export const MaxHeight: string;
            export const MaxWidth: string;
            export const MinHeight: string;
            export const MinWidth: string;
            export const NotAnImageFile: string;
            export const UploadFileTooBig: string;
            export const UploadFileTooSmall: string;
        }
    }

    declare namespace Db {

        namespace Administration {

            namespace APIKeys {
                export const AppName: string;
                export const Button: string;
                export const ClientId: string;
                export const Key: string;
                export const Role: string;
                export const Secret: string;
            }

            namespace AuthorizedVouchers {
                export const AuthorizationDate: string;
                export const AuthorizationId: string;
                export const AuthorizedUserId: string;
                export const LoginUserId: string;
                export const Remark: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace CampaignSetup {
                export const ApiKey: string;
                export const AppId: string;
                export const Code: string;
                export const FixedCode: string;
                export const Id: string;
                export const Password: string;
                export const Provider: string;
                export const ProviderType: string;
                export const Token: string;
                export const Type: string;
                export const UserName: string;
            }

            namespace CampaignTemplates {
                export const Code: string;
                export const Footer: string;
                export const Html: string;
                export const Id: string;
                export const Image: string;
                export const Message: string;
                export const ProviderType: string;
                export const ProviderTypeId: string;
                export const TemplateType: string;
                export const TemplateTypeId: string;
                export const Title: string;
                export const Url: string;
            }

            namespace ConfigLookup {
                export const Code: string;
                export const Type: string;
                export const Value: string;
            }

            namespace Configuration {
                export const Code: string;
                export const Description: string;
                export const Id: string;
                export const Name: string;
                export const Type: string;
                export const Value: string;
            }

            namespace DocumentPrinting {
                export const Content: string;
                export const DocumentId: string;
                export const LastModified: string;
                export const LastRequested: string;
                export const Location: string;
            }

            namespace DocumentReports {
                export const DocumentId: string;
                export const ReportFile: string;
                export const ReportId: string;
                export const ReportKey: string;
                export const ReportName: string;
            }

            namespace Freight {
                export const ApiEndpoint: string;
                export const ApiKey: string;
                export const ClientSecret: string;
                export const FreightCode: string;
                export const FreightId: string;
                export const FreightName: string;
                export const LedgerId: string;
                export const Password: string;
                export const UserId: string;
            }

            namespace Integration {
                export const AccessKey: string;
                export const IntegrationType: string;
                export const Password: string;
                export const RefreshToken: string;
                export const RoleArn: string;
                export const SecretKey: string;
                export const Type: string;
                export const Url: string;
                export const Username: string;
            }

            namespace ItemDiscount {
                export const Code: string;
                export const CompanyId: string;
                export const Details: string;
                export const Id: string;
            }

            namespace ItemDiscountDetails {
                export const CategoryId: string;
                export const Code: string;
                export const DetailsId: string;
                export const Id: string;
                export const MaxDiscount: string;
                export const ProductTypeId: string;
                export const String1: string;
                export const SubCategoryId: string;
            }

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace Navigation {
                export const Controller: string;
                export const Icon: string;
                export const IsParent: string;
                export const IsSubParent: string;
                export const MenuId: string;
                export const MenuOrder: string;
                export const Module: string;
                export const Name: string;
                export const SubMenu: string;
            }

            namespace PushNotifyConfig {
                export const ApiKey: string;
                export const AppId: string;
                export const Id: string;
            }

            namespace QualityInspectionTemplate {
                export const Code: string;
                export const Details: string;
                export const TemplateId: string;
            }

            namespace QualityInspectionTemplateDetails {
                export const DetailId: string;
                export const IsNumeric: string;
                export const Max: string;
                export const Min: string;
                export const Parameter: string;
                export const TemplateId: string;
                export const Value: string;
            }

            namespace SendCampaign {
                export const CampaignCode: string;
                export const Code: string;
                export const DateTime: string;
                export const FixedCode: string;
                export const Html: string;
                export const Image: string;
                export const Message: string;
                export const Party: string;
                export const ProviderId: string;
                export const ProviderType: string;
                export const Recurring: string;
                export const Schedule: string;
                export const ScheduleId: string;
                export const ScheduleTypeId: string;
                export const TemplateId: string;
                export const Title: string;
                export const UseTemplate: string;
            }

            namespace SendCampaignDetails {
                export const PartyId: string;
                export const ScheduleDetailsId: string;
                export const ScheduleId: string;
            }

            namespace Sequence {
                export const Code: string;
                export const Id: string;
                export const Name: string;
                export const Processes: string;
            }

            namespace SequenceDetails {
                export const DepartmentId: string;
                export const DeptName: string;
                export const DetailId: string;
                export const Priority: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const SequenceId: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace CRM {

            namespace ProductCatalog {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BrandId: string;
                export const BrandName: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const CollectionName: string;
                export const CostMethodId: string;
                export const CreationDate: string;
                export const CreationVoucherId: string;
                export const DesignId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const ForExchange: string;
                export const GroupSieveName: string;
                export const HSN: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const Image4: string;
                export const Image5: string;
                export const Image6: string;
                export const Image7: string;
                export const Image8: string;
                export const ImageName: string;
                export const InspectionDetails: string;
                export const IsConfigurable: string;
                export const IsCustomerItem: string;
                export const IsDefaultSKU: string;
                export const IsDisabled: string;
                export const IsFeatured: string;
                export const IsNew: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const LaborDetails: string;
                export const LaborMarkup: string;
                export const MaxPurity: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const MetalName: string;
                export const MinPurity: string;
                export const MoldsDetails: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const ParentDesign: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const PriceMarkup: string;
                export const ProductCode: string;
                export const ProductEnquiryType: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityInspectionId: string;
                export const QualityName: string;
                export const Rate: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesPrice: string;
                export const SequenceDetails: string;
                export const ServerDate: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StdPurity: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const SuperTypeName: string;
                export const TaxCode: string;
                export const UnitLabour: string;
                export const Variance: string;
                export const Video1: string;
                export const Video2: string;
                export const Volume: string;
                export const Volume1: string;
                export const Volume2: string;
                export const Weight: string;
            }
        }

        namespace CertificationReturn {

            namespace CertificationReturnTax {
                export const CCTaxAmount: string;
                export const CentralTaxAmount: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const ECommGST: string;
                export const EligibilityForITC: string;
                export const GrossAmount: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const IntegratedTaxAmount: string;
                export const InvoiceType: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const PartyTax: string;
                export const ProductTypeId: string;
                export const ReverseCharge: string;
                export const State: string;
                export const StateTaxAmount: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransTaxId: string;
                export const VoucherNo: string;
            }
        }

        namespace Common {

            namespace GiftVoucherTransactions {
                export const Amount: string;
                export const CompanyId: string;
                export const ExpiryDate: string;
                export const GvMasterId: string;
                export const GvNumber: string;
                export const Id: string;
                export const IsRedeemed: string;
                export const IsSold: string;
                export const IssuedDate: string;
                export const RedeemedTransDate: string;
                export const RedeemedTransId: string;
                export const RedeemedValue: string;
                export const RedeemedVoucherTypeId: string;
                export const TransDate: string;
                export const TransId: string;
                export const VoucherTypeId: string;
            }

            namespace UserPreference {
                export const Name: string;
                export const PreferenceType: string;
                export const UserId: string;
                export const UserPreferenceId: string;
                export const Value: string;
            }
        }

        namespace ECommerce {

            namespace ECommExchange {
                export const AdditionalCharges: string;
                export const AutoPosting: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsECommExchanged: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ECommExchangeBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ECommExchangeItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ECommExchangeLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace ECommExchangeTax {
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace ECommOrder {
                export const AdditionalCharges: string;
                export const AddressDetails: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BillingAddress: string;
                export const BillingCity: string;
                export const BillingCityName: string;
                export const BillingCountry: string;
                export const BillingCountryName: string;
                export const BillingPhone: string;
                export const BillingPin: string;
                export const BillingState: string;
                export const BillingStateName: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CheckList: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const ECommOrderId: string;
                export const ECommOrderNo: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FirstName: string;
                export const GrossAmount: string;
                export const ItemDetails: string;
                export const LastName: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ProductItemImage: string;
                export const PromoDetails: string;
                export const ReasonId: string;
                export const ReceiptAmount: string;
                export const ReceiptDetails: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const ShippingAddress: string;
                export const ShippingCity: string;
                export const ShippingCityName: string;
                export const ShippingCountry: string;
                export const ShippingCountryName: string;
                export const ShippingPhone: string;
                export const ShippingPincode: string;
                export const ShippingState: string;
                export const ShippingStateName: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ECommOrderAddress {
                export const Address1: string;
                export const AddressId: string;
                export const City: string;
                export const CityName: string;
                export const Country: string;
                export const CountryName: string;
                export const POSCustomerId: string;
                export const Phone: string;
                export const Pincode: string;
                export const State: string;
                export const StateName: string;
                export const TransId: string;
                export const Type: string;
            }

            namespace ECommOrderBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ECommOrderItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ECommOrderId: string;
                export const ECommOrderItemId: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsConfigurable: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const Status: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ECommOrderLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace ECommOrderPromo {
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PromoAmount: string;
                export const PromoCode: string;
                export const PromoId: string;
                export const PromoName: string;
                export const PromoPer: string;
                export const TotalAmount: string;
                export const TransId: string;
                export const TransPromoId: string;
            }

            namespace ECommRefund {
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Date: string;
                export const ECommRefundDetails: string;
                export const Email: string;
                export const EnteredBy: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mobile: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OrderVoucherNo: string;
                export const POSCustomerId: string;
                export const PartyBalance: string;
                export const PayOutId: string;
                export const RefDate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const RefundECommsible: string;
                export const RefundTotal: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TotalAmount: string;
                export const TransId: string;
                export const Url: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ECommRefundDetails {
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ExchangeRateId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mode: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OrderId: string;
                export const PartyType: string;
                export const RefNo: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TransDetailId: string;
                export const TransId: string;
            }

            namespace ECommRepair {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const BalanceAmount: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GSTState: string;
                export const GrossAmount: string;
                export const ImageName: string;
                export const ItemDetails: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const Receipt: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxId: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ECommRepairItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const Day1Amount: string;
                export const Day2Amount: string;
                export const Day3Amount: string;
                export const Day4Amount: string;
                export const Day5Amount: string;
                export const Day6Amount: string;
                export const Day7Amount: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const EmployeeId: string;
                export const FancyCharges: string;
                export const Footfall1: string;
                export const Footfall2: string;
                export const Footfall3: string;
                export const Footfall4: string;
                export const Footfall5: string;
                export const FromYear: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsRepairProcess: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const M10Amount: string;
                export const M10Pieces: string;
                export const M10Weight: string;
                export const M11Amount: string;
                export const M11Pieces: string;
                export const M11Weight: string;
                export const M12Amount: string;
                export const M12Pieces: string;
                export const M12Weight: string;
                export const M1Amount: string;
                export const M1Pieces: string;
                export const M1Weight: string;
                export const M2Amount: string;
                export const M2Pieces: string;
                export const M2Weight: string;
                export const M3Amount: string;
                export const M3Pieces: string;
                export const M3Weight: string;
                export const M4Amount: string;
                export const M4Pieces: string;
                export const M4Weight: string;
                export const M5Amount: string;
                export const M5Pieces: string;
                export const M5Weight: string;
                export const M6Amount: string;
                export const M6Pieces: string;
                export const M6Weight: string;
                export const M7Amount: string;
                export const M7Pieces: string;
                export const M7Weight: string;
                export const M8Amount: string;
                export const M8Pieces: string;
                export const M8Weight: string;
                export const M9Amount: string;
                export const M9Pieces: string;
                export const M9Weight: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const Month: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TimeSlot1: string;
                export const TimeSlot2: string;
                export const TimeSlot3: string;
                export const TimeSlot4: string;
                export const TimeSlot5: string;
                export const ToYear: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Week: string;
                export const WeekAmount: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ECommRepairItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ECommRepairLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace ECommRepairTax {
                export const B2CSType: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const ECommGST: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace ECommSales {
                export const AdditionalCharges: string;
                export const Address: string;
                export const AddressDetails: string;
                export const Anniversary: string;
                export const AutoPosting: string;
                export const BalanceAmount: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BillingAddress: string;
                export const BillingCity: string;
                export const BillingCityName: string;
                export const BillingCountry: string;
                export const BillingCountryName: string;
                export const BillingPhone: string;
                export const BillingPin: string;
                export const BillingState: string;
                export const BillingStateName: string;
                export const BirthDate: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const ECommOrderId: string;
                export const ECommOrderNo: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GSTState: string;
                export const GiftDetails: string;
                export const GrossAmount: string;
                export const ImageName: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const PromoDetails: string;
                export const Receipt: string;
                export const ReceiptDetails: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const ShippingAddress: string;
                export const ShippingCity: string;
                export const ShippingCityName: string;
                export const ShippingCountry: string;
                export const ShippingCountryName: string;
                export const ShippingPhone: string;
                export const ShippingPincode: string;
                export const ShippingState: string;
                export const ShippingStateName: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxId: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ECommSalesGiftVoucher {
                export const Amount: string;
                export const Expiry: string;
                export const GiftMasterId: string;
                export const IsPartial: string;
                export const Quantity: string;
                export const TransGiftId: string;
                export const TransId: string;
                export const UniqueCode: string;
                export const Value: string;
            }

            namespace ECommSalesItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BalanceAmount: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const Day1Amount: string;
                export const Day2Amount: string;
                export const Day3Amount: string;
                export const Day4Amount: string;
                export const Day5Amount: string;
                export const Day6Amount: string;
                export const Day7Amount: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ECommOrderItemId: string;
                export const EmployeeId: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const Footfall1: string;
                export const Footfall2: string;
                export const Footfall3: string;
                export const Footfall4: string;
                export const Footfall5: string;
                export const FromYear: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsRepairProcess: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const M10Amount: string;
                export const M10Pieces: string;
                export const M10Weight: string;
                export const M11Amount: string;
                export const M11Pieces: string;
                export const M11Weight: string;
                export const M12Amount: string;
                export const M12Pieces: string;
                export const M12Weight: string;
                export const M1Amount: string;
                export const M1Pieces: string;
                export const M1Weight: string;
                export const M2Amount: string;
                export const M2Pieces: string;
                export const M2Weight: string;
                export const M3Amount: string;
                export const M3Pieces: string;
                export const M3Weight: string;
                export const M4Amount: string;
                export const M4Pieces: string;
                export const M4Weight: string;
                export const M5Amount: string;
                export const M5Pieces: string;
                export const M5Weight: string;
                export const M6Amount: string;
                export const M6Pieces: string;
                export const M6Weight: string;
                export const M7Amount: string;
                export const M7Pieces: string;
                export const M7Weight: string;
                export const M8Amount: string;
                export const M8Pieces: string;
                export const M8Weight: string;
                export const M9Amount: string;
                export const M9Pieces: string;
                export const M9Weight: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const Month: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderAmount: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxAmount: string;
                export const TaxCode: string;
                export const TimeSlot1: string;
                export const TimeSlot2: string;
                export const TimeSlot3: string;
                export const TimeSlot4: string;
                export const TimeSlot5: string;
                export const ToYear: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Week: string;
                export const WeekAmount: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ECommSalesItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ECommSalesLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace ECommSalesPromo {
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PromoAmount: string;
                export const PromoCode: string;
                export const PromoId: string;
                export const PromoName: string;
                export const PromoPer: string;
                export const TotalAmount: string;
                export const TransId: string;
                export const TransPromoId: string;
            }

            namespace ECommSalesReceipt {
                export const Amount: string;
                export const Balance: string;
                export const BankId: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const Code: string;
                export const LedgerId: string;
                export const ModeId: string;
                export const ReceiptId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherType: string;
                export const Scheme: string;
                export const SchemeEnrollmentId: string;
                export const Total: string;
                export const TransId: string;
            }

            namespace ECommSalesReport {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const CurrencyId: string;
                export const DeppartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GrossAmountDay1: string;
                export const GrossAmountDay2: string;
                export const GrossAmountDay3: string;
                export const GrossAmountDay4: string;
                export const GrossAmountDay5: string;
                export const GrossAmountDay6: string;
                export const GrossAmountSlot1: string;
                export const GrossAmountSlot2: string;
                export const GrossAmountSlot3: string;
                export const GrossAmountSlot4: string;
                export const GrossAmountSlot5: string;
                export const GrossAmountSlot6: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const Pieces: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TotalGrossAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace ECommSalesReturn {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const AutoPosting: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const IsReturned: string;
                export const ItemDetails: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxId: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ECommSalesReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ECommSalesReturnItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ECommSalesReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ECommSalesReturnTax {
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace ECommSalesTax {
                export const B2CSType: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const ECommGST: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace OrderManagementCheckList {
                export const CheckListId: string;
                export const CheckListName: string;
                export const CheckListValue: string;
                export const Id: string;
                export const TransId: string;
                export const TransItemId: string;
            }

            namespace OrderProcessing {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const AvailablePieces: string;
                export const AvailableWeight: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CcGrossAmount: string;
                export const CcNetAmount: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CurrentPosition: string;
                export const CustomerName: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ECommOrderId: string;
                export const ECommOrderItemId: string;
                export const ECommOrderNo: string;
                export const Email: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const Stoneweight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TypeDescription: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace OrderReceipt {
                export const Amount: string;
                export const BankId: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const Code: string;
                export const Id: string;
                export const LedgerId: string;
                export const ModeId: string;
                export const ReceiptDetails: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherType: string;
                export const Scheme: string;
                export const SchemeEnrollmentId: string;
                export const TransId: string;
            }

            namespace OrdersManagement {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CcGrossAmount: string;
                export const CcNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CheckList: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const ECommOrderId: string;
                export const ECommOrderNo: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ReasonId: string;
                export const ReceiptAmount: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace PickUp {
                export const AWBNumber: string;
                export const AdditionalCharges: string;
                export const Address: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CityId: string;
                export const CompanyId: string;
                export const CountryId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const ECommOrderId: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FirstName: string;
                export const FreightId: string;
                export const GrossAmount: string;
                export const ItemDetails: string;
                export const LabelId: string;
                export const LastName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const PickupDate: string;
                export const PickupTime: string;
                export const Pieces: string;
                export const Pin: string;
                export const PosCustomerCode: string;
                export const ReceiptAmount: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const StateId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace PickUpBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace PickUpItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ECommOrderId: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const Status: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace Receipt {
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Date: string;
                export const EnteredBy: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const IsAdvance: string;
                export const KnockOffTotal: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OrderVoucherNo: string;
                export const POSCustomerId: string;
                export const PartyBalance: string;
                export const ReceiptDetails: string;
                export const RefDate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SuffixPrefixId: string;
                export const SysDate: string;
                export const TaxLedgerId: string;
                export const TotalAmount: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ReceiptDetails {
                export const Amount: string;
                export const BankId: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ExchangeRateId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mode: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OrderId: string;
                export const PartyType: string;
                export const RefNo: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TransDetailId: string;
                export const TransId: string;
            }

            namespace ReturnsManagement {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CcGrossAmount: string;
                export const CcNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CheckList: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const ECommOrderId: string;
                export const ECommOrderNo: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ReasonId: string;
                export const ReceiptAmount: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace Shipping {
                export const AWBNumber: string;
                export const AdditionalCharges: string;
                export const Address: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CityId: string;
                export const CompanyId: string;
                export const CountryId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const ECommOrderId: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FirstName: string;
                export const FreightId: string;
                export const GrossAmount: string;
                export const ItemDetails: string;
                export const LabelId: string;
                export const LastName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const PickupDate: string;
                export const PickupTime: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ReceiptAmount: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const StateId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ShippingBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ShippingItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ECommOrderId: string;
                export const ECommOrderItemId: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const Status: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }
        }

        namespace Fields {
            export const AWBNumber: string;
            export const AccountGroupName: string;
            export const AccountingContraDetailId: string;
            export const AccountingExpense: string;
            export const AccountingPeriodCode: string;
            export const AccountingVoucherTypeId: string;
            export const AcknowledgementStatus: string;
            export const AdditionalChargeCode: string;
            export const AdditionalChargeName: string;
            export const AdditionalCharges: string;
            export const Address: string;
            export const Address2: string;
            export const AddressType: string;
            export const AddtoZiFlow: string;
            export const AgainstId: string;
            export const AgainstInvoiceNo: string;
            export const AgainstVoucherNo: string;
            export const AgainstVoucherTypeId: string;
            export const AllVouchers: string;
            export const Amount: string;
            export const ApplicableOn: string;
            export const Attribute: string;
            export const AttributeCode: string;
            export const AttributeName: string;
            export const AttributeType: string;
            export const AvailablePieces: string;
            export const AvailableWeight: string;
            export const B2CSType: string;
            export const BOMAttributeId: string;
            export const BOMProductId: string;
            export const BagNo: string;
            export const BagStatus: string;
            export const Balance: string;
            export const BalanceAmount: string;
            export const BalanceIsPosted: string;
            export const BalancePostingDate: string;
            export const BalanceUserId: string;
            export const Bank: string;
            export const BaseItemTypeId: string;
            export const BaseWeight: string;
            export const BillDate: string;
            export const BillNo: string;
            export const BomAmount: string;
            export const BomRate: string;
            export const Brand: string;
            export const BrandCode: string;
            export const BrandName: string;
            export const Button: string;
            export const ButtonWeight: string;
            export const CCBomAmount: string;
            export const CCCredit: string;
            export const CCDebit: string;
            export const CCGrossAmount: string;
            export const CCLaborAmount: string;
            export const CCNetAmount: string;
            export const CCRoundOff: string;
            export const CCTaxAmount: string;
            export const CST: string;
            export const CalcOn: string;
            export const CalcUnit: string;
            export const Category: string;
            export const CategoryCode: string;
            export const CategoryName: string;
            export const CenterStone: string;
            export const CertificateNo: string;
            export const CessId: string;
            export const ChallanDate: string;
            export const ChallanNo: string;
            export const Chargeable: string;
            export const CheckListId: string;
            export const CheckListValue: string;
            export const ChequeDate: string;
            export const ChequeNo: string;
            export const City: string;
            export const Collection: string;
            export const CollectionCode: string;
            export const CollectionName: string;
            export const ColorQualityMapping: string;
            export const Comment: string;
            export const Company: string;
            export const CompanyCode: string;
            export const CompanyType: string;
            export const ContraId: string;
            export const CostMethod: string;
            export const Country: string;
            export const CreationDate: string;
            export const Credit: string;
            export const CreditNote: string;
            export const CreditPeriod: string;
            export const Currency: string;
            export const CurrentStatus: string;
            export const Customer: string;
            export const CustomerCode: string;
            export const CustomerName: string;
            export const Day1Amount: string;
            export const Day2Amount: string;
            export const Day3Amount: string;
            export const Day4Amount: string;
            export const Day5Amount: string;
            export const Day6Amount: string;
            export const Day7Amount: string;
            export const Debit: string;
            export const DebitNote: string;
            export const Decision: string;
            export const DefaultTDS: string;
            export const DeliveryDate: string;
            export const DepartmentId: string;
            export const DesignCode: string;
            export const DesignName: string;
            export const Designation: string;
            export const DetailId: string;
            export const DiamondAmount: string;
            export const DiamondPieces: string;
            export const DiamondWeight: string;
            export const Discount: string;
            export const DiscountPercentage: string;
            export const DiscountType: string;
            export const Due: string;
            export const ECommGST: string;
            export const ECommOrderId: string;
            export const ECommOrderItemId: string;
            export const ECommOrderNo: string;
            export const Email: string;
            export const Employee: string;
            export const EndDateTime: string;
            export const EnteredBy: string;
            export const ExchangeRate: string;
            export const ExcludeDiscount: string;
            export const ExpectedValue: string;
            export const Expiry: string;
            export const ExportPieces: string;
            export const Extra1: string;
            export const Extra2: string;
            export const ExtraDate: string;
            export const FancyCharges: string;
            export const FinancialYear: string;
            export const FinancialYearId: string;
            export const FirstName: string;
            export const Flow: string;
            export const Footfall1: string;
            export const Footfall2: string;
            export const Footfall3: string;
            export const Footfall4: string;
            export const Footfall5: string;
            export const ForExchange: string;
            export const Freight: string;
            export const FromDate: string;
            export const FromDepartmentId: string;
            export const FromDeptId: string;
            export const FromDeptName: string;
            export const FromEmployeeId: string;
            export const FromEmployeeName: string;
            export const FromNetWeight: string;
            export const FromPieces: string;
            export const FromProcessId: string;
            export const FromWeight: string;
            export const FromWorkerId: string;
            export const FromYear: string;
            export const GSTState: string;
            export const GiftMasterId: string;
            export const GrossAmount: string;
            export const GrossAmountDay1: string;
            export const GrossAmountDay2: string;
            export const GrossAmountDay3: string;
            export const GrossAmountDay4: string;
            export const GrossAmountDay5: string;
            export const GrossAmountDay6: string;
            export const GrossAmountSlot1: string;
            export const GrossAmountSlot2: string;
            export const GrossAmountSlot3: string;
            export const GrossAmountSlot4: string;
            export const GrossAmountSlot5: string;
            export const GrossAmountSlot6: string;
            export const GrossWeight: string;
            export const Group: string;
            export const GroupSieve: string;
            export const GroupUnder: string;
            export const HSN: string;
            export const HUID: string;
            export const Hallmark: string;
            export const HasBom: string;
            export const ImageName: string;
            export const IncludeTax: string;
            export const InspectedValue: string;
            export const IsAffectGrossProfit: string;
            export const IsCustomerItem: string;
            export const IsDefault: string;
            export const IsDefaultSKU: string;
            export const IsDisabled: string;
            export const IsECommExchanged: string;
            export const IsExisting: string;
            export const IsPartial: string;
            export const IsPosted: string;
            export const IsRepairProcess: string;
            export const IsReturned: string;
            export const ItemGrossAmount: string;
            export const ItemNetAmount: string;
            export const ItemType: string;
            export const Journal: string;
            export const JournalCompany: string;
            export const Karat: string;
            export const KnockOff: string;
            export const KnockOffTotal: string;
            export const Lab: string;
            export const LaborAmount: string;
            export const LaborDiscount: string;
            export const LaborMarkup: string;
            export const LaborPriceList: string;
            export const LaborRate: string;
            export const LastName: string;
            export const LedgerName: string;
            export const LineNo: string;
            export const Loss: string;
            export const LossPercent: string;
            export const LotNo: string;
            export const M10Amount: string;
            export const M10Pieces: string;
            export const M10Weight: string;
            export const M11Amount: string;
            export const M11Pieces: string;
            export const M11Weight: string;
            export const M12Amount: string;
            export const M12Pieces: string;
            export const M12Weight: string;
            export const M1Amount: string;
            export const M1Pieces: string;
            export const M1Weight: string;
            export const M2Amount: string;
            export const M2Pieces: string;
            export const M2Weight: string;
            export const M3Amount: string;
            export const M3Pieces: string;
            export const M3Weight: string;
            export const M4Amount: string;
            export const M4Pieces: string;
            export const M4Weight: string;
            export const M5Amount: string;
            export const M5Pieces: string;
            export const M5Weight: string;
            export const M6Amount: string;
            export const M6Pieces: string;
            export const M6Weight: string;
            export const M7Amount: string;
            export const M7Pieces: string;
            export const M7Weight: string;
            export const M8Amount: string;
            export const M8Pieces: string;
            export const M8Weight: string;
            export const M9Amount: string;
            export const M9Pieces: string;
            export const M9Weight: string;
            export const MCredit: string;
            export const MDebit: string;
            export const MailingName: string;
            export const Manage: string;
            export const MarkUp: string;
            export const MarkUpPolicy: string;
            export const MarkUpPolicyCode: string;
            export const MarkUpPolicyId: string;
            export const MarkUpPolicyName: string;
            export const MarkUpType: string;
            export const Max: string;
            export const MaxDiscountPercent: string;
            export const MaximumLabor: string;
            export const Metal: string;
            export const MetalAmount: string;
            export const MetalBalance: string;
            export const MetalColor: string;
            export const MetalConsumed: string;
            export const MetalIssued: string;
            export const MetalRequired: string;
            export const Min: string;
            export const MinimumLabor: string;
            export const Mobile: string;
            export const Mode: string;
            export const Month: string;
            export const MovementDate: string;
            export const MovementId: string;
            export const MultiplicationFactor: string;
            export const MultiplicationFactorAmount: string;
            export const Narration: string;
            export const Nature: string;
            export const NetAmount: string;
            export const NetWeight: string;
            export const NoOfSubBag: string;
            export const NoofBags: string;
            export const OldBagNo: string;
            export const OldLineNo: string;
            export const OpeningBalanceType: string;
            export const OrderPiece: string;
            export const OrderStatusId: string;
            export const OrderTransItemId: string;
            export const OrderTypeId: string;
            export const OrderVoucherNo: string;
            export const OriginalLabourAmount: string;
            export const OriginalLabourRate: string;
            export const OtherAmount: string;
            export const OtherCharges: string;
            export const OtherPieces: string;
            export const OtherRate: string;
            export const OtherWeight: string;
            export const OverdueDays: string;
            export const PAN: string;
            export const PDCType: string;
            export const PDCVoucherNo: string;
            export const POSCustomer: string;
            export const POSCustomerId: string;
            export const ParentAttributeId: string;
            export const Parties: string;
            export const Parts: string;
            export const PartsPerSubBag: string;
            export const Party: string;
            export const PartyBalance: string;
            export const PartyBalanceId: string;
            export const PartyCode: string;
            export const PartyLedgerId: string;
            export const PartyName: string;
            export const PayOutId: string;
            export const PaymentLedger: string;
            export const PcsPerSubBag: string;
            export const PeriodId: string;
            export const PeriodicClosingAccount: string;
            export const PeriodicPostingDate: string;
            export const Phone: string;
            export const PickupDate: string;
            export const PickupTime: string;
            export const Pieces: string;
            export const PiecesPerSubBag: string;
            export const Pin: string;
            export const Pincode: string;
            export const PlaceofSupply: string;
            export const PointerWeight: string;
            export const PostingDate: string;
            export const PriceCode: string;
            export const PriceList: string;
            export const PriceName: string;
            export const PriceType: string;
            export const Priority: string;
            export const Process: string;
            export const ProductCalculateOn: string;
            export const ProductCode: string;
            export const ProductId: string;
            export const ProductItemImage: string;
            export const ProductName: string;
            export const ProductSize: string;
            export const ProductType: string;
            export const PromoAmount: string;
            export const PromoId: string;
            export const PromoPer: string;
            export const PurchaseRate: string;
            export const PureWeight: string;
            export const Purity: string;
            export const QCPass: string;
            export const Quality: string;
            export const Quantity: string;
            export const Quarter1: string;
            export const Quarter2: string;
            export const Quarter3: string;
            export const RMDepartmentId: string;
            export const Rate: string;
            export const RateType: string;
            export const Reason: string;
            export const ReceiptAmount: string;
            export const ReceiptId: string;
            export const ReceivedAmount: string;
            export const ReceivedWeight: string;
            export const RefDepartmentId: string;
            export const RefMovementId: string;
            export const RefTransBom: string;
            export const RefTransId: string;
            export const RefVoucherType: string;
            export const ReferenceDate: string;
            export const ReferenceNo: string;
            export const ReferenceTransactionId: string;
            export const ReferenceTransactionItemId: string;
            export const ReferenceType: string;
            export const Refund: string;
            export const RefundECommsible: string;
            export const RefundTotal: string;
            export const Remark: string;
            export const RequiredPieces: string;
            export const RequiredWeight: string;
            export const RoundOff: string;
            export const Routing: string;
            export const SKU: string;
            export const SalesPerson: string;
            export const SalesRate: string;
            export const Scheme: string;
            export const SchemeEnrollmentId: string;
            export const ServerDate: string;
            export const ServiceId: string;
            export const ServiceInwardDetailsMasterId: string;
            export const ServiceInwardMasterId: string;
            export const ServiceInwards: string;
            export const ServiceOutwardDetailsMasterId: string;
            export const ServiceOutwardMasterId: string;
            export const Setting: string;
            export const Shape: string;
            export const Share: string;
            export const ShipAddress: string;
            export const Shipment: string;
            export const Sieve: string;
            export const SpecialRemark: string;
            export const Stamp: string;
            export const StartDateTime: string;
            export const State: string;
            export const Status: string;
            export const StockId: string;
            export const StoneAmount: string;
            export const StoneColor: string;
            export const StoneCulet: string;
            export const StoneCut: string;
            export const StoneDepth: string;
            export const StoneDiscount: string;
            export const StoneFluorescence: string;
            export const StoneGirdle: string;
            export const StoneMarkup: string;
            export const StonePieces: string;
            export const StonePolish: string;
            export const StoneRate: string;
            export const StoneSize: string;
            export const StoneStatusId: string;
            export const StoneStatusName: string;
            export const StoneSymmetry: string;
            export const StoneTable: string;
            export const StoneWeight: string;
            export const Studded: string;
            export const SubBagNo: string;
            export const SubCategory: string;
            export const SuperType: string;
            export const Supplier: string;
            export const SupplierCode: string;
            export const SupplierName: string;
            export const SurplusAccount: string;
            export const SysDate: string;
            export const TDS: string;
            export const TDSAmount: string;
            export const TDSRate: string;
            export const TDSTotal: string;
            export const TaxAmount: string;
            export const TaxCode: string;
            export const TaxId: string;
            export const TaxNumber: string;
            export const TaxRate: string;
            export const TaxRegistrationType: string;
            export const Terms: string;
            export const TermsId: string;
            export const TimeSlot1: string;
            export const TimeSlot2: string;
            export const TimeSlot3: string;
            export const TimeSlot4: string;
            export const TimeSlot5: string;
            export const ToAttributeId: string;
            export const ToDate: string;
            export const ToDepartmentId: string;
            export const ToDeptId: string;
            export const ToDeptName: string;
            export const ToEmployeeId: string;
            export const ToEmployeeName: string;
            export const ToNetWeight: string;
            export const ToPieces: string;
            export const ToProcessId: string;
            export const ToProduct: string;
            export const ToWeight: string;
            export const ToWorkerId: string;
            export const ToYear: string;
            export const Total: string;
            export const TotalAmount: string;
            export const TotalGrossAmount: string;
            export const TransDate: string;
            export const TransDetailId: string;
            export const TransGiftId: string;
            export const TransId: string;
            export const TransInspectionId: string;
            export const TransItemId: string;
            export const TransLbrId: string;
            export const TransLossId: string;
            export const TransPromoId: string;
            export const TransactionCalculateOn: string;
            export const TreeId: string;
            export const TreeItemId: string;
            export const TreeNo: string;
            export const TreeWeight: string;
            export const Type: string;
            export const UOM: string;
            export const UniqueCode: string;
            export const UnitCost: string;
            export const UnitLabor: string;
            export const UnitRate: string;
            export const Url: string;
            export const UserDescription: string;
            export const UserId: string;
            export const Value: string;
            export const VoucherNo: string;
            export const VoucherType: string;
            export const Vouchers: string;
            export const WastagePercentage: string;
            export const WastageWeight: string;
            export const Week: string;
            export const WeekAmount: string;
            export const Weight: string;
            export const WorkOrder: string;
            export const WstPer: string;
            export const WstWt: string;
        }

        namespace Finance {

            namespace AccountingPeriod {
                export const Code: string;
                export const CompanyId: string;
                export const Details: string;
                export const FromDate: string;
                export const PeriodId: string;
                export const ToDate: string;
            }

            namespace AccountingPeriodDetails {
                export const CompanyId: string;
                export const DetailId: string;
                export const IsClosed: string;
                export const PeriodId: string;
                export const TypeOfVoucher: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
            }

            namespace Contra {
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Details: string;
                export const EnteredBy: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const RefDate: string;
                export const RefNo: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SuffixPrefixId: string;
                export const SysDate: string;
                export const TaxLedgerId: string;
                export const TotalAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ContraDetail {
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ExchangeRateId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mode: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PartyType: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TransDetailId: string;
                export const TransId: string;
            }

            namespace Expense {
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Details: string;
                export const EnteredBy: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const RefDate: string;
                export const RefNo: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SuffixPrefixId: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxLedgerId: string;
                export const TotalAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ExpenseDetail {
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ExchangeRateId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mode: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PartyType: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TransDetailsId: string;
                export const TransId: string;
            }

            namespace Journal {
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Details: string;
                export const EnteredBy: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const RefDate: string;
                export const RefNo: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SuffixPrefixId: string;
                export const SysDate: string;
                export const TaxLedgerId: string;
                export const TotalAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace JournalDetail {
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ExchangeRateId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mode: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PartyType: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TransDetailsId: string;
                export const TransId: string;
            }

            namespace OpeningBalance {
                export const Amount: string;
                export const AutoPosting: string;
                export const CCAmount: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const IsPosted: string;
                export const LedgerName: string;
                export const OpeningBalanceTypeId: string;
                export const PartyId: string;
                export const PostingDate: string;
                export const Remark: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace PDCClearance {
                export const AgainstId: string;
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CompanyId: string;
                export const CreatedBy: string;
                export const Details: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const PDCTypeId: string;
                export const PDCVoucherNo: string;
                export const RefDate: string;
                export const RefNo: string;
                export const Status: string;
                export const TransDate: string;
                export const TransId: string;
                export const Type: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace PDCClearanceDetails {
                export const AgainstId: string;
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CompanyId: string;
                export const CreatedBy: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const RefDate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const Status: string;
                export const TransDate: string;
                export const TransDetailsId: string;
                export const TransId: string;
                export const Type: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace PDCPayable {
                export const Amount: string;
                export const BankId: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CompanyId: string;
                export const CreatedBy: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const KnockOffTotal: string;
                export const LedgerName: string;
                export const Narration: string;
                export const PartyBalance: string;
                export const PartyId: string;
                export const RefDate: string;
                export const RefNo: string;
                export const Status: string;
                export const TransDate: string;
                export const TransId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace PDCReceivable {
                export const Amount: string;
                export const BankId: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CompanyId: string;
                export const CreatedBy: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const LedgerName: string;
                export const Narration: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const RefDate: string;
                export const RefNo: string;
                export const RefVoucherNo: string;
                export const Status: string;
                export const TransDate: string;
                export const TransId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace PartyBalance {
                export const AgainstInvoiceNo: string;
                export const AgainstVoucherNo: string;
                export const AgainstVoucherTypeId: string;
                export const BalanceAmount: string;
                export const CCCredit: string;
                export const CCDebit: string;
                export const CheckRefund: string;
                export const CompanyId: string;
                export const Credit: string;
                export const CreditNote: string;
                export const CreditPeriod: string;
                export const Debit: string;
                export const DebitNote: string;
                export const Due: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const KnockOff: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const MCredit: string;
                export const MDebit: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OverDueDays: string;
                export const POSCustomerId: string;
                export const PartyBalanceId: string;
                export const ReceivedAmount: string;
                export const RefTransId: string;
                export const ReferenceType: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TotalAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
            }

            namespace Payment {
                export const Address1: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Details: string;
                export const EnteredBy: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const GstVat: string;
                export const InvoiceNo: string;
                export const KnockOffTotal: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const Pan: string;
                export const PartyBalance: string;
                export const Pincode: string;
                export const Rate: string;
                export const RefDate: string;
                export const RefNo: string;
                export const State: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TdsTotal: string;
                export const TotalAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace PaymentDetails {
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ExchangeRate: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mode: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PartyType: string;
                export const RefNo: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TransDetailId: string;
                export const TransId: string;
            }

            namespace PeriodicClosing {
                export const CompanyId: string;
                export const FinancialYear: string;
                export const PostingDate: string;
                export const SurplusAccountId: string;
                export const TransDate: string;
                export const TransId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace Receipt {
                export const Address1: string;
                export const BankId: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Details: string;
                export const EnteredBy: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const GstVat: string;
                export const InvoiceNo: string;
                export const KnockOffTotal: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const Pan: string;
                export const PartyBalance: string;
                export const Pincode: string;
                export const RefDate: string;
                export const RefNo: string;
                export const State: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TotalAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ReceiptDetails {
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ExchangeRateId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mode: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PartyType: string;
                export const RefNo: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TransDetailId: string;
                export const TransId: string;
            }

            namespace ServiceInward {
                export const Address1: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Details: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const InvoiceNo: string;
                export const KnockOffTotal: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const NetAmount: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const Pan: string;
                export const Pincode: string;
                export const Rate: string;
                export const RefDate: string;
                export const RefNo: string;
                export const State: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TdsTotal: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ServiceInwardDetails {
                export const Amount: string;
                export const CategoryId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const ServiceCode: string;
                export const ServiceId: string;
                export const TaxCode: string;
                export const TransDetailId: string;
                export const TransId: string;
            }

            namespace ServiceInwardTax {
                export const B2CSType: string;
                export const CCTaxAmount: string;
                export const CentralTaxAmount: string;
                export const ECommGST: string;
                export const EligibilityForITC: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const IntegratedTaxAmount: string;
                export const InvoiceType: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const PartyTax: string;
                export const ProductTypeId: string;
                export const ReverseCharge: string;
                export const State: string;
                export const StateTaxAmount: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace ServiceOutward {
                export const Address1: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Details: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const InvoiceNo: string;
                export const KnockOffTotal: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const NetAmount: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const Pan: string;
                export const Pincode: string;
                export const Rate: string;
                export const RefDate: string;
                export const RefNo: string;
                export const State: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TdsTotal: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ServiceOutwardDetails {
                export const Amount: string;
                export const CategoryId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const ServiceCode: string;
                export const ServiceId: string;
                export const TaxCode: string;
                export const TransDetailId: string;
                export const TransId: string;
            }

            namespace ServiceOutwardTax {
                export const B2CSType: string;
                export const CCTaxAmount: string;
                export const CentralTaxAmount: string;
                export const ECommGST: string;
                export const EligibilityForITC: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const IntegratedTaxAmount: string;
                export const InvoiceType: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const PartyTax: string;
                export const ProductTypeId: string;
                export const ReverseCharge: string;
                export const State: string;
                export const StateTaxAmount: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }
        }

        namespace HR {

            namespace Attendance {
                export const CompanyId: string;
                export const Details: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace AttendanceDetails {
                export const Absent: string;
                export const DetailId: string;
                export const EmployeeCode: string;
                export const EmployeeId: string;
                export const EmployeeName: string;
                export const HalfDay: string;
                export const OnLeave: string;
                export const Present: string;
                export const TransDate: string;
                export const TransId: string;
            }

            namespace EmployeeAdvance {
                export const Amount: string;
                export const ChequeDate: string;
                export const Chequenumber: string;
                export const CompanyId: string;
                export const Date: string;
                export const EmployeeId: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const LedgerId: string;
                export const Narration: string;
                export const SalaryMonth: string;
                export const SuffixPrefixId: string;
                export const TransId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace EmployeeQualification {
                export const Code: string;
                export const Name: string;
                export const QualificationId: string;
            }

            namespace EmploymentType {
                export const Code: string;
                export const EmploymentTypeId: string;
                export const Name: string;
            }

            namespace HolidayList {
                export const Code: string;
                export const Description: string;
                export const EndDate: string;
                export const HolidayListId: string;
                export const Holidays: string;
                export const StartDate: string;
            }

            namespace Holidays {
                export const Date: string;
                export const HolidayId: string;
                export const HolidayListId: string;
                export const HolidayName: string;
                export const Narration: string;
            }

            namespace IncomeTaxSlabDetails {
                export const Condition: string;
                export const DetailsId: string;
                export const FromAmount: string;
                export const IncomeTaxSlabId: string;
                export const PerecentDeduction: string;
                export const ToAmount: string;
                export const Value: string;
            }

            namespace IncomeTaxSlabs {
                export const AllowTaxExemption: string;
                export const Code: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const EffectiveFrom: string;
                export const IncomeSlabId: string;
                export const IsDisabled: string;
                export const Narration: string;
                export const StdTaxExemption: string;
                export const TaxSlabDetails: string;
            }

            namespace LeaveAllocation {
                export const EmployeeId: string;
                export const FromDate: string;
                export const LeaveAllocationId: string;
                export const LeaveTypeId: string;
                export const Leaves: string;
                export const ToDate: string;
            }

            namespace LeavePolicy {
                export const LeavePolicyCode: string;
                export const LeavePolicyId: string;
                export const LeaveTypes: string;
            }

            namespace LeavePolicyDetails {
                export const AllocatedDays: string;
                export const LeavePolicyDetailId: string;
                export const LeavePolicyId: string;
                export const LeaveTypeCode: string;
                export const LeaveTypeId: string;
            }

            namespace LeaveType {
                export const AllowEncashment: string;
                export const AllowNegativeBalance: string;
                export const ApplicableAfter: string;
                export const EncashmentComponentId: string;
                export const FractionofDailySalaryPerLeave: string;
                export const Includeholidayswithinleavesasleaves: string;
                export const IsCarryForward: string;
                export const IsCompensatory: string;
                export const IsLeaveWithoutPay: string;
                export const IsOptional: string;
                export const IsPartiallyPaidLeaves: string;
                export const LeaveTypeCode: string;
                export const LeaveTypeId: string;
                export const MaxContinuosDays: string;
                export const MaxEncashmentDays: string;
                export const MaxLeavesAllowed: string;
            }

            namespace Payroll {
                export const BranchId: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const DesignationId: string;
                export const Details: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const LedgerId: string;
                export const PayrollFrequency: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace PayrollDetails {
                export const Absent: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const Deductions: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignationId: string;
                export const DesignationName: string;
                export const DetailId: string;
                export const Earnings: string;
                export const EmployeeCode: string;
                export const EmployeeDetails: string;
                export const EmployeeId: string;
                export const EmployeeName: string;
                export const GrossSalary: string;
                export const HalfDay: string;
                export const NetSalary: string;
                export const OnLeave: string;
                export const Present: string;
                export const TaxAmount: string;
                export const TransId: string;
            }

            namespace PayrollEmployeeDetails {
                export const Amount: string;
                export const Code: string;
                export const ComponentId: string;
                export const EmployeeDetailId: string;
                export const EmployeeId: string;
                export const Percentage: string;
                export const Type: string;
            }

            namespace PayrollPeriod {
                export const FromDate: string;
                export const PayrollPeriodCode: string;
                export const PayrollPeriodId: string;
                export const ToDate: string;
            }

            namespace SalaryComponent {
                export const Code: string;
                export const Narration: string;
                export const SalaryComponentId: string;
                export const Type: string;
            }

            namespace SalaryPackage {
                export const Code: string;
                export const IsDisabled: string;
                export const Narration: string;
                export const PackageDetails: string;
                export const SalaryPackageId: string;
                export const TotalAmount: string;
            }

            namespace SalaryPackageDetails {
                export const Amount: string;
                export const Code: string;
                export const ComponentId: string;
                export const Narration: string;
                export const Percentage: string;
                export const SalaryPackageDetailsId: string;
                export const SalaryPackageId: string;
                export const Type: string;
            }
        }

        namespace Inventory {

            namespace BranchIn {
                export const AdditionalCharges: string;
                export const Authorize: string;
                export const AuthorizedBy: string;
                export const AuthorizedDate: string;
                export const AutoPosting: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BranchId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace BranchInBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace BranchInItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace BranchInLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace BranchInTax {
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace BranchOut {
                export const AdditionalCharges: string;
                export const AutoPosting: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BranchId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace BranchOutBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace BranchOutItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace BranchOutLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace BranchOutTax {
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace CertificationIssue {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BaseItemTypeId: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace CertificationIssueBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace CertificationIssueItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace CertificationReturn {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace CertificationReturnBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace CertificationReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace CertificationReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ConvertToWIP {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const AutoPosting: string;
                export const BagNo: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const Line_No: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProcessId: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const SubBagNo: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace ConvertToWIPBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ConvertToWIPItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefDepartmentId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubBagNo: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace LocationTransfer {
                export const AdditionalCharges: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FromDepartmentId: string;
                export const FromDepartmentName: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const ToDepartmentId: string;
                export const ToDepartmentName: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace LocationTransferBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace LocationTransferItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace LotCreation {
                export const AutoPosting: string;
                export const CommonItemDetails: string;
                export const CompanyId: string;
                export const Details: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const IsPosted: string;
                export const PostingDate: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace LotCreationBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefStockBomId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransactionId: string;
                export const Weight: string;
            }

            namespace LotCreationDetails {
                export const AckStatus: string;
                export const AllotedNetWeight: string;
                export const AllotedPieces: string;
                export const AllotedWeight: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BalanceNetWeight: string;
                export const BalancePieces: string;
                export const BalanceWeight: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const GenerateLot: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const HasBom: string;
                export const Hsn: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const ItemsDetails: string;
                export const KaratId: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const NewGrossWeight: string;
                export const NewNetWeight: string;
                export const NewPieces: string;
                export const NewProductCode: string;
                export const NewProductId: string;
                export const NewStoneWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefTransTypeId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SpecialRemark: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace LotCreationItems {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StonePieces: string;
                export const StoneRate: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransactionId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
                export const __id: string;
            }

            namespace MRP {
                export const AttributeId: string;
                export const DetailsId: string;
                export const DifferenceQuantity: string;
                export const FixedCode: string;
                export const InProcessQuantity: string;
                export const InStock: string;
                export const Maximum0: string;
                export const Maximum1: string;
                export const Maximum2: string;
                export const Minimum0: string;
                export const Minimum1: string;
                export const Minimum2: string;
                export const OrderQuantity: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const TransId: string;
                export const UOM: string;
            }

            namespace MaterialPayment {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const PostingDate: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
            }

            namespace MaterialPaymentItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StonePieces: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace MaterialReceipt {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const PostingDate: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
            }

            namespace MaterialReceiptItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const GroupSieveName: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsConfigurable: string;
                export const IsCustomerItem: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherRate: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace MaterialRequest {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const ItemDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace MaterialRequestBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace MaterialRequestItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const InStock: string;
                export const IsClosed: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StonePieces: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace MaterialReturn {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const PostingDate: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
            }

            namespace MaterialReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const GroupSieveName: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsConfigurable: string;
                export const IsCustomerItem: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherRate: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace Melting {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const AutoPosting: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const IssuedAlloy: string;
                export const IssuedPureWeight: string;
                export const ItemDetails: string;
                export const KaratId: string;
                export const Loss: string;
                export const LossPercent: string;
                export const MetalColorId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const Purity: string;
                export const ReceivableWeight: string;
                export const ReceivedWeight: string;
                export const Remark: string;
                export const RequiredAlloy: string;
                export const RequiredAlloyTemp: string;
                export const RequiredPureWeight: string;
                export const ReturnDetails: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const StonePieces: string;
                export const Stoneweight: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace MeltingItems {
                export const AckStatus: string;
                export const AlloyRequired: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const ConversionFactor: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const GroupId: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const Line_No: string;
                export const LotNo: string;
                export const NetWeight: string;
                export const OtherRate: string;
                export const Parts: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const ReceivableWeight: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneRate: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace MeltingReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const GroupId: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalColorName: string;
                export const NetWeight: string;
                export const OtherRate: string;
                export const Parts: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneRate: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace Mixing {
                export const AutoPosting: string;
                export const CompanyId: string;
                export const Details: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const IsPosted: string;
                export const ItemsDetails: string;
                export const PostingDate: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace MixingDetails {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const HasBom: string;
                export const Hsn: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const NetWeight: string;
                export const NewPieces: string;
                export const NewProductId: string;
                export const NewSKU: string;
                export const NewWeight: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefTransTypeId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace MixingItems {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const Hsn: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const NetWeight: string;
                export const OtherRate: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneColorId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const TransId: string;
                export const TransactionId: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace ReOrderDetails {
                export const AttributeId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const DetailsId: string;
                export const FixedCode: string;
                export const Maximum0: string;
                export const Maximum1: string;
                export const Maximum2: string;
                export const Minimum0: string;
                export const Minimum1: string;
                export const Minimum2: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const TransId: string;
                export const UOM: string;
                export const Validate: string;
            }

            namespace Rejection {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const AutoPosting: string;
                export const BillDate: string;
                export const BillNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RejectionType: string;
                export const Remark: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace RejectionBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace RejectionItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SKUGeneration {
                export const AttributeIdSelected: string;
                export const AutoPosting: string;
                export const CompanyId: string;
                export const Details: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const GenerateSKU: string;
                export const IsPosted: string;
                export const LineNoSelected: string;
                export const Markup: string;
                export const NoofSKU: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const PrintingDetails: string;
                export const ProductIdSelected: string;
                export const SKUSelected: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace SKUItemBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefStockBomId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SBomRate: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransactionId: string;
                export const Weight: string;
            }

            namespace SKUItems {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StonePieces: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransactionId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
                export const __id: string;
            }

            namespace SKULabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransLbrId: string;
                export const TransactionId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SKURepricing {
                export const AttributeIdSelected: string;
                export const AutoPosting: string;
                export const CompanyId: string;
                export const Details: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const GenerateSKU: string;
                export const IsPosted: string;
                export const Items: string;
                export const LineNoSelected: string;
                export const Markup: string;
                export const NoofSKU: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductIdSelected: string;
                export const SKUSelected: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace SKURepricingBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefStockBomId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SBomRate: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransactionId: string;
                export const Weight: string;
            }

            namespace SKURepricingDetails {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const Hsn: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const NewSKU: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StonePieces: string;
                export const StoneSizeId: string;
                export const Stoneweight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SKURepricingDetailsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefStockBomId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SBomRate: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace SKURepricingItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransactionId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
                export const __id: string;
            }

            namespace SKURepricingLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransLbrId: string;
                export const TransactionId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SKUSplitting {
                export const AutoPosting: string;
                export const CommonItemDetails: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Details: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const IsPosted: string;
                export const PostingDate: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace SKUSplittingBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefStockBomId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransactionId: string;
                export const Weight: string;
            }

            namespace SKUSplittingDetails {
                export const AckStatus: string;
                export const AllotedNetWeight: string;
                export const AllotedPieces: string;
                export const AllotedWeight: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BalanceNetWeight: string;
                export const BalancePieces: string;
                export const BalanceWeight: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const GenerateSKU: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const ItemsDetails: string;
                export const KaratId: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const NewGrossWeight: string;
                export const NewNetWeight: string;
                export const NewProductCode: string;
                export const NewProductId: string;
                export const NewSKU: string;
                export const NewStoneWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefTransTypeId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SKUSplittingItems {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const PurchaseCostMethodId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StonePieces: string;
                export const StoneRate: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransItemId: string;
                export const TransactionId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
                export const __id: string;
            }

            namespace SKUSplittingLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransLbrId: string;
                export const TransactionId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SKUStockItem {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const Hsn: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const ItemsDetails: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const NewSKU: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StonePieces: string;
                export const StoneSizeId: string;
                export const Stoneweight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SetItems {
                export const AttributeId: string;
                export const ItemId: string;
                export const Line_No: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const SKU: string;
                export const SetId: string;
                export const StockId: string;
            }

            namespace SetMaster {
                export const Id: string;
                export const ItemDetails: string;
                export const SKU: string;
            }

            namespace Sorting {
                export const AutoPosting: string;
                export const CategoryId: string;
                export const Clear: string;
                export const CompanyId: string;
                export const DetailItems: string;
                export const Details: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const GenerateLot: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const LotNo: string;
                export const NetWeight: string;
                export const NewPieces: string;
                export const NewProductId: string;
                export const NewWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductTypeId: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const SubCategoryId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace SortingDetails {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const HasBom: string;
                export const Hsn: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const ItemsDetails: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const NetWeight: string;
                export const NewPieces: string;
                export const NewProductId: string;
                export const NewSKU: string;
                export const NewWeight: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const SpecialRemark: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace SortingItems {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const Hsn: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const NetWeight: string;
                export const OtherRate: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const TransItemId: string;
                export const TransactionId: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace StockAllocatedBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransactionId: string;
                export const Weight: string;
            }

            namespace StockAllocatedItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TransactionId: string;
                export const UserDescription: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace StockAllocation {
                export const AutoPosting: string;
                export const CompanyId: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const Remark: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace StockAllocationItems {
                export const AckStatus: string;
                export const AllocatedItems: string;
                export const AllocatedPieces: string;
                export const AllocatedWeight: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserDescription: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace StockAllocationItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace StockEnquiry {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMCategoryName: string;
                export const BOMDetails: string;
                export const BOMGroupSieveName: string;
                export const BOMKaratName: string;
                export const BOMMetalColorName: string;
                export const BOMPureWeight: string;
                export const BOMPurity: string;
                export const BOMQualityName: string;
                export const BOMShapeName: string;
                export const BOMSieveName: string;
                export const BOMStoneColoreName: string;
                export const BOMStoneSizeName: string;
                export const BOMSubCategoryName: string;
                export const BagNo: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const BrandName: string;
                export const CalcOnId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionName: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const ExportPieces: string;
                export const FinancialYearId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const HistoryDetails: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const ImageName: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const KaratName: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const MetalName: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const POSCustomerId: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SKU: string;
                export const SetId: string;
                export const ShapeName: string;
                export const SieveName: string;
                export const StockAllocation: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StoneColoreName: string;
                export const StoneCuletCode: string;
                export const StoneCuletId: string;
                export const StoneCuletName: string;
                export const StoneCutCode: string;
                export const StoneCutId: string;
                export const StoneCutName: string;
                export const StoneDepth: string;
                export const StoneFluorescenceCode: string;
                export const StoneFluorescenceId: string;
                export const StoneFluorescenceName: string;
                export const StoneGirdleCode: string;
                export const StoneGirdleId: string;
                export const StoneGirdleName: string;
                export const StonePieces: string;
                export const StonePolishCode: string;
                export const StonePolishId: string;
                export const StonePolishName: string;
                export const StoneSizeName: string;
                export const StoneSymmetryCode: string;
                export const StoneSymmetryId: string;
                export const StoneSymmetryName: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryName: string;
                export const SuperTypeName: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }
        }

        namespace ItemFields {
            export const Attribute: string;
            export const AttributeId: string;
            export const BrandCode: string;
            export const BrandId: string;
            export const BrandName: string;
            export const CategoryCode: string;
            export const CategoryId: string;
            export const CategoryName: string;
            export const CollectionCode: string;
            export const CollectionId: string;
            export const CollectionName: string;
            export const GroupSieveCode: string;
            export const GroupSieveId: string;
            export const GroupSieveName: string;
            export const ItemType: string;
            export const ItemTypeId: string;
            export const KaratCode: string;
            export const KaratId: string;
            export const KaratName: string;
            export const MetalCode: string;
            export const MetalColorCode: string;
            export const MetalColorId: string;
            export const MetalColorName: string;
            export const MetalId: string;
            export const MetalName: string;
            export const Num1: string;
            export const Num2: string;
            export const Num3: string;
            export const ProductSizeCode: string;
            export const ProductSizeId: string;
            export const ProductSizeName: string;
            export const ProductTypeCode: string;
            export const ProductTypeId: string;
            export const ProductTypeName: string;
            export const QualityCode: string;
            export const QualityId: string;
            export const QualityName: string;
            export const SettingName: string;
            export const ShapeCode: string;
            export const ShapeId: string;
            export const ShapeName: string;
            export const SieveCode: string;
            export const SieveId: string;
            export const SieveName: string;
            export const StampCode: string;
            export const StampId: string;
            export const StampName: string;
            export const StoneColorCode: string;
            export const StoneColorId: string;
            export const StoneColoreName: string;
            export const StoneCuletCode: string;
            export const StoneCuletId: string;
            export const StoneCuletName: string;
            export const StoneCutCode: string;
            export const StoneCutId: string;
            export const StoneCutName: string;
            export const StoneDepth: string;
            export const StoneFluorescenceCode: string;
            export const StoneFluorescenceId: string;
            export const StoneFluorescenceName: string;
            export const StoneGirdleCode: string;
            export const StoneGirdleId: string;
            export const StoneGirdleName: string;
            export const StonePolishCode: string;
            export const StonePolishId: string;
            export const StonePolishName: string;
            export const StoneSizeCode: string;
            export const StoneSizeId: string;
            export const StoneSizeName: string;
            export const StoneSymmetryCode: string;
            export const StoneSymmetryId: string;
            export const StoneSymmetryName: string;
            export const StoneTable: string;
            export const String1: string;
            export const String2: string;
            export const String3: string;
            export const SubCategoryCode: string;
            export const SubCategoryId: string;
            export const SubCategoryName: string;
            export const SuperTypeCode: string;
            export const SuperTypeId: string;
            export const SuperTypeName: string;
        }

        namespace JobWork {

            namespace JobWork {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const MaterialDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace JobWorkBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace JobWorkItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemReturn: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const Status: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace JobWorkReturn {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderType: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxRegType: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace JobWorkReturnBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace JobWorkReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace JobWorkReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace JobWorkReturnTax {
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }
        }

        namespace Master {

            namespace Camlytics {
                export const ChannelId: string;
                export const CompanyId: string;
                export const Id: string;
                export const Url: string;
            }

            namespace CustomerCategory {
                export const Code: string;
                export const Id: string;
                export const Name: string;
                export const NextLevel: string;
                export const UpgradeValue: string;
            }

            namespace Designation {
                export const AdvanceAmount: string;
                export const DesignationId: string;
                export const DesignationName: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const LeaveDays: string;
                export const Level: string;
                export const Narration: string;
            }

            namespace EmployeeDetails {
                export const DepartmentId: string;
                export const DetailId: string;
                export const EmployeeId: string;
                export const EmployeeName: string;
            }

            namespace EmployeeMaster {
                export const Address: string;
                export const BankAccountNumber: string;
                export const BankIfsc: string;
                export const BankName: string;
                export const BloodGroup: string;
                export const BranchCode: string;
                export const BranchName: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const DailyWage: string;
                export const DepartmentId: string;
                export const Departments: string;
                export const DesignationId: string;
                export const DesignationName: string;
                export const Dob: string;
                export const Email: string;
                export const EmployeeCode: string;
                export const EmployeeId: string;
                export const EmployeeName: string;
                export const EmploymentType: string;
                export const EsiNumber: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const Gender: string;
                export const GrossSalary: string;
                export const IsDisabled: string;
                export const JoiningDate: string;
                export const LabourCardExpiryDate: string;
                export const LabourCardNumber: string;
                export const LeavePolicyId: string;
                export const ManagerId: string;
                export const MaritalStatus: string;
                export const MobileNumber: string;
                export const Narration: string;
                export const PanNumber: string;
                export const PassportExpiryDate: string;
                export const PassportNo: string;
                export const PfNumber: string;
                export const PhoneNumber: string;
                export const Qualification: string;
                export const ReportToId: string;
                export const SalaryPackageId: string;
                export const SalaryType: string;
                export const TerminationDate: string;
                export const VisaExpiryDate: string;
                export const VisaNumber: string;
            }

            namespace SalesPerson {
                export const Address: string;
                export const BankAccountNumber: string;
                export const BankIfsc: string;
                export const BankName: string;
                export const BloodGroup: string;
                export const BranchCode: string;
                export const BranchName: string;
                export const CompanyId: string;
                export const DailyWage: string;
                export const DefaultPackageId: string;
                export const DepartmentId: string;
                export const DesignationId: string;
                export const Details: string;
                export const Dob: string;
                export const Email: string;
                export const EmployeeCode: string;
                export const EmployeeId: string;
                export const EmployeeName: string;
                export const EmploymentType: string;
                export const EsiNumber: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const Gender: string;
                export const IsDisabled: string;
                export const JoiningDate: string;
                export const LabourCardExpiryDate: string;
                export const LabourCardNumber: string;
                export const ManagerId: string;
                export const MaritalStatus: string;
                export const MobileNumber: string;
                export const Narration: string;
                export const PanNumber: string;
                export const PassportExpiryDate: string;
                export const PassportNo: string;
                export const PfNumber: string;
                export const PhoneNumber: string;
                export const Qualification: string;
                export const ReportToId: string;
                export const SalaryType: string;
                export const TerminationDate: string;
                export const VisaExpiryDate: string;
                export const VisaNumber: string;
            }

            namespace TargetDistribution {
                export const April: string;
                export const August: string;
                export const Code: string;
                export const December: string;
                export const February: string;
                export const January: string;
                export const July: string;
                export const June: string;
                export const March: string;
                export const May: string;
                export const November: string;
                export const October: string;
                export const September: string;
                export const TargetDistributionId: string;
            }
        }

        namespace OMS {

            namespace AccountGroup {
                export const AccountGroupId: string;
                export const AccountGroupName: string;
                export const AffectGrossProfit: string;
                export const Balance: string;
                export const Flow: string;
                export const GroupUnder: string;
                export const IsDefault: string;
                export const Narration: string;
                export const Nature: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const Quarter1: string;
                export const Quarter2: string;
                export const Quarter3: string;
                export const Quarter4: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
            }

            namespace AccountLedger {
                export const AccountGroupId: string;
                export const AccountGroupName: string;
                export const AccountNo: string;
                export const BillbyBill: string;
                export const DefaultTDSType: string;
                export const IFSCCode: string;
                export const IsDisabled: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const MICRCode: string;
                export const MailingName: string;
                export const Nature: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PartyCode: string;
                export const PartyType: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Swift: string;
                export const SysDate: string;
                export const TermId: string;
            }

            namespace AdditionalCharges {
                export const AdditionalChargeCode: string;
                export const AdditionalChargeId: string;
                export const AdditionalChargeName: string;
                export const ApplicableOn: string;
                export const ExcludeDiscount: string;
                export const IncludeTax: string;
                export const Narration: string;
                export const ProductCalculateOn: string;
                export const Rate: string;
                export const RateType: string;
                export const TransactionCalculateOn: string;
                export const Vouchers: string;
            }

            namespace AdditionalChargesVouchers {
                export const AdditionalChargeCode: string;
                export const AdditionalChargeId: string;
                export const AdditionalChargeName: string;
                export const ApplicableOn: string;
                export const DetailId: string;
                export const ProductCalculateOn: string;
                export const Rate: string;
                export const RateType: string;
                export const TransactionCalculateOn: string;
                export const VoucherTypeId: string;
            }

            namespace AddressMaster {
                export const Address1: string;
                export const Address2: string;
                export const AddressId: string;
                export const AddressType: string;
                export const City: string;
                export const CityName: string;
                export const Country: string;
                export const CountryName: string;
                export const Default: string;
                export const LedgerId: string;
                export const Pincode: string;
                export const State: string;
                export const StateName: string;
            }

            namespace AttributeMaster {
                export const AttributeCode: string;
                export const AttributeId: string;
                export const AttributeName: string;
                export const AttributeTypeId: string;
                export const FixedName: string;
                export const GroupSieveId: string;
                export const IsParent: string;
                export const MaxPurity: string;
                export const MinPurity: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PurchaseFormula: string;
                export const SPGravity: string;
                export const SalesFormula: string;
                export const StdPurity: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
            }

            namespace BrandMaster {
                export const AttributeTypeId: string;
                export const BrandCode: string;
                export const BrandId: string;
                export const BrandName: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
            }

            namespace CategoryMaster {
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const Image: string;
                export const IsDisabled: string;
                export const IsSizeApplicable: string;
                export const ItemTypeId: string;
            }

            namespace CheckList {
                export const CheckListId: string;
                export const CheckListName: string;
                export const CheckListType: string;
                export const CheckListTypeId: string;
            }

            namespace CitiesMaster {
                export const Id: string;
                export const Name: string;
                export const StateId: string;
            }

            namespace CollectionMaster {
                export const AttributeCode: string;
                export const AttributeId: string;
                export const AttributeName: string;
                export const AttributeTypeId: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
            }

            namespace ColorQualityMapping {
                export const Code: string;
                export const MappingId: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
            }

            namespace Company {
                export const Address: string;
                export const Address2: string;
                export const CST: string;
                export const City: string;
                export const CityName: string;
                export const CodeandName: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const Country: string;
                export const CountryName: string;
                export const CurrencyId: string;
                export const CurrentDate: string;
                export const DiscountingPolicyId: string;
                export const EmailId: string;
                export const IsDefault: string;
                export const IsDisabled: string;
                export const IsLabourList: string;
                export const IsPriceList: string;
                export const LedgerId: string;
                export const Logo: string;
                export const MailingName: string;
                export const MarkUpPolicyId: string;
                export const Mobile: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PAN: string;
                export const PLMarkup: string;
                export const PLabourListId: string;
                export const PMarkup: string;
                export const PPriceListId: string;
                export const ParentCompany: string;
                export const Phone: string;
                export const Pin: string;
                export const SLMarkup: string;
                export const SLabourListId: string;
                export const SMarkup: string;
                export const SPriceListId: string;
                export const State: string;
                export const StateName: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
                export const TIN: string;
                export const TaxGroupId: string;
                export const TypeOfCompany: string;
                export const Web: string;
            }

            namespace ContactDetails {
                export const AddtoZiFlow: string;
                export const Comment: string;
                export const ContactId: string;
                export const Decision: string;
                export const Designation: string;
                export const EmailId: string;
                export const FirstName: string;
                export const IsDefault: string;
                export const LastName: string;
                export const LedgerId: string;
                export const Manage: string;
                export const MobileNo: string;
                export const Phone: string;
                export const Share: string;
            }

            namespace CountriesMaster {
                export const Id: string;
                export const Name: string;
                export const Nationality: string;
                export const Phonecode: string;
                export const ShortName: string;
            }

            namespace CurrencyMaster {
                export const CurrencyId: string;
                export const CurrencyName: string;
                export const CurrencySymbol: string;
                export const Extra1: string;
                export const Extra2: string;
                export const ExtraDate: string;
                export const IsDefault: string;
                export const Narration: string;
                export const NoOfDecimalPlaces: string;
                export const SubunitName: string;
            }

            namespace Customer {
                export const APIEndpoint: string;
                export const APIToken: string;
                export const AccountGroupId: string;
                export const AddressDetails: string;
                export const AutoCreateVoucherUsingAPI: string;
                export const AutoPosting: string;
                export const BillbyBill: string;
                export const Coef: string;
                export const ContactDetails: string;
                export const CostPricegroupId: string;
                export const CurrencyId: string;
                export const CustomerPrefix: string;
                export const Email: string;
                export const GstVat: string;
                export const IsDisabled: string;
                export const LbrAddDisc: string;
                export const LbrAddMkp: string;
                export const LbrFlag: string;
                export const LbrFromDate: string;
                export const LbrPricegroupId: string;
                export const LbrToDate: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const MailingName: string;
                export const MarkUpPolicyId: string;
                export const Nature: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyType: string;
                export const StnAddDisc: string;
                export const StnAddMkp: string;
                export const StnFlag: string;
                export const StnFromDate: string;
                export const StnToDate: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxRegType: string;
                export const TermId: string;
                export const Token: string;
            }

            namespace CustomerOrder {
                export const AccountGroupId: string;
                export const BillbyBill: string;
                export const CostPricegroupId: string;
                export const DefaultTdsType: string;
                export const GstVat: string;
                export const IsDisabled: string;
                export const LbrAddDisc: string;
                export const LbrAddMkp: string;
                export const LbrFlag: string;
                export const LbrFromDate: string;
                export const LbrPricegroupId: string;
                export const LbrToDate: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const MailingName: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyType: string;
                export const PartyTypeId: string;
                export const StnAddDisc: string;
                export const StnAddMkp: string;
                export const StnFlag: string;
                export const StnFromDate: string;
                export const StnToDate: string;
                export const Tan: string;
                export const TaxRegType: string;
                export const Tds: string;
                export const TermId: string;
            }

            namespace Denomination {
                export const Code: string;
                export const DenominationId: string;
                export const Name: string;
            }

            namespace DepartmentMaster {
                export const CompanyId: string;
                export const DepartmentTypeId: string;
                export const DeptCode: string;
                export const DeptId: string;
                export const DeptName: string;
                export const ItemTypeId: string;
                export const Narration: string;
                export const ParentDeptId: string;
                export const ProcessDetails: string;
                export const UserId: string;
            }

            namespace DepartmentProcessDetails {
                export const DepartmentId: string;
                export const DeptName: string;
                export const DetailId: string;
                export const ProcessCode: string;
                export const ProcessId: string;
                export const ProcessName: string;
            }

            namespace Design {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BrandId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const CreationDate: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DesignName: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const GroupSieveName: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const Image4: string;
                export const Image5: string;
                export const Image6: string;
                export const Image7: string;
                export const Image8: string;
                export const ImageName: string;
                export const IsConfigurable: string;
                export const IsDisabled: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const Iteration: string;
                export const KaratId: string;
                export const KaratName: string;
                export const MappingCode: string;
                export const MappingId: string;
                export const MaxPurity: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const MinPurity: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductSizeId: string;
                export const ProductSizeName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Remarks: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StdPurity: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const Video1: string;
                export const Video2: string;
                export const Volume: string;
                export const Volume1: string;
                export const Volume2: string;
                export const Weight: string;
                export const ZProofId: string;
            }

            namespace DesignBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMDesignId: string;
                export const BomId: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CenterStone: string;
                export const CostMethodId: string;
                export const DesignId: string;
                export const GroupSieveId: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const StdPurity: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const Sys_Date: string;
                export const Weight: string;
            }

            namespace DiscountingPolicy {
                export const Code: string;
                export const CompanyId: string;
                export const Details: string;
                export const DiscountId: string;
                export const Name: string;
            }

            namespace DiscountingPolicyDetails {
                export const CategoryCode: string;
                export const CategoryId: string;
                export const DiscountDetailId: string;
                export const DiscountId: string;
                export const DiscountType: string;
                export const MaxDiscountPercent: string;
                export const Priority: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
            }

            namespace DocumentFormatMaster {
                export const BranchWise: string;
                export const CounterWise: string;
                export const Format: string;
                export const IncrementBy: string;
                export const LastNumber: string;
                export const Lock: string;
                export const MaterialType: string;
                export const Noofzeroes: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PrefillwithZero: string;
                export const Prefix: string;
                export const PrefixDate: string;
                export const ResetMonthly: string;
                export const ResetYearly: string;
                export const Separator: string;
                export const StartIndex: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Suffix: string;
                export const SuffixprefixId: string;
                export const Sys_Date: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
            }

            namespace ExchangeRate {
                export const CurrencyId: string;
                export const CurrencyName: string;
                export const ExchRate: string;
                export const ExchTypeId: string;
                export const ExchangeRateId: string;
                export const Extra1: string;
                export const Extra2: string;
                export const FixedName: string;
                export const FromDate: string;
                export const Narration: string;
                export const ToDate: string;
            }

            namespace FinancialYear {
                export const FinancialYearCode: string;
                export const FinancialYearId: string;
                export const FromDate: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const ToDate: string;
            }

            namespace FixedCode {
                export const FixedCode: string;
                export const FixedId: string;
                export const FixedName: string;
                export const FixedType: string;
                export const MasterName: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
            }

            namespace FixedRateMaster {
                export const Attribute: string;
                export const AttributeId: string;
                export const CategoryCode: string;
                export const CategoryName: string;
                export const CostId: string;
                export const FromDate: string;
                export const FromWt: string;
                export const ItemTypeId: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductTypeCode: string;
                export const ProductTypeName: string;
                export const PurchaseRate: string;
                export const SalesRate: string;
                export const SubCategoryCode: string;
                export const SubCategoryName: string;
                export const ToDate: string;
                export const ToWt: string;
            }

            namespace FormatMaster {
                export const BranchWise: string;
                export const CounterWise: string;
                export const DesignPrefix: string;
                export const DesignPrefixEditor: string;
                export const DesignSuffix: string;
                export const DesignSuffixEditor: string;
                export const Format: string;
                export const FormatId: string;
                export const FormatType: string;
                export const IncrementBy: string;
                export const LastMonth: string;
                export const LastNumber: string;
                export const LastYear: string;
                export const Lock: string;
                export const Noofzeroes: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PrefillwithZero: string;
                export const Prefix: string;
                export const PrefixCode: string;
                export const PrefixDate: string;
                export const ResetMonthly: string;
                export const ResetYearly: string;
                export const Separator: string;
                export const StartIndex: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Suffix: string;
                export const Sys_Date: string;
            }

            namespace GiftVoucherDetails {
                export const GvDetailId: string;
                export const GvId: string;
                export const ProductApplicable: string;
            }

            namespace GiftVoucherMaster {
                export const Active: string;
                export const Code: string;
                export const FixedName: string;
                export const GvId: string;
                export const GvType: string;
                export const MinInvoiceValue: string;
                export const PartialRedeem: string;
                export const ProdApp: string;
                export const ProductApplicable: string;
                export const Validity: string;
                export const Value: string;
            }

            namespace HSN {
                export const Code: string;
                export const Description: string;
                export const Id: string;
                export const Name: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const RateApplied: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxCode: string;
            }

            namespace HSNTaxDetails {
                export const Code: string;
                export const DetailsId: string;
                export const GroupId: string;
                export const InputRCMLedgerId: string;
                export const IsInterState: string;
                export const LedgerId: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TaxRate: string;
            }

            namespace HsnTaxMaster {
                export const Cess1Id: string;
                export const Cess1LedgerId: string;
                export const Cess2Id: string;
                export const Cess2LedgerId: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const Code: string;
                export const Description: string;
                export const Details: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const Tax1Id: string;
                export const Tax1LedgerId: string;
                export const Tax2Id: string;
                export const Tax2LedgerId: string;
                export const TaxGroup: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const Type: string;
            }

            namespace KaratRate {
                export const AttributeId: string;
                export const CostId: string;
                export const FromDate: string;
                export const FromWt: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurStdRate: string;
                export const SaleStdRate: string;
                export const ToDate: string;
                export const ToWt: string;
            }

            namespace LabourMaster {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const BrandName: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const CollectionName: string;
                export const FixedName: string;
                export const FromParts: string;
                export const FromWt: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const LabourId: string;
                export const LossPer: string;
                export const MaxLabour: string;
                export const MaxOrMin: string;
                export const MinLabour: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProcessTypeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurStdLabour: string;
                export const QualityId: string;
                export const RateType: string;
                export const SaleStdLabour: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const SuperTypeName: string;
                export const Sys_Date: string;
                export const ToParts: string;
                export const ToWt: string;
            }

            namespace LabourPriceList {
                export const FixedName: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PriceCode: string;
                export const PriceListDetails: string;
                export const PriceName: string;
                export const PriceType: string;
                export const PricelistId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
            }

            namespace LabourPriceListDetails {
                export const Amount: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const FromDate: string;
                export const FromWt: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const MarkUp: string;
                export const MinLabour: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PriceListDetailsId: string;
                export const PriceListId: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProcessTypeId: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurStdRate: string;
                export const QualityId: string;
                export const SaleStdRate: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const Sys_Date: string;
                export const ToDate: string;
                export const ToWt: string;
            }

            namespace LedgerPosting {
                export const AccountGroupId: string;
                export const Amount1: string;
                export const Amount2: string;
                export const Balance: string;
                export const Balance1: string;
                export const BaseItemTypeId: string;
                export const CBalance: string;
                export const CCCredit: string;
                export const CCDebit: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CompanyId: string;
                export const Credit: string;
                export const CurrencyId: string;
                export const DBalance: string;
                export const Debit: string;
                export const DetailsId: string;
                export const DrCr: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const GroupName: string;
                export const InvoiceNo: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const LedgerPostingId: string;
                export const MCredit: string;
                export const MDebit: string;
                export const Nature: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OpBalance: string;
                export const OpeningBalance: string;
                export const POSCustomerId: string;
                export const PartyCode: string;
                export const RefTransId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
                export const TransDate: string;
                export const TransId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace MarkUpPolicy {
                export const Charges: string;
                export const MarkUpPolicyCode: string;
                export const MarkUpPolicyId: string;
                export const MarkUpPolicyName: string;
            }

            namespace MarkupCharges {
                export const BrandId: string;
                export const CategoryId: string;
                export const CollectionId: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const MarkUp: string;
                export const MarkUpPolicyId: string;
                export const MarkUpRateType: string;
                export const MarkUpType: string;
                export const MarkupChargesId: string;
                export const MetalColorId: string;
                export const ProcessId: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const QualityId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
            }

            namespace MetalRateMaster {
                export const CompanyId: string;
                export const CurrencyId: string;
                export const DailyRateId: string;
                export const FixedName: string;
                export const FromDate: string;
                export const IsSysParam: string;
                export const LossPercent: string;
                export const MetalTypeId: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const ProductTypeName: string;
                export const Rate: string;
                export const RateOn: string;
                export const RateTypeId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
                export const ToDate: string;
            }

            namespace MoldMaster {
                export const Code: string;
                export const MoldId: string;
                export const Name: string;
                export const RackNo: string;
            }

            namespace OrderStatus {
                export const AttributeCode: string;
                export const AttributeId: string;
                export const AttributeName: string;
                export const AttributeTypeId: string;
            }

            namespace Others {
                export const Attribute: string;
                export const AttributeId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const HSN: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const Rate: string;
                export const Remarks: string;
                export const ServerDate: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const Sys_Date: string;
                export const TaxCode: string;
            }

            namespace PaymentMode {
                export const AllowSelection: string;
                export const Code: string;
                export const CommissionAccount: string;
                export const CommissionPercent: string;
                export const FixedName: string;
                export const IsDisabled: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const ModeId: string;
                export const Name: string;
                export const Num1: string;
                export const Num2: string;
                export const OnlyForPos: string;
                export const String1: string;
                export const String2: string;
                export const SysDate: string;
                export const Type: string;
            }

            namespace PosCustomerMaster {
                export const Address: string;
                export const AllowCredit: string;
                export const Anniversary: string;
                export const BirthDate: string;
                export const CityId: string;
                export const CityName: string;
                export const CountryId: string;
                export const CountryName: string;
                export const CreditLimit: string;
                export const Email: string;
                export const FirstName: string;
                export const Gender: string;
                export const GroupId: string;
                export const HomeBranchId: string;
                export const ImagePath: string;
                export const IsDisabled: string;
                export const LastName: string;
                export const MaritialStatus: string;
                export const Mobile: string;
                export const Mobile2: string;
                export const NationalityId: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const ParentId: string;
                export const Pin: string;
                export const PosCustomerCode: string;
                export const Prefix: string;
                export const RefId: string;
                export const ReligonId: string;
                export const StateId: string;
                export const StateName: string;
                export const TaxId: string;
                export const TelO: string;
                export const TelR: string;
            }

            namespace PriceList {
                export const FixedName: string;
                export const ItemDetails: string;
                export const LaborDetails: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PriceCode: string;
                export const PriceName: string;
                export const PriceType: string;
                export const PricelistId: string;
                export const RateDetails: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
            }

            namespace PriceListDetails {
                export const Amount: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const FromDate: string;
                export const FromWt: string;
                export const ItemListId: string;
                export const ItemTypeId: string;
                export const MarkUp: string;
                export const PriceListDetailsId: string;
                export const PriceListId: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurStdRate: string;
                export const QualityId: string;
                export const SaleStdRate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const ToDate: string;
                export const ToWt: string;
            }

            namespace ProcessApplicableDetails {
                export const CalcOn: string;
                export const CalcOnId: string;
                export const ProcessId: string;
            }

            namespace ProcessInspection {
                export const Id: string;
                export const IsNumeric: string;
                export const Max: string;
                export const Min: string;
                export const Parameter: string;
                export const ProcessId: string;
                export const TemplateId: string;
                export const Value: string;
            }

            namespace ProcessMaster {
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const FixedName: string;
                export const InspectionDetails: string;
                export const IsDisabled: string;
                export const IsSetting: string;
                export const ItemTypeId: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const ProcessApplicableDetails: string;
                export const ProcessCode: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProcessTypeId: string;
                export const QualityInspectionId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysParam: string;
                export const Sys_Date: string;
            }

            namespace ProductBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomId: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CenterStone: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const StdPurity: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const Sys_Date: string;
                export const TaxCode: string;
                export const TextureId: string;
                export const Weight: string;
            }

            namespace ProductImages {
                export const Image: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const ProductId: string;
                export const ProductImageId: string;
            }

            namespace ProductInspection {
                export const Id: string;
                export const IsNumeric: string;
                export const Max: string;
                export const Min: string;
                export const Parameter: string;
                export const ProcessId: string;
                export const ProductId: string;
                export const TemplateId: string;
                export const Value: string;
            }

            namespace ProductMaster {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BrandId: string;
                export const BrandName: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const CollectionName: string;
                export const CostId: string;
                export const CostMethodId: string;
                export const CreationDate: string;
                export const CreationVoucherId: string;
                export const DesignId: string;
                export const DiamondDiscountPercent: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const ForExchange: string;
                export const GroupSieveName: string;
                export const HSN: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const Image4: string;
                export const Image5: string;
                export const Image6: string;
                export const Image7: string;
                export const Image8: string;
                export const ImageName: string;
                export const InspectionDetails: string;
                export const IsConfigurable: string;
                export const IsCustomerItem: string;
                export const IsDefaultSKU: string;
                export const IsDisabled: string;
                export const IsFeatured: string;
                export const IsNew: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const LaborDetails: string;
                export const LaborMarkup: string;
                export const MFAmount: string;
                export const MappingId: string;
                export const MaxPurity: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const MetalName: string;
                export const MinPurity: string;
                export const MoldsDetails: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const ParentDesign: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const PriceMarkup: string;
                export const ProductCode: string;
                export const ProductEnquiryType: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductPartyDetails: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PurchaseRate: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityInspectionId: string;
                export const QualityName: string;
                export const Rate: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const SalesPrice: string;
                export const SalesRate: string;
                export const SequenceDetails: string;
                export const ServerDate: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StdPurity: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const SuperTypeName: string;
                export const TaxCode: string;
                export const UnitLabour: string;
                export const Variance: string;
                export const Video1: string;
                export const Video2: string;
                export const Volume: string;
                export const Volume1: string;
                export const Volume2: string;
                export const Weight: string;
            }

            namespace ProductMasterLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ProductMolds {
                export const Code: string;
                export const MoldId: string;
                export const Pcs: string;
                export const ProductId: string;
                export const ProductMoldId: string;
                export const RackNo: string;
            }

            namespace ProductPartyDetails {
                export const DetailId: string;
                export const LedgerName: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const ProductId: string;
                export const SKU: string;
            }

            namespace ProductSequence {
                export const Complexity: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const Duration: string;
                export const Id: string;
                export const MaxLoss: string;
                export const Priority: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductId: string;
                export const StdLoss: string;
            }

            namespace ProductSizeMaster {
                export const CM: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const INCH: string;
                export const MM: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const SizeType: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
            }

            namespace ProductType {
                export const HSN: string;
                export const ItemId: string;
                export const ItemTypeId: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const Purity: string;
                export const SalesCostMethodId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
                export const TaxCode: string;
            }

            namespace PromotionDetails {
                export const ApplicableOn: string;
                export const CodeRequired: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const DiscountAmount: string;
                export const DiscountOn: string;
                export const DiscountPercentage: string;
                export const FreeProductId: string;
                export const FromDate: string;
                export const IsApproved: string;
                export const IsDisabled: string;
                export const MaximumRedeemCount: string;
                export const MinimumSalesAmount: string;
                export const PrdTypeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PromoCode: string;
                export const PromoId: string;
                export const PromoName: string;
                export const PromotionDetailsId: string;
                export const ToDate: string;
            }

            namespace PromotionMaster {
                export const ApplicableOn: string;
                export const ApprovedBy: string;
                export const CodeRequired: string;
                export const DiscountAmount: string;
                export const DiscountOn: string;
                export const DiscountPercentage: string;
                export const FreeProductId: string;
                export const FromDate: string;
                export const IsApproved: string;
                export const IsDisabled: string;
                export const MaximumRedeemCount: string;
                export const MinimumSalesAmount: string;
                export const PromoCode: string;
                export const PromoId: string;
                export const PromoName: string;
                export const PromoType: string;
                export const PromotionDetails: string;
                export const ToDate: string;
                export const VoucherCode: string;
            }

            namespace RateMaster {
                export const Attribute: string;
                export const AttributeId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CostId: string;
                export const FromDate: string;
                export const FromWt: string;
                export const ItemTypeId: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurStdRate: string;
                export const QualityId: string;
                export const QualityName: string;
                export const SaleStdRate: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const ToDate: string;
                export const ToWt: string;
            }

            namespace RawMaterialMaster {
                export const Attribute: string;
                export const AttributeId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CostId: string;
                export const CostMethodId: string;
                export const CreationDate: string;
                export const CreationVoucherId: string;
                export const ForExchange: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const IsConfigurable: string;
                export const IsCustomerItem: string;
                export const IsDefaultSKU: string;
                export const IsDisabled: string;
                export const IsFeatured: string;
                export const IsNew: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const ParentDesign: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PurchaseRate: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const SalesPrice: string;
                export const SalesRate: string;
                export const ServerDate: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const Sys_Date: string;
                export const TaxCode: string;
                export const Variance: string;
                export const Weight: string;
            }

            namespace ReasonStatus {
                export const IsDefault: string;
                export const Notification: string;
                export const NotifyCustomer: string;
                export const ReasonStatusId: string;
                export const Type: string;
                export const TypeDescription: string;
                export const TypeId: string;
                export const TypeName: string;
                export const UpdateECommerce: string;
            }

            namespace RewardsDetails {
                export const CategoryId: string;
                export const CategoryName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchasePoints: string;
                export const PurchaseValue: string;
                export const RDetailsId: string;
                export const RMasterId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
            }

            namespace RewardsMaster {
                export const CustomerCategoryId: string;
                export const EmailPoints: string;
                export const ExchangeRate: string;
                export const MobilePoints: string;
                export const ProductWise: string;
                export const PurchaseValue: string;
                export const RMasterId: string;
                export const ReferencePoints: string;
                export const RewardCode: string;
                export const RewardsDetails: string;
            }

            namespace Role {
                export const ItemDiscount: string;
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace ServicesMaster {
                export const CategoryId: string;
                export const DefaultTdsType: string;
                export const ServiceCode: string;
                export const ServiceId: string;
                export const ServiceName: string;
                export const TaxCode: string;
            }

            namespace Settings {
                export const Description: string;
                export const Id: string;
                export const Name: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
                export const Type: string;
                export const Value: string;
            }

            namespace SieveSizeMapping {
                export const Depth: string;
                export const FromWeight: string;
                export const Id: string;
                export const IsParent: string;
                export const Length: string;
                export const Parent: string;
                export const ParentId: string;
                export const ProductTypeId: string;
                export const Shape: string;
                export const ShapeId: string;
                export const Sieve: string;
                export const SieveId: string;
                export const Size: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const ToWeight: string;
                export const Width: string;
            }

            namespace StatesMaster {
                export const CountryId: string;
                export const Id: string;
                export const StateName: string;
            }

            namespace SubCategoryDetails {
                export const CategoryId: string;
                export const DetailId: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
            }

            namespace SubCategoryMaster {
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CostMethodId: string;
                export const Details: string;
                export const FixedName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const PointerWeight: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
            }

            namespace TargetMaster {
                export const Amount: string;
                export const AprilAchieved: string;
                export const AprilTarget: string;
                export const AugustAchieved: string;
                export const AugustTarget: string;
                export const BaseItemTypeId: string;
                export const DecemberAchieved: string;
                export const DecemberTarget: string;
                export const EmployeeId: string;
                export const EmployeeName: string;
                export const FebruaryAchieved: string;
                export const FebruaryTarget: string;
                export const FinancialYearId: string;
                export const JanuaryAchieved: string;
                export const JanuaryTarget: string;
                export const JulyAchieved: string;
                export const JulyTarget: string;
                export const JuneAchieved: string;
                export const JuneTarget: string;
                export const MarchAchieved: string;
                export const MarchTarget: string;
                export const MayAchieved: string;
                export const MayTarget: string;
                export const NovemberAchieved: string;
                export const NovemberTarget: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OctoberAchieved: string;
                export const OctoberTarget: string;
                export const ProductTypeName: string;
                export const Quantity: string;
                export const SeptemberAchieved: string;
                export const SeptemberTarget: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
                export const TargetDistributionId: string;
                export const TargetId: string;
                export const UserId: string;
            }

            namespace Tax {
                export const ApplicableOn: string;
                export const CalculatingMode: string;
                export const CumulativeTrans: string;
                export const FixedName: string;
                export const GroupId: string;
                export const HasThreshold: string;
                export const InputRCMLedgerId: string;
                export const IsDisabled: string;
                export const ItemDetails: string;
                export const LedgerId: string;
                export const Narration: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductType: string;
                export const Rate: string;
                export const SingleTrans: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TaxType: string;
                export const ThresholdValue: string;
            }

            namespace TaxDetails {
                export const GroupId: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const SelectedtaxId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Sys_Date: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TaxdetailsId: string;
            }

            namespace TaxItemDetails {
                export const BaseItemTypeId: string;
                export const GroupId: string;
                export const TaxId: string;
                export const TaxItemDetailsId: string;
            }

            namespace TaxRateHistory {
                export const Date: string;
                export const Rate: string;
                export const TaxId: string;
            }

            namespace ToDoMaster {
                export const Completed: string;
                export const Description: string;
                export const EndDate: string;
                export const FixedName: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const StartDate: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaskTypeId: string;
                export const ToDoId: string;
                export const UserId: string;
                export const Username: string;
            }

            namespace User {
                export const AuthPassword: string;
                export const Branch: string;
                export const CatalogueAccessPassword: string;
                export const CompanyId: string;
                export const Department: string;
                export const DisplayName: string;
                export const EditPassword: string;
                export const Email: string;
                export const FinYear: string;
                export const HasAuth: string;
                export const HasCatalogueAccess: string;
                export const HasEdit: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const ItemDiscount: string;
                export const LastDirectoryUpdate: string;
                export const PartyId: string;
                export const Password: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const Source: string;
                export const Type: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
            }

            namespace UserDetails {
                export const CompanyId: string;
                export const DepartmentId: string;
                export const RackId: string;
                export const UserId: string;
                export const UserdetailsId: string;
                export const Username: string;
            }

            namespace Vendor {
                export const APIEndpoint: string;
                export const APIToken: string;
                export const AccountGroupId: string;
                export const AddressDetails: string;
                export const AutoCreateVoucherUsingAPI: string;
                export const AutoPosting: string;
                export const BillbyBill: string;
                export const ContactDetails: string;
                export const CostPricegroupId: string;
                export const CurrencyId: string;
                export const GstVat: string;
                export const IsDisabled: string;
                export const LbrAddDisc: string;
                export const LbrAddMkp: string;
                export const LbrFlag: string;
                export const LbrFromDate: string;
                export const LbrPricegroupId: string;
                export const LbrToDate: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const MailingName: string;
                export const Nature: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyType: string;
                export const StnAddDisc: string;
                export const StnAddMkp: string;
                export const StnFlag: string;
                export const StnFromDate: string;
                export const StnToDate: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxRegType: string;
                export const TermId: string;
                export const Token: string;
            }

            namespace VoucherMaster {
                export const AllowBackDatedEntry: string;
                export const AutoPosting: string;
                export const BranchWise: string;
                export const CounterWise: string;
                export const Declaration: string;
                export const DefaultJewelleryDepartment: string;
                export const DefaultMetalDepartment: string;
                export const DefaultOthersDepartment: string;
                export const DefaultStoneDepartment: string;
                export const Details: string;
                export const Format: string;
                export const Heading1: string;
                export const Heading2: string;
                export const Heading3: string;
                export const Heading4: string;
                export const IncrementBy: string;
                export const IsDefault: string;
                export const IsDisabled: string;
                export const IsTaxApplicable: string;
                export const LastNumber: string;
                export const LedgerId: string;
                export const Lock: string;
                export const MasterId: string;
                export const MaterialType: string;
                export const MenuId: string;
                export const MethodOfVoucherNumbering: string;
                export const Narration: string;
                export const Noofzeroes: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const PrefillwithZero: string;
                export const Prefix: string;
                export const PrefixDate: string;
                export const ResetMonthly: string;
                export const ResetYearly: string;
                export const Separator: string;
                export const StockUpdateMode: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const Suffix: string;
                export const Sys_Date: string;
                export const Terms: string;
                export const TypeOfVoucher: string;
                export const VoucherCode: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
            }

            namespace VoucherTaxDetails {
                export const DetailsId: string;
                export const GroupId: string;
                export const IsInterState: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const VoucherTypeId: string;
            }
        }

        namespace OpeningStock {

            namespace OpeningStock {
                export const AdditionalCharges: string;
                export const AutoPosting: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GSTState: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const Shrt: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace OpeningStockItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const ParentDesign: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace OpeningStockItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace OpeningStockLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }
        }

        namespace ProductDevelopment {

            namespace CustomerRequirement {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace CustomerRequirementBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace CustomerRequirementItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const Budget: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CenterStone: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const DualToneKarat: string;
                export const DualToneKaratId: string;
                export const DualToneMetalColorId: string;
                export const DualToneMetalId: string;
                export const DualTonePurity: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const Image4: string;
                export const Image5: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const Iteration: string;
                export const KaratId: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MappingId: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const MetalName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StatusId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneCategoryId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StoneItems: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSubCategoryId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const ToneType: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TripleToneKarat: string;
                export const TripleToneKaratId: string;
                export const TripleToneMetalColorId: string;
                export const TripleToneMetalId: string;
                export const TripleTonePurity: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const UserId: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace CustomerRequirementStoneItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDetailId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace DesignRequest {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const Code: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerPrefix: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DesignName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsSmartStone: string;
                export const IsSubmitted: string;
                export const ItemTypeId: string;
                export const Iteration: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MappingId: string;
                export const MetalAmount: string;
                export const MetalColorCode: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductSizeName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
                export const ZProofId: string;
            }

            namespace DesignRequestBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace PDInterface {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CcGrossAmount: string;
                export const CcNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const CustomerRequirements: string;
                export const Designing: string;
                export const Discount: string;
                export const ECommOrderId: string;
                export const ECommOrderNo: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const Quotations: string;
                export const ReasonId: string;
                export const ReceiptAmount: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const SpecSheets: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace PDQuotation {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsApproved: string;
                export const IsSubmitted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const MarkUpPolicyId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PriceListId: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace PDQuotationAdditionalCharges {
                export const AdditionalChargeCode: string;
                export const AdditionalChargeId: string;
                export const AdditionalChargeName: string;
                export const Amount: string;
                export const ApplicableOn: string;
                export const Chargeable: string;
                export const ProductCalculateOn: string;
                export const Rate: string;
                export const RateType: string;
                export const TransChargesId: string;
                export const TransItemId: string;
            }

            namespace PDQuotationBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Volume: string;
                export const Weight: string;
            }

            namespace PDQuotationItems {
                export const AckStatus: string;
                export const AdditionalAmount: string;
                export const AdditionalCharges: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DesignName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const Iteration: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorCode: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StatusId: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const Video1: string;
                export const Video2: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace PDQuotationLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace RequirementItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const Budget: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CenterStone: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const DualToneKarat: string;
                export const DualToneKaratId: string;
                export const DualToneMetalColorId: string;
                export const DualToneMetalId: string;
                export const DualTonePurity: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const Image4: string;
                export const Image5: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const Iteration: string;
                export const KaratId: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MappingId: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const MetalName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StatusId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneCategoryId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StoneItems: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSubCategoryId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const ToneType: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TripleToneKarat: string;
                export const TripleToneKaratId: string;
                export const TripleToneMetalColorId: string;
                export const TripleToneMetalId: string;
                export const TripleTonePurity: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const UserId: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace RequirementStoneItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDetailId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SpecSheet {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsApproved: string;
                export const IsSubmitted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const MarkUpPolicyId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PriceListId: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace SpecSheetBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const DesignId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Volume: string;
                export const Weight: string;
            }

            namespace SpecSheetItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DesignName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HUID: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const Image4: string;
                export const Image5: string;
                export const Image6: string;
                export const Image7: string;
                export const Image8: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const Iteration: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StatusId: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const Video1: string;
                export const Video2: string;
                export const Volume: string;
                export const Volume1: string;
                export const Volume2: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SpecSheetLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace StageMembers {
                export const Comment: string;
                export const Decision: string;
                export const Email: string;
                export const Manage: string;
                export const MemberName: string;
                export const MemeberId: string;
                export const Share: string;
                export const StageId: string;
            }

            namespace Stages {
                export const AllowPrivateComment: string;
                export const AllowPublicComment: string;
                export const Members: string;
                export const Narration: string;
                export const SendEmail: string;
                export const StageId: string;
                export const StageName: string;
            }
        }

        namespace Production {

            namespace Dismantling {
                export const AdditionalCharges: string;
                export const AutoPosting: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const Roundoff: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace DismantlingBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BagNo: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LotNo: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace DismantlingItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefDepartmentId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubBagNo: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace DismantlingReturn {
                export const AutoPosting: string;
                export const CompanyId: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const NetWeight: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace DismantlingReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LossPieces: string;
                export const LossWeight: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const ReceivedPieces: string;
                export const ReceivedWeight: string;
                export const RefDepartmentId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubBagNo: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace IssueMaterial {
                export const AutoPosting: string;
                export const BagNo: string;
                export const CompanyId: string;
                export const DepartmentId: string;
                export const Details: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const ImageName: string;
                export const IsPosted: string;
                export const Line_No: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace IssueMaterialDetails {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const CompanyId: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const FinancialYearId: string;
                export const ItemDetails: string;
                export const Line_No: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const RefTransDetailId: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const RequiredPieces: string;
                export const RequiredWeight: string;
                export const SKU: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const SubBagNo: string;
                export const TransDate: string;
                export const TransDetailId: string;
                export const TransId: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace IssueMaterialItems {
                export const Amount: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const CertificateNo: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const HSN: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const NetWeight: string;
                export const OldBagNo: string;
                export const OldLineNo: string;
                export const OrderPieces: string;
                export const OrderWeight: string;
                export const ParentAttributeId: string;
                export const ParentMetalId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SKU: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeCode: string;
                export const ShapeName: string;
                export const SieveCode: string;
                export const SieveName: string;
                export const StockAllocation: string;
                export const StockDepartmentId: string;
                export const StoneColorCode: string;
                export const StoneColoreName: string;
                export const StoneSizeCode: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const SubBagNo: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransDetailId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherNo: string;
                export const Weight: string;
            }

            namespace JWReceiptInspectionValues {
                export const ExpectedValue: string;
                export const InspectedValue: string;
                export const Max: string;
                export const Min: string;
                export const Parameter: string;
                export const Remark: string;
                export const Status: string;
                export const TransInspectionId: string;
                export const TransItemId: string;
            }

            namespace JobWorkIssue {
                export const CompanyId: string;
                export const DepartmentId: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const PartyId: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace JobWorkIssueBOM {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BomProductId: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const FromDeptId: string;
                export const FromWorkerId: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const ToDeptId: string;
                export const ToWorkerId: string;
                export const TransBomId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace JobWorkIssueItems {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CustomerName: string;
                export const DepartmentId: string;
                export const EndDateTime: string;
                export const FinancialYearId: string;
                export const FromDeptId: string;
                export const FromNetWeight: string;
                export const FromPieces: string;
                export const FromWeight: string;
                export const FromWorkerId: string;
                export const GroupSieveId: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const IsDisabled: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const Loss: string;
                export const LossPercent: string;
                export const LotNo: string;
                export const MetalColorId: string;
                export const NewBOMDetails: string;
                export const OrderNo: string;
                export const OrderTransId: string;
                export const OrderTransItemId: string;
                export const OrderTypeId: string;
                export const Parts: string;
                export const PartyId: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductSizeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remarks: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StartDateTime: string;
                export const StockAllocation: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubBagNo: string;
                export const SubCategoryName: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TreeId: string;
                export const TreeItemId: string;
                export const TreeNo: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace JobWorkReceipt {
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const RoundOff: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace JobWorkReceiptBOM {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BomAmount: string;
                export const BomProductId: string;
                export const BomRate: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const GroupSieveId: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TransBomId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace JobWorkReceiptItems {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const CompanyId: string;
                export const CustomerName: string;
                export const DepartmentId: string;
                export const EndDateTime: string;
                export const FinancialYearId: string;
                export const FromDeptId: string;
                export const FromNetWeight: string;
                export const FromPieces: string;
                export const FromWeight: string;
                export const FromWorkerId: string;
                export const KaratId: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const Loss: string;
                export const LossPercent: string;
                export const LotNo: string;
                export const MetalId: string;
                export const NewBOMDetails: string;
                export const OrderNo: string;
                export const OrderTransId: string;
                export const OrderTransItemId: string;
                export const OrderTypeId: string;
                export const Parts: string;
                export const ProcessId: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityInspection: string;
                export const QualityInspectionValue: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const StartDateTime: string;
                export const StockAllocation: string;
                export const SubBagNo: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TreeId: string;
                export const TreeItemId: string;
                export const TreeNo: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace JobWorkReceiptLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace JobWorkReceiptTax {
                export const CCTaxAmount: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace JobWorkSettlement {
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Details: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const KnockOff: string;
                export const LedgerName: string;
                export const PartyId: string;
                export const ProductTypeId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace JobWorkSettlementDetails {
                export const Amount: string;
                export const KnockOff: string;
                export const ProductId: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Rate: string;
                export const TransDetailId: string;
                export const TransId: string;
                export const Type: string;
            }

            namespace MFGInspectionValues {
                export const ExpectedValue: string;
                export const InspectedValue: string;
                export const Max: string;
                export const Min: string;
                export const Parameter: string;
                export const Remark: string;
                export const Status: string;
                export const TransInspectionId: string;
                export const TransItemId: string;
            }

            namespace MFGTransaction {
                export const DepartmentId: string;
                export const EmployeeId: string;
                export const ItemDetails: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace MFGTransactionBOM {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BomProductId: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const FromDeptId: string;
                export const FromWorkerId: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const ToDeptId: string;
                export const ToWorkerId: string;
                export const TransBomId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace MFGTransactionItems {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const Button: string;
                export const CompanyId: string;
                export const DepartmentId: string;
                export const EndDateTime: string;
                export const FinancialYearId: string;
                export const FromDeptId: string;
                export const FromDiamondPieces: string;
                export const FromDiamondWeight: string;
                export const FromNetWeight: string;
                export const FromOtherPieces: string;
                export const FromOtherWeight: string;
                export const FromPieces: string;
                export const FromProcessId: string;
                export const FromStonePieces: string;
                export const FromStoneWeight: string;
                export const FromWeight: string;
                export const FromWorkerId: string;
                export const ImageName: string;
                export const KaratId: string;
                export const Line_No: string;
                export const Loss: string;
                export const LossDetails: string;
                export const LossPercent: string;
                export const LotNo: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const OrderTransId: string;
                export const OrderTransItemId: string;
                export const OrderTypeId: string;
                export const Parts: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductItemImage: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityInspection: string;
                export const QualityInspectionValue: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const StartDateTime: string;
                export const StockAllocation: string;
                export const SubBagNo: string;
                export const ToDeptId: string;
                export const ToDiamondPieces: string;
                export const ToDiamondWeight: string;
                export const ToNetWeight: string;
                export const ToOtherPieces: string;
                export const ToOtherWeight: string;
                export const ToPieces: string;
                export const ToProcessId: string;
                export const ToStonePieces: string;
                export const ToStoneWeight: string;
                export const ToWeight: string;
                export const ToWorkerId: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TreeId: string;
                export const TreeItemId: string;
                export const TreeNo: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace MFGTransactionLoss {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BomProductId: string;
                export const CalcOnId: string;
                export const CertificateNo: string;
                export const FromDeptId: string;
                export const FromWorkerId: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const ToDeptId: string;
                export const ToWorkerId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TransLossId: string;
                export const Weight: string;
            }

            namespace Merging {
                export const BagNo: string;
                export const CompanyId: string;
                export const DepartmentId: string;
                export const Details: string;
                export const EachSubBagParts: string;
                export const EachSubBagPieces: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const NoOfSubBag: string;
                export const Parts: string;
                export const Pieces: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace MergingBOM {
                export const AttributeId: string;
                export const BagNo: string;
                export const BomProductId: string;
                export const CalcOnId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const FinancialYearId: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const TransBomId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserId: string;
                export const Weight: string;
            }

            namespace MergingItems {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const EmployeeId: string;
                export const HasBom: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalColorId: string;
                export const NetWeight: string;
                export const OrderTypeId: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const POSCustomerId: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RefVoucherNo: string;
                export const StockAllocation: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const SubBagNo: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TreeId: string;
                export const TreeItemId: string;
                export const TreeNo: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const Weight: string;
            }

            namespace Production {
                export const CompanyId: string;
                export const DepartmentId: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const ItemDetails: string;
                export const ProcessId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ProductionBOM {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BomAmount: string;
                export const BomProductId: string;
                export const BomRate: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TransBomId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ProductionItems {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CustomerName: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const EndDateTime: string;
                export const FinancialYearId: string;
                export const HasBom: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Line_No: string;
                export const Loss: string;
                export const LossPercent: string;
                export const LotNo: string;
                export const MetalId: string;
                export const NetWeight: string;
                export const OrderNo: string;
                export const OrderTransId: string;
                export const OrderTransItemId: string;
                export const OrderTypeId: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const StartDateTime: string;
                export const StockAllocation: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const SubBagNo: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TreeId: string;
                export const TreeItemId: string;
                export const TreeNo: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace QualityInspection {
                export const EmployeeId: string;
                export const Items: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const RefVoucherNo: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
            }

            namespace QualityInspectionItems {
                export const AttributeId: string;
                export const BagNo: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const EmployeeName: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RefVoucherNo: string;
                export const Status: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const Values: string;
                export const WorkerId: string;
            }

            namespace QualityInspectionValues {
                export const ExpectedValue: string;
                export const InspectedValue: string;
                export const Max: string;
                export const Min: string;
                export const Parameter: string;
                export const Remark: string;
                export const Status: string;
                export const TransInspectionId: string;
                export const TransItemId: string;
            }

            namespace ReceiptMaterial {
                export const BagNo: string;
                export const CompanyId: string;
                export const DepartmentId: string;
                export const Details: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const ImageName: string;
                export const Line_No: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ReceiptMaterialDetails {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const CompanyId: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const FinancialYearId: string;
                export const ItemDetails: string;
                export const Line_No: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const RefTransDetailId: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const SKU: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const SubBagNo: string;
                export const TransDate: string;
                export const TransDetailId: string;
                export const TransId: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace ReceiptMaterialItems {
                export const Amount: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const CertificateNo: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const HSN: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const NetWeight: string;
                export const OldBagNo: string;
                export const OldLineNo: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SKU: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeName: string;
                export const SieveName: string;
                export const StockAllocation: string;
                export const StoneColoreName: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const SubBagNo: string;
                export const TaxCode: string;
                export const ToAttributeId: string;
                export const ToProductId: string;
                export const TransDate: string;
                export const TransDetailId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherNo: string;
                export const Weight: string;
            }

            namespace Splitting {
                export const BagNo: string;
                export const CompanyId: string;
                export const Details: string;
                export const EachSubBagParts: string;
                export const EachSubBagPieces: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const NoOfSubBag: string;
                export const Parts: string;
                export const Pieces: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace SplittingBOM {
                export const AttributeId: string;
                export const BagNo: string;
                export const BomProductId: string;
                export const CalcOnId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const FinancialYearId: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const TransBomId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserId: string;
                export const Weight: string;
            }

            namespace SplittingItems {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const CustomerId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const EmployeeId: string;
                export const HasBom: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalColorId: string;
                export const NetWeight: string;
                export const OrderTypeId: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RefVoucherNo: string;
                export const StockAllocation: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const SubBagNo: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TreeId: string;
                export const TreeItemId: string;
                export const TreeNo: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const Weight: string;
            }

            namespace TreeMaking {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const BaseWeight: string;
                export const ButtonWeight: string;
                export const CompanyId: string;
                export const ConversionFactor: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IssueDetails: string;
                export const ItemDetails: string;
                export const KaratId: string;
                export const Loss: string;
                export const LossPercent: string;
                export const MetalBalance: string;
                export const MetalColorId: string;
                export const MetalConsumed: string;
                export const MetalIssued: string;
                export const MetalRequired: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const Purity: string;
                export const RMDepartmentId: string;
                export const ReceiptDetail: string;
                export const Remark: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const TreeNo: string;
                export const TreeWeight: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace TreeMakingBOM {
                export const AttributeId: string;
                export const BagNo: string;
                export const BomProductId: string;
                export const CalcOnId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const FinancialYearId: string;
                export const IsCustomerItem: string;
                export const IsExisting: string;
                export const ItemTypeId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Markup: string;
                export const Pieces: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const TransBomId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserId: string;
                export const Weight: string;
            }

            namespace TreeMakingIssue {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const GroupId: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const Line_No: string;
                export const LotNo: string;
                export const NetWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefTransTypeId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SpecialRemark: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace TreeMakingItems {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const EmployeeId: string;
                export const HasBom: string;
                export const ItemTypeId: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MovementId: string;
                export const NetWeight: string;
                export const OrderTypeId: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const POSCustomerId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RefVoucherNo: string;
                export const StockAllocation: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const SubBagNo: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const Weight: string;
            }

            namespace TreeMakingReceipt {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const GroupId: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalColorName: string;
                export const NetWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefTransTypeId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SpecialRemark: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace WIPMovement {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const CompanyId: string;
                export const CustomerName: string;
                export const DepartmentId: string;
                export const DeptCode: string;
                export const DeptName: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const EmployeeId: string;
                export const EmployeeName: string;
                export const FinancialYearId: string;
                export const FromDepartmentId: string;
                export const FromDeptName: string;
                export const FromEmployeeId: string;
                export const FromEmployeeName: string;
                export const FromNetWeight: string;
                export const FromPieces: string;
                export const FromWeight: string;
                export const HasBom: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Line_No: string;
                export const Loss: string;
                export const LossPercent: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const MovementDate: string;
                export const MovementId: string;
                export const NetWeight: string;
                export const OrderId: string;
                export const OrderPiece: string;
                export const OrderTypeId: string;
                export const OrderVoucherNo: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefMovementId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SKU: string;
                export const StonePieces: string;
                export const StoneWeight: string;
                export const SubBagNo: string;
                export const ToDepartmentId: string;
                export const ToDeptName: string;
                export const ToEmployeeId: string;
                export const ToEmployeeName: string;
                export const ToNetWeight: string;
                export const ToPieces: string;
                export const ToWeight: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const TreeId: string;
                export const TreeItemId: string;
                export const TreeNo: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace WIPTransaction {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const GroupId: string;
                export const HSN: string;
                export const ImageName: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MovementId: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SKU: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StonePieces: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubBagNo: string;
                export const TaxCode: string;
                export const TransId: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace WorkOrder {
                export const CompanyId: string;
                export const DepartmentId: string;
                export const EmployeeId: string;
                export const FinancialYearId: string;
                export const ItemDetails: string;
                export const NoofBags: string;
                export const Pieces: string;
                export const SelectDetails: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace WorkOrderBOM {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BomProductId: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const FinancialYearId: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneStatusName: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TransBomId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserId: string;
                export const Weight: string;
            }

            namespace WorkOrderItems {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BrandId: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const EmployeeId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const Image1: string;
                export const Image2: string;
                export const Image3: string;
                export const ImageName: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetWeight: string;
                export const OrderTypeId: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const POSCustomerId: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RefVoucherNo: string;
                export const Remarks: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StockAllocation: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const SubBagNo: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const Weight: string;
            }
        }

        namespace Purchase {

            namespace ApprovalIn {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ApprovalInBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SBomRate: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ApprovalInItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PurchasePieces: string;
                export const PurchaseVoucher: string;
                export const PurchaseWeight: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RemainingPieces: string;
                export const RemainingWeight: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const SalesPieces: string;
                export const SalesVoucher: string;
                export const SalesWeight: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ApprovalInLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ApprovalInReturn {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ApprovalInReturnBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ApprovalInReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RefVoucherTypeId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ApprovalInReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace MaterialIn {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace MaterialInBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace MaterialInItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsCustomerItem: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace Order {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace OrderItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const InStock: string;
                export const IsClosed: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace OrderLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace PurchaseItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCUnitCost: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const PurityName: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace PurchaseItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TaxCode: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace PurchaseLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace PurchaseMaster {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GSTState: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const Shrt: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxRegType: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace PurchaseReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace PurchaseReturnItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TaxCode: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace PurchaseReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace PurchaseReturnMaster {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace PurchaseReturnTax {
                export const CCTaxAmount: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace PurchaseTax {
                export const CCTaxAmount: string;
                export const CentralTaxAmount: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const ECommGST: string;
                export const EligibilityForITC: string;
                export const GrossAmount: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const IntegratedTaxAmount: string;
                export const InvoiceType: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const PartyTax: string;
                export const ProductTypeId: string;
                export const ReverseCharge: string;
                export const State: string;
                export const StateTaxAmount: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransTaxId: string;
                export const VoucherNo: string;
            }

            namespace Quotation {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace QuotationBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace QuotationItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace QuotationLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace RateFixing {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const PostingDate: string;
                export const Rate: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace RateFixingItems {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SpecialRemark: string;
                export const StoneAmount: string;
                export const StonePieces: string;
                export const StoneRate: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace RateFixingTax {
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }
        }

        namespace Repair {

            namespace Repair {
                export const ActiveCustomers: string;
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const CustomerType: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FrequencyPoints: string;
                export const GSTState: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const MonetaryPoints: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RecencyPoints: string;
                export const Remark: string;
                export const RepairTypeId: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TermsId: string;
                export const TotalPoints: string;
                export const TotalRepair: string;
                export const TotalRepairAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace RepairItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const IsRepairProcess: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefOrderId: string;
                export const RefOrderItemId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace RepairItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace RepairLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace RepairTax {
                export const B2CSType: string;
                export const CCTaxAmount: string;
                export const CentralTaxAmount: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const Code: string;
                export const ECommGST: string;
                export const EligibilityForITC: string;
                export const GrossAmount: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const IntegratedTaxAmount: string;
                export const InvoiceType: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const PartyTax: string;
                export const ProductTypeId: string;
                export const ReverseCharge: string;
                export const State: string;
                export const StateTaxAmount: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransTaxId: string;
                export const VoucherNo: string;
            }
        }

        namespace Reports {

            namespace ItemsRegister {
                export const AttributeId: string;
                export const CompanyCode: string;
                export const DeptName: string;
                export const DiamondWeight: string;
                export const GrossAmount: string;
                export const Image: string;
                export const ImageLength: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalGrossWeight: string;
                export const MetalNetWeight: string;
                export const OrderNo: string;
                export const Party: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PreciousStoneWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const RefNo: string;
                export const SemiPreciousStoneWeight: string;
                export const StampCode: string;
                export const Status: string;
                export const SuperTypeCode: string;
                export const TotalDiamondWeight: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace PriceBifurcation {
                export const AttributeId: string;
                export const CompanyCode: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondRate: string;
                export const DiamondType: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const Image: string;
                export const ImageLength: string;
                export const KaratId: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalColorName: string;
                export const MetalGrossWeight: string;
                export const MetalName: string;
                export const MetalNetAmount: string;
                export const MetalNetWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductLink: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const Remark: string;
                export const StampCode: string;
                export const Status: string;
                export const StoneAmount: string;
                export const StonePieces: string;
                export const StoneRate: string;
                export const StoneType: string;
                export const StoneWeight: string;
                export const SuperTypeCode: string;
                export const TotalDiamondWeight: string;
                export const TotalLabour: string;
                export const TotalStoneWeight: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitLabour: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ShortList {
                export const AttributeId: string;
                export const CompanyCode: string;
                export const DeptName: string;
                export const DiamondWeight: string;
                export const GrossAmount: string;
                export const Image: string;
                export const ImageLength: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalGrossWeight: string;
                export const MetalNetWeight: string;
                export const OrderNo: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PreciousStoneWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const RefNo: string;
                export const SemiPreciousStoneWeight: string;
                export const StampCode: string;
                export const Status: string;
                export const SuperTypeCode: string;
                export const TotalDiamondWeight: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ShortListCategoryWise {
                export const AttributeId: string;
                export const CategoryCode: string;
                export const CompanyCode: string;
                export const DeptName: string;
                export const DiamondWeight: string;
                export const GrossAmount: string;
                export const Image: string;
                export const ImageLength: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalGrossWeight: string;
                export const MetalNetWeight: string;
                export const OrderNo: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PreciousStoneWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const RefNo: string;
                export const SemiPreciousStoneWeight: string;
                export const StampCode: string;
                export const Status: string;
                export const SuperTypeCode: string;
                export const TotalDiamondWeight: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace StockBifurcation {
                export const AttributeId: string;
                export const Company: string;
                export const CustomerName: string;
                export const DepartmentName: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const GroupSieveName: string;
                export const Image: string;
                export const ImageLength: string;
                export const KaratId: string;
                export const KaratName: string;
                export const LedgerName: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalColorName: string;
                export const MetalGrossWeight: string;
                export const MetalName: string;
                export const MetalNetAmount: string;
                export const MetalNetWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const PurchasePieces: string;
                export const PurchaseVoucher: string;
                export const PurchaseWeight: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityName: string;
                export const RemainingPieces: string;
                export const RemainingWeight: string;
                export const Remark: string;
                export const SKU: string;
                export const SalesPieces: string;
                export const SalesVoucher: string;
                export const SalesWeight: string;
                export const ShapeName: string;
                export const SieveName: string;
                export const Status: string;
                export const StoneColoreName: string;
                export const StonePieces: string;
                export const StoneProductType: string;
                export const StoneSizeName: string;
                export const StoneType: string;
                export const StoneWeight: string;
                export const TotalLabour: string;
                export const TotalStoneWeight: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitLabour: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace StoneBifurcation {
                export const AttributeId: string;
                export const CompanyCode: string;
                export const DeptName: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondRate: string;
                export const DiamondType: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const GrossAmount: string;
                export const Image: string;
                export const ImageLength: string;
                export const KaratId: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalColorName: string;
                export const MetalGrossWeight: string;
                export const MetalName: string;
                export const MetalNetAmount: string;
                export const MetalNetWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PreciousStonePieces: string;
                export const PreciousStoneType: string;
                export const PreciousStoneWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductLink: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const Remark: string;
                export const SemiPreciousStonePieces: string;
                export const SemiPreciousStoneType: string;
                export const SemiPreciousStoneWeight: string;
                export const StampCode: string;
                export const Status: string;
                export const SuperTypeCode: string;
                export const TotalDiamondWeight: string;
                export const TotalPreciousStoneWeight: string;
                export const TotalSemiPreciousStoneWeight: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace UserRoles {
                export const RoleId: string;
                export const UserId: string;
                export const UserRoleId: string;
            }
        }

        namespace Retail {

            namespace Exchange {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const AutoPosting: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FirstName: string;
                export const GrossAmount: string;
                export const IsExchanged: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LastName: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ExchangeItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ExchangeItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ExchangeLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace ExchangeTax {
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace GiftVoucherAllocate {
                export const CompanyId: string;
                export const CompanyName: string;
                export const EmployeeId: string;
                export const ItemDetails: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace GiftVoucherAllocateDetails {
                export const Amount: string;
                export const Code: string;
                export const CompanyId: string;
                export const EmployeeId: string;
                export const GvMasterId: string;
                export const GvNumber: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherTypeId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserId: string;
                export const Value: string;
            }

            namespace GiftVoucherIssue {
                export const GiftMasterId: string;
                export const ItemDetails: string;
                export const Quantity: string;
                export const TransDate: string;
                export const TransId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace GiftVoucherItemDetails {
                export const Amount: string;
                export const Code: string;
                export const Expiry: string;
                export const FixedName: string;
                export const GiftMasterId: string;
                export const Id: string;
                export const IsIssued: string;
                export const IsPartial: string;
                export const IsRedeemed: string;
                export const MinInvoiceValue: string;
                export const RedeemedDate: string;
                export const RedeemedValue: string;
                export const RefVoucherId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UniqueNo: string;
                export const Value: string;
            }

            namespace GiftVoucherItems {
                export const GiftMasterId: string;
                export const ItemDetails: string;
                export const Quantity: string;
                export const TransId: string;
                export const TransItemId: string;
            }

            namespace GiftVoucherSales {
                export const CompanyId: string;
                export const EmployeeId: string;
                export const ItemDetails: string;
                export const POSCustomerId: string;
                export const ReceiptDetails: string;
                export const TotalAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace GiftVoucherSalesDetails {
                export const Amount: string;
                export const Code: string;
                export const CompanyId: string;
                export const EmployeeId: string;
                export const GvMasterId: string;
                export const GvNumber: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherTypeId: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UserId: string;
                export const Value: string;
            }

            namespace GiftVoucherSalesReceipt {
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const Code: string;
                export const Id: string;
                export const LedgerId: string;
                export const ModeId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherType: string;
                export const Scheme: string;
                export const SchemeEnrollmentId: string;
                export const TransId: string;
            }

            namespace OrderBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace POSApproval {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const MF: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const ReceiptAmount: string;
                export const ReceiptDetails: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace POSApprovalBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace POSApprovalItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const FirstName: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LastName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PurchasePieces: string;
                export const PurchaseVoucher: string;
                export const PurchaseWeight: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RemainingPieces: string;
                export const RemainingWeight: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const SalesPieces: string;
                export const SalesVoucher: string;
                export const SalesWeight: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSApprovalLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSApprovalReturn {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const ReceiptAmount: string;
                export const ReceiptDetails: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace POSApprovalReturnBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace POSApprovalReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSApprovalReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSOrder {
                export const AdditionalCharges: string;
                export const Address: string;
                export const AddressDetails: string;
                export const Anniversary: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BillingAddress: string;
                export const BillingCity: string;
                export const BillingCityName: string;
                export const BillingCountry: string;
                export const BillingCountryName: string;
                export const BillingPin: string;
                export const BillingState: string;
                export const BillingStateName: string;
                export const BirthDate: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CheckList: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const ECommOrderId: string;
                export const ECommOrderNo: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FirstName: string;
                export const GrossAmount: string;
                export const ItemDetails: string;
                export const LastName: string;
                export const MF: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatusId: string;
                export const OrderStatusName: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ProductItemImage: string;
                export const ReasonId: string;
                export const ReceiptAmount: string;
                export const ReceiptDetails: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const ShippingAddress: string;
                export const ShippingCity: string;
                export const ShippingCityName: string;
                export const ShippingCountry: string;
                export const ShippingCountryName: string;
                export const ShippingPincode: string;
                export const ShippingState: string;
                export const ShippingStateName: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace POSOrderAddress {
                export const Address1: string;
                export const AddressId: string;
                export const City: string;
                export const CityName: string;
                export const Country: string;
                export const CountryName: string;
                export const POSCustomerId: string;
                export const Pincode: string;
                export const State: string;
                export const StateName: string;
                export const TransId: string;
                export const Type: string;
            }

            namespace POSOrderBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace POSOrderItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ECommOrderId: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OrderStatus: string;
                export const OrderStatusId: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const Status: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSOrderLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace POSQuotation {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CityId: string;
                export const CompanyId: string;
                export const CountryId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FirstName: string;
                export const GrossAmount: string;
                export const ImageName: string;
                export const ItemDetails: string;
                export const LastName: string;
                export const MF: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const StateId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace POSQuotationBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace POSQuotationItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const Status: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSQuotationLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace POSReturn {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const AutoPosting: string;
                export const BaseItemTypeId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const IsPosted: string;
                export const IsReturned: string;
                export const ItemDetails: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxId: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace POSReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSReturnItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace POSReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSReturnTax {
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace POSSales {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const AutoPosting: string;
                export const BalanceAmount: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GSTState: string;
                export const GiftDetails: string;
                export const GrossAmount: string;
                export const ImageName: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const MF: string;
                export const Mobile: string;
                export const Month: string;
                export const MonthlySales: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const PromoDetails: string;
                export const Receipt: string;
                export const ReceiptDetails: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TaxId: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace POSSalesGiftVoucher {
                export const Amount: string;
                export const Expiry: string;
                export const GiftMasterId: string;
                export const IsPartial: string;
                export const Quantity: string;
                export const TransGiftId: string;
                export const TransId: string;
                export const UniqueCode: string;
                export const Value: string;
            }

            namespace POSSalesItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const BrandName: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CollectionName: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const Day1Amount: string;
                export const Day2Amount: string;
                export const Day3Amount: string;
                export const Day4Amount: string;
                export const Day5Amount: string;
                export const Day6Amount: string;
                export const Day7Amount: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const EmployeeId: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const Footfall1: string;
                export const Footfall2: string;
                export const Footfall3: string;
                export const Footfall4: string;
                export const Footfall5: string;
                export const FromYear: string;
                export const GrossAmount: string;
                export const GrossAmountPercent: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const IsRepairProcess: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const Line_No: string;
                export const LotNo: string;
                export const M10Amount: string;
                export const M10Pieces: string;
                export const M10Weight: string;
                export const M11Amount: string;
                export const M11Pieces: string;
                export const M11Weight: string;
                export const M12Amount: string;
                export const M12Pieces: string;
                export const M12Weight: string;
                export const M1Amount: string;
                export const M1Pieces: string;
                export const M1Weight: string;
                export const M2Amount: string;
                export const M2Pieces: string;
                export const M2Weight: string;
                export const M3Amount: string;
                export const M3Pieces: string;
                export const M3Weight: string;
                export const M4Amount: string;
                export const M4Pieces: string;
                export const M4Weight: string;
                export const M5Amount: string;
                export const M5Pieces: string;
                export const M5Weight: string;
                export const M6Amount: string;
                export const M6Pieces: string;
                export const M6Weight: string;
                export const M7Amount: string;
                export const M7Pieces: string;
                export const M7Weight: string;
                export const M8Amount: string;
                export const M8Pieces: string;
                export const M8Weight: string;
                export const M9Amount: string;
                export const M9Pieces: string;
                export const M9Weight: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const Month: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TimeSlot1: string;
                export const TimeSlot2: string;
                export const TimeSlot3: string;
                export const TimeSlot4: string;
                export const TimeSlot5: string;
                export const ToYear: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Week: string;
                export const WeekAmount: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace POSSalesItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace POSSalesLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const OriginalLabourAmount: string;
                export const OriginalLabourRate: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace POSSalesReceipt {
                export const Amount: string;
                export const Balance: string;
                export const BankId: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const Code: string;
                export const Denominations: string;
                export const LedgerId: string;
                export const ModeId: string;
                export const ReceiptId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherType: string;
                export const Scheme: string;
                export const SchemeEnrollmentId: string;
                export const TempAmount: string;
                export const Total: string;
                export const TransId: string;
            }

            namespace POSSalesReceiptDetails {
                export const Amount: string;
                export const Code: string;
                export const Count: string;
                export const DenominationId: string;
                export const ReceiptDetailsId: string;
                export const ReceiptId: string;
            }

            namespace POSSalesReport {
                export const AdditionalCharges: string;
                export const AddressId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const CurrencyId: string;
                export const DeppartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GrossAmountDay1: string;
                export const GrossAmountDay2: string;
                export const GrossAmountDay3: string;
                export const GrossAmountDay4: string;
                export const GrossAmountDay5: string;
                export const GrossAmountDay6: string;
                export const GrossAmountSlot1: string;
                export const GrossAmountSlot2: string;
                export const GrossAmountSlot3: string;
                export const GrossAmountSlot4: string;
                export const GrossAmountSlot5: string;
                export const GrossAmountSlot6: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const Pieces: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Roundoff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TotalGrossAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace POSSalesTax {
                export const B2CSType: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const ECommGST: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace POSSalesWithoutTax {
                export const AdditionalCharges: string;
                export const Address: string;
                export const Anniversary: string;
                export const AutoPosting: string;
                export const BalanceAmount: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BirthDate: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const CustomerName: string;
                export const Discount: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GSTState: string;
                export const GiftDetails: string;
                export const GrossAmount: string;
                export const ImageName: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const Mobile: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PosCustomerCode: string;
                export const PostingDate: string;
                export const PromoDetails: string;
                export const Receipt: string;
                export const ReceiptDetails: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const TaxId: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace PosSalesPromo {
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PromoAmount: string;
                export const PromoCode: string;
                export const PromoId: string;
                export const PromoName: string;
                export const PromoPer: string;
                export const TotalAmount: string;
                export const TransId: string;
                export const TransPromoId: string;
            }

            namespace Receipt {
                export const BankId: string;
                export const CompanyId: string;
                export const CurrencyId: string;
                export const Date: string;
                export const EnteredBy: string;
                export const ExchangeRate: string;
                export const FinancialYearId: string;
                export const InvoiceNo: string;
                export const IsAdvance: string;
                export const KnockOffTotal: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Narration: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OrderVoucherNo: string;
                export const POSCustomerId: string;
                export const PartyBalance: string;
                export const PosCustomerCode: string;
                export const ReceiptDetails: string;
                export const RefDate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const RefVoucherNo: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SuffixPrefixId: string;
                export const SysDate: string;
                export const TaxLedgerId: string;
                export const TotalAmount: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace ReceiptDenominationDetails {
                export const Amount: string;
                export const Code: string;
                export const Count: string;
                export const DenominationId: string;
                export const ReceiptDetailsId: string;
                export const ReceiptId: string;
            }

            namespace ReceiptDetails {
                export const Amount: string;
                export const BankId: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const Denominations: string;
                export const ExchangeRateId: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mode: string;
                export const Num1: string;
                export const Num2: string;
                export const Num3: string;
                export const OrderId: string;
                export const PartyType: string;
                export const ReceiptId: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const String1: string;
                export const String2: string;
                export const String3: string;
                export const SysDate: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxName: string;
                export const TransId: string;
            }
        }

        namespace Sales {

            namespace ApprovalOut {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const MF: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ApprovalOutBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionCode: string;
                export const CollectionName: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveCode: string;
                export const GroupSieveId: string;
                export const GroupSieveName: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalCode: string;
                export const MetalColorCode: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalName: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveCode: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StampCode: string;
                export const StampName: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletCode: string;
                export const StoneCuletId: string;
                export const StoneCuletName: string;
                export const StoneCutCode: string;
                export const StoneCutId: string;
                export const StoneCutName: string;
                export const StoneDepth: string;
                export const StoneFluorescenceCode: string;
                export const StoneFluorescenceId: string;
                export const StoneFluorescenceName: string;
                export const StoneGirdleCode: string;
                export const StoneGirdleId: string;
                export const StoneGirdleName: string;
                export const StonePolishCode: string;
                export const StonePolishId: string;
                export const StonePolishName: string;
                export const StoneSizeCode: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const StoneSymmetryCode: string;
                export const StoneSymmetryId: string;
                export const StoneSymmetryName: string;
                export const StoneTable: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ApprovalOutItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandCode: string;
                export const BrandId: string;
                export const BrandName: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionCode: string;
                export const CollectionId: string;
                export const CollectionName: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveCode: string;
                export const GroupSieveId: string;
                export const GroupSieveName: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalCode: string;
                export const MetalColorCode: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const MetalName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductSizeName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveCode: string;
                export const SieveId: string;
                export const SieveName: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StampName: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletCode: string;
                export const StoneCuletId: string;
                export const StoneCuletName: string;
                export const StoneCutCode: string;
                export const StoneCutId: string;
                export const StoneCutName: string;
                export const StoneDepth: string;
                export const StoneFluorescenceCode: string;
                export const StoneFluorescenceId: string;
                export const StoneFluorescenceName: string;
                export const StoneGirdleCode: string;
                export const StoneGirdleId: string;
                export const StoneGirdleName: string;
                export const StonePieces: string;
                export const StonePolishCode: string;
                export const StonePolishId: string;
                export const StonePolishName: string;
                export const StoneRate: string;
                export const StoneSizeCode: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryCode: string;
                export const StoneSymmetryId: string;
                export const StoneSymmetryName: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const SuperTypeName: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ApprovalOutLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ApprovalOutReturn {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace ApprovalOutReturnBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionCode: string;
                export const CollectionName: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveCode: string;
                export const GroupSieveId: string;
                export const GroupSieveName: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalCode: string;
                export const MetalColorCode: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalName: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveCode: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StampCode: string;
                export const StampName: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletCode: string;
                export const StoneCuletId: string;
                export const StoneCuletName: string;
                export const StoneCutCode: string;
                export const StoneCutId: string;
                export const StoneCutName: string;
                export const StoneDepth: string;
                export const StoneFluorescenceCode: string;
                export const StoneFluorescenceId: string;
                export const StoneFluorescenceName: string;
                export const StoneGirdleCode: string;
                export const StoneGirdleId: string;
                export const StoneGirdleName: string;
                export const StonePolishCode: string;
                export const StonePolishId: string;
                export const StonePolishName: string;
                export const StoneSizeCode: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const StoneSymmetryCode: string;
                export const StoneSymmetryId: string;
                export const StoneSymmetryName: string;
                export const StoneTable: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace ApprovalOutReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const Status: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace ApprovalOutReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace DeliveryChallan {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace DeliveryChallanBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionCode: string;
                export const CollectionName: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveCode: string;
                export const GroupSieveId: string;
                export const GroupSieveName: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalCode: string;
                export const MetalColorCode: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalName: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SettingId: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveCode: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StampCode: string;
                export const StampName: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletCode: string;
                export const StoneCuletId: string;
                export const StoneCuletName: string;
                export const StoneCutCode: string;
                export const StoneCutId: string;
                export const StoneCutName: string;
                export const StoneDepth: string;
                export const StoneFluorescenceCode: string;
                export const StoneFluorescenceId: string;
                export const StoneFluorescenceName: string;
                export const StoneGirdleCode: string;
                export const StoneGirdleId: string;
                export const StoneGirdleName: string;
                export const StonePolishCode: string;
                export const StonePolishId: string;
                export const StonePolishName: string;
                export const StoneSizeCode: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryCode: string;
                export const StoneSymmetryId: string;
                export const StoneSymmetryName: string;
                export const StoneTable: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace DeliveryChallanItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandCode: string;
                export const BrandId: string;
                export const BrandName: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionCode: string;
                export const CollectionId: string;
                export const CollectionName: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveCode: string;
                export const GroupSieveId: string;
                export const GroupSieveName: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalCode: string;
                export const MetalColorCode: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const MetalName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductSizeName: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityCode: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveCode: string;
                export const SieveId: string;
                export const SieveName: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StampName: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorCode: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletCode: string;
                export const StoneCuletId: string;
                export const StoneCuletName: string;
                export const StoneCutCode: string;
                export const StoneCutId: string;
                export const StoneCutName: string;
                export const StoneDepth: string;
                export const StoneFluorescenceCode: string;
                export const StoneFluorescenceId: string;
                export const StoneFluorescenceName: string;
                export const StoneGirdleCode: string;
                export const StoneGirdleId: string;
                export const StoneGirdleName: string;
                export const StonePieces: string;
                export const StonePolishCode: string;
                export const StonePolishId: string;
                export const StonePolishName: string;
                export const StoneRate: string;
                export const StoneSizeCode: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryCode: string;
                export const StoneSymmetryId: string;
                export const StoneSymmetryName: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryCode: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const SuperTypeName: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace DeliveryChallanLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace MaterialOut {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const DepartmentId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace MaterialOutBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace MaterialOutItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsCustomerItem: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const RoutingId: string;
                export const SKU: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace RateFixing {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillAddId: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const PostingDate: string;
                export const Rate: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace RateFixingItems {
                export const AckStatus: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupId: string;
                export const HSN: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsPosted: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoutingId: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const SpecialRemark: string;
                export const StoneAmount: string;
                export const StonePieces: string;
                export const StoneRate: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace RateFixingTax {
                export const Cess1Amount: string;
                export const Cess1Id: string;
                export const Cess1LedgerId: string;
                export const Cess1Rate: string;
                export const Cess2Amount: string;
                export const Cess2Id: string;
                export const Cess2LedgerId: string;
                export const Cess2Rate: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const NetAmount: string;
                export const ProductTypeId: string;
                export const Tax1Amount: string;
                export const Tax1Id: string;
                export const Tax1LedgerId: string;
                export const Tax1Rate: string;
                export const Tax2Amount: string;
                export const Tax2Id: string;
                export const Tax2LedgerId: string;
                export const Tax2Rate: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxRate: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace SalesItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BillDate: string;
                export const BillNo: string;
                export const BrandId: string;
                export const BrandName: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CollectionName: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const FinancialYearId: string;
                export const Friday: string;
                export const GrossAmount: string;
                export const GrossAmountPercent: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const IsRepairProcess: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const Monday: string;
                export const Month: string;
                export const Month1: string;
                export const Month2: string;
                export const Month3: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PriceRange1: string;
                export const PriceRange2: string;
                export const PriceRange3: string;
                export const PriceRange4: string;
                export const PriceRange5: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Quarter: string;
                export const Quarter1Amount: string;
                export const Quarter1Pieces: string;
                export const Quarter2Amount: string;
                export const Quarter2Pieces: string;
                export const Quarter3Amount: string;
                export const Quarter3Pieces: string;
                export const Quarter4Amount: string;
                export const Quarter4Pieces: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefOrderId: string;
                export const RefOrderItemId: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const Saturday: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const Thursday: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const Tuesday: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Wednesday: string;
                export const Week: string;
                export const Week1Pieces: string;
                export const Week1Sales: string;
                export const Week2Pieces: string;
                export const Week2Sales: string;
                export const Week3Pieces: string;
                export const Week3Sales: string;
                export const Week4Pieces: string;
                export const Week4Sales: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SalesItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace SalesLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SalesMaster {
                export const ActiveCustomers: string;
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const CustomerType: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const FrequencyPoints: string;
                export const GSTState: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const MF: string;
                export const MonetaryPoints: string;
                export const Month: string;
                export const MonthlySales: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RecencyPoints: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TermsId: string;
                export const TotalPoints: string;
                export const TotalSales: string;
                export const TotalSalesAmount: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace SalesQuotation {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsApproved: string;
                export const IsSubmitted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const MarkUpPolicyId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PriceListId: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace SalesQuotationBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace SalesQuotationItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const Iteration: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const StatusId: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SalesQuotationLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
            }

            namespace SalesReturnItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryCode: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const IsPosted: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampCode: string;
                export const StampId: string;
                export const Status: string;
                export const StockAllocation: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeCode: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SalesReturnItemsBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace SalesReturnLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SalesReturnMaster {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const AutoPosting: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const IsPosted: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PostingDate: string;
                export const ProductItemImage: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const RoundOff: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const TaxAmount: string;
                export const TaxDetails: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace SalesReturnTax {
                export const CCTaxAmount: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const LedgerId: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const ProductTypeId: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransId: string;
                export const TransTaxId: string;
            }

            namespace SalesTax {
                export const B2CSType: string;
                export const CCTaxAmount: string;
                export const CentralTaxAmount: string;
                export const CessAmount: string;
                export const CessId: string;
                export const CessLedgerId: string;
                export const CessRate: string;
                export const Code: string;
                export const ECommGST: string;
                export const EligibilityForITC: string;
                export const GrossAmount: string;
                export const HSN: string;
                export const InputRCMLedgerId: string;
                export const IntegratedTaxAmount: string;
                export const InvoiceType: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const OutputLedgerId: string;
                export const OutputRCMLedgerId: string;
                export const PartyTax: string;
                export const ProductTypeId: string;
                export const ReverseCharge: string;
                export const State: string;
                export const StateTaxAmount: string;
                export const TaxAmount: string;
                export const TaxId: string;
                export const TaxLedgerId: string;
                export const TaxName: string;
                export const TaxRate: string;
                export const TaxType: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransTaxId: string;
                export const VoucherNo: string;
            }
        }

        namespace SalesOrder {

            namespace SalesOrder {
                export const AdditionalCharges: string;
                export const Address1: string;
                export const BillDate: string;
                export const BillNo: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CCRoundOff: string;
                export const CCTaxAmount: string;
                export const ChallanDate: string;
                export const ChallanNo: string;
                export const City: string;
                export const CompanyId: string;
                export const Country: string;
                export const CurrencyId: string;
                export const Discount: string;
                export const Email: string;
                export const EmployeeId: string;
                export const ExchRate: string;
                export const FinancialYearId: string;
                export const GrossAmount: string;
                export const GstVat: string;
                export const ItemDetails: string;
                export const LedgerName: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const Pan: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductItemImage: string;
                export const Remark: string;
                export const ShipAddressId: string;
                export const ShipmentId: string;
                export const State: string;
                export const Status: string;
                export const TaxAmount: string;
                export const TermsId: string;
                export const TransDate: string;
                export const TransId: string;
                export const UserId: string;
                export const Username: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace SalesOrderBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CCBomAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const GrossWeight: string;
                export const GroupSieveId: string;
                export const HasBom: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const Markup: string;
                export const MetalColorId: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const RefTransBomId: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const SettingName: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePolishId: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const TransBomId: string;
                export const TransItemId: string;
                export const Weight: string;
            }

            namespace SalesOrderItems {
                export const AckStatus: string;
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BagStatus: string;
                export const BrandId: string;
                export const CCGrossAmount: string;
                export const CCNetAmount: string;
                export const CalcOnId: string;
                export const CalcUnitId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const DeliveryDate: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const Discount: string;
                export const DiscountPer: string;
                export const ExportPieces: string;
                export const FancyCharges: string;
                export const GrossAmount: string;
                export const GroupSieveId: string;
                export const HSN: string;
                export const HUID: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsDisabled: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const Lab: string;
                export const LaborDetails: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalId: string;
                export const NetAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherCharges: string;
                export const OtherPieces: string;
                export const OtherRate: string;
                export const OtherWeight: string;
                export const Parts: string;
                export const PartyId: string;
                export const Pieces: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const Remark: string;
                export const Remarks: string;
                export const SKU: string;
                export const SalesCostMethodId: string;
                export const ServerDate: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const SpecialRemark: string;
                export const StampId: string;
                export const Status: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneCuletId: string;
                export const StoneCutId: string;
                export const StoneDepth: string;
                export const StoneFluorescenceId: string;
                export const StoneGirdleId: string;
                export const StonePieces: string;
                export const StonePolishId: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSymmetryId: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TaxCode: string;
                export const TransDate: string;
                export const TransId: string;
                export const TransItemId: string;
                export const UnitCost: string;
                export const UnitLabour: string;
                export const UnitRate: string;
                export const UserDescription: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }

            namespace SalesOrderLabor {
                export const Attribute: string;
                export const AttributeId: string;
                export const BrandId: string;
                export const CCLabourAmount: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CalculateTo: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CollectionId: string;
                export const Discount: string;
                export const DiscountPercent: string;
                export const IsCustomerItem: string;
                export const ItemTypeId: string;
                export const LabourAmount: string;
                export const LabourRate: string;
                export const MarkUp: string;
                export const Parts: string;
                export const Pieces: string;
                export const ProcessId: string;
                export const ProcessName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const QualityId: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const StoneColorId: string;
                export const StoneSizeId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const TransItemId: string;
                export const TransLbrId: string;
                export const Weight: string;
                export const WstPer: string;
                export const WstWt: string;
            }
        }

        namespace Scheme {

            namespace SchemeEnrollment {
                export const BonusValue: string;
                export const IsCancelled: string;
                export const IsMatured: string;
                export const IsRedeemed: string;
                export const POSCustomerId: string;
                export const PosCustomerCode: string;
                export const SchemeAmount: string;
                export const SchemeCode: string;
                export const SchemeEnrollmentId: string;
                export const SchemeId: string;
                export const Tenure: string;
            }

            namespace SchemeMaster {
                export const AllowCancellation: string;
                export const BonusType: string;
                export const BonusValue: string;
                export const CancellationCharge: string;
                export const Description: string;
                export const Frequency: string;
                export const SchemeAmount: string;
                export const SchemeCode: string;
                export const SchemeId: string;
                export const SchemeType: string;
                export const Tenure: string;
            }

            namespace SchemePayment {
                export const Address: string;
                export const Amount: string;
                export const CustomerName: string;
                export const FirstName: string;
                export const LedgerId: string;
                export const LedgerName: string;
                export const Mobile: string;
                export const POSCustomerId: string;
                export const PanNumber: string;
                export const PosCustomerCode: string;
                export const SchemeCode: string;
                export const SchemeId: string;
                export const SchemePaymentDetails: string;
                export const SchemePaymentId: string;
                export const TransDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
            }

            namespace SchemePaymentDetails {
                export const Amount: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const Code: string;
                export const LedgerId: string;
                export const ModeId: string;
                export const RefNo: string;
                export const SchemeDetailsId: string;
                export const SchemePaymentId: string;
            }
        }

        namespace Stock {

            namespace JobTransaction {
                export const Attribute: string;
                export const AttributeId: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const CostMethod: string;
                export const DepartmentId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const FinancialYearId: string;
                export const GroupId: string;
                export const HSN: string;
                export const ImageName: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratCode: string;
                export const KaratId: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const MetalCode: string;
                export const MetalColorId: string;
                export const MovementId: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductTypeCode: string;
                export const ProductTypeId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefVoucherId: string;
                export const SKU: string;
                export const ShapeId: string;
                export const SieveId: string;
                export const Status: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StonePieces: string;
                export const StoneSizeId: string;
                export const StoneStatusId: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const TransId: string;
                export const Variance: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }

            namespace StockItem {
                export const Attribute: string;
                export const AttributeId: string;
                export const BOMDetails: string;
                export const BagNo: string;
                export const BrandId: string;
                export const BrandName: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CollectionId: string;
                export const CollectionName: string;
                export const CompanyCode: string;
                export const CompanyId: string;
                export const CostMethodId: string;
                export const CustomerName: string;
                export const DepartmentId: string;
                export const DeptName: string;
                export const DesignCode: string;
                export const DesignId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const ExportPieces: string;
                export const Fancy2Pieces: string;
                export const Fancy2Size: string;
                export const Fancy2Weight: string;
                export const FancyPieces: string;
                export const FancySize: string;
                export const FancyWeight: string;
                export const FinancialYearId: string;
                export const HSN: string;
                export const HUID: string;
                export const Hallmark: string;
                export const HasBom: string;
                export const ImageName: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const LedgerName: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MF: string;
                export const MFAmount: string;
                export const MarquisePieces: string;
                export const MarquiseWeight: string;
                export const MetalAmount: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const MetalId: string;
                export const MetalName: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherSize: string;
                export const OtherWeight: string;
                export const POSCustomerId: string;
                export const POSSalesAmount: string;
                export const POSSalesPieces: string;
                export const POSSalesReturnAmount: string;
                export const POSSalesReturnPieces: string;
                export const Parts: string;
                export const PartyCode: string;
                export const PartyId: string;
                export const Pieces: string;
                export const PreciousPieces: string;
                export const PreciousWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductSizeCode: string;
                export const ProductSizeId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseAmount: string;
                export const PurchasePieces: string;
                export const PurchaseReturnAmount: string;
                export const PurchaseReturnPieces: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const RoundPieces: string;
                export const RoundSize: string;
                export const RoundWeight: string;
                export const SKU: string;
                export const SalesAmount: string;
                export const SalesPieces: string;
                export const SalesReturnAmount: string;
                export const SalesReturnPieces: string;
                export const SemiPreciousPieces: string;
                export const SemiPreciousWeight: string;
                export const SetId: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StampCode: string;
                export const StampId: string;
                export const StockAllocation: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneCuletCode: string;
                export const StoneCuletId: string;
                export const StoneCuletName: string;
                export const StoneCutCode: string;
                export const StoneCutId: string;
                export const StoneCutName: string;
                export const StoneDepth: string;
                export const StoneFluorescenceCode: string;
                export const StoneFluorescenceId: string;
                export const StoneFluorescenceName: string;
                export const StoneGirdleCode: string;
                export const StoneGirdleId: string;
                export const StoneGirdleName: string;
                export const StonePieces: string;
                export const StonePolishCode: string;
                export const StonePolishId: string;
                export const StonePolishName: string;
                export const StoneRate: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneSymmetryCode: string;
                export const StoneSymmetryId: string;
                export const StoneSymmetryName: string;
                export const StoneTable: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const SuperTypeId: string;
                export const SuperTypeName: string;
                export const TaxCode: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const VoucherTypeName: string;
                export const Weight: string;
            }

            namespace StockItemBOM {
                export const Attribute: string;
                export const BOMAttributeId: string;
                export const BOMProductId: string;
                export const BomAmount: string;
                export const BomRate: string;
                export const CalcOn: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CostMethodId: string;
                export const GroupSieveId: string;
                export const GroupSieveName: string;
                export const IsCustomerItem: string;
                export const ItemType: string;
                export const ItemTypeId: string;
                export const KaratId: string;
                export const KaratName: string;
                export const Lab: string;
                export const Line_No: string;
                export const MetalColorId: string;
                export const MetalColorName: string;
                export const Parts: string;
                export const Pieces: string;
                export const PointerWeight: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductName: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const PurchaseCostMethodId: string;
                export const PureWeight: string;
                export const Purity: string;
                export const QualityId: string;
                export const QualityName: string;
                export const Remarks: string;
                export const SalesCostMethodId: string;
                export const SettingId: string;
                export const ShapeCode: string;
                export const ShapeId: string;
                export const ShapeName: string;
                export const SieveId: string;
                export const SieveName: string;
                export const StockBomId: string;
                export const StockId: string;
                export const StoneColorId: string;
                export const StoneColoreName: string;
                export const StoneSizeId: string;
                export const StoneSizeName: string;
                export const StoneStatusId: string;
                export const SubCategoryId: string;
                export const SubCategoryName: string;
                export const TextureId: string;
                export const Weight: string;
            }

            namespace StockReport {
                export const AttributeId: string;
                export const BagNo: string;
                export const CalcOnId: string;
                export const CategoryId: string;
                export const CategoryName: string;
                export const CertificateNo: string;
                export const CompanyId: string;
                export const DepartmentId: string;
                export const DiamondAmount: string;
                export const DiamondPieces: string;
                export const DiamondWeight: string;
                export const FinancialYearId: string;
                export const GroupId: string;
                export const HSN: string;
                export const ImageName: string;
                export const ItemTypeId: string;
                export const Lab: string;
                export const Line_No: string;
                export const LotNo: string;
                export const MetalAmount: string;
                export const NetWeight: string;
                export const OtherAmount: string;
                export const OtherPieces: string;
                export const OtherWeight: string;
                export const POSCustomerId: string;
                export const PartyId: string;
                export const Pieces: string;
                export const Pieces0: string;
                export const Pieces120: string;
                export const Pieces150: string;
                export const Pieces180: string;
                export const Pieces30: string;
                export const Pieces60: string;
                export const Pieces90: string;
                export const ProductCode: string;
                export const ProductId: string;
                export const ProductTypeId: string;
                export const ProductTypeName: string;
                export const Profit: string;
                export const ProfitPercent: string;
                export const PurchaseTotal: string;
                export const PureWeight: string;
                export const Purity: string;
                export const Rate: string;
                export const RefNo: string;
                export const RefTransId: string;
                export const RefTransItemId: string;
                export const RefVoucherId: string;
                export const SKU: string;
                export const SalesTotal: string;
                export const SetId: string;
                export const StockId: string;
                export const StoneAmount: string;
                export const StonePieces: string;
                export const StoneStatusId: string;
                export const StoneWeight: string;
                export const Studded: string;
                export const TotalPieces: string;
                export const TransId: string;
                export const TransItemId: string;
                export const VoucherDate: string;
                export const VoucherNo: string;
                export const VoucherTypeId: string;
                export const Weight: string;
            }
        }

        namespace _Ext {

            namespace AuditLog {
                export const ADate: string;
                export const ATime: string;
                export const ActionDate: string;
                export const ActionType: string;
                export const EntityId: string;
                export const EntityTableName: string;
                export const Id: string;
                export const IpAddress: string;
                export const NewEntity: string;
                export const OldEntity: string;
                export const SessionId: string;
                export const UserId: string;
                export const Username: string;
                export const VersionNo: string;
            }
        }
    }

    declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const FormTitle: string;
                export const GoogleButton: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignUpButton: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const BackToLogin: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const Password: string;
                export const SubmitButton: string;
                export const Success: string;
            }
        }
    }

    declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContentDescription: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    declare namespace Validation {
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CurrentPasswordMismatch: string;
        export const CustomerLogin: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const InvalidActivateToken: string;
        export const InvalidCompany: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const SavePrimaryKeyError: string;
    }

    TabAurous['Texts'] = Q.proxyTexts(Texts, '', {Controls:{Fields:{BOMLaborTab:1,ImageTab:1,ProductDetailsTab:1},IdleTimeout:{CountdownMessage:1,KeepAliveButton:1,SignoutButton:1,WarningMessage:1,WarningTitle:1},ImageUpload:{AddFileButton:1,ColorboxClose:1,ColorboxCurrent:1,ColorboxNext:1,ColorboxPrior:1,DeleteButtonHint:1,MaxHeight:1,MaxWidth:1,MinHeight:1,MinWidth:1,NotAnImageFile:1,UploadFileTooBig:1,UploadFileTooSmall:1}},Db:{Administration:{APIKeys:{AppName:1,Button:1,ClientId:1,Key:1,Role:1,Secret:1},AuthorizedVouchers:{AuthorizationDate:1,AuthorizationId:1,AuthorizedUserId:1,LoginUserId:1,Remark:1,VoucherNo:1,VoucherTypeId:1},CampaignSetup:{ApiKey:1,AppId:1,Code:1,FixedCode:1,Id:1,Password:1,Provider:1,ProviderType:1,Token:1,Type:1,UserName:1},CampaignTemplates:{Code:1,Footer:1,Html:1,Id:1,Image:1,Message:1,ProviderType:1,ProviderTypeId:1,TemplateType:1,TemplateTypeId:1,Title:1,Url:1},ConfigLookup:{Code:1,Type:1,Value:1},Configuration:{Code:1,Description:1,Id:1,Name:1,Type:1,Value:1},DocumentPrinting:{Content:1,DocumentId:1,LastModified:1,LastRequested:1,Location:1},DocumentReports:{DocumentId:1,ReportFile:1,ReportId:1,ReportKey:1,ReportName:1},Freight:{ApiEndpoint:1,ApiKey:1,ClientSecret:1,FreightCode:1,FreightId:1,FreightName:1,LedgerId:1,Password:1,UserId:1},Integration:{AccessKey:1,IntegrationType:1,Password:1,RefreshToken:1,RoleArn:1,SecretKey:1,Type:1,Url:1,Username:1},ItemDiscount:{Code:1,CompanyId:1,Details:1,Id:1},ItemDiscountDetails:{CategoryId:1,Code:1,DetailsId:1,Id:1,MaxDiscount:1,ProductTypeId:1,String1:1,SubCategoryId:1},Language:{Id:1,LanguageId:1,LanguageName:1},Navigation:{Controller:1,Icon:1,IsParent:1,IsSubParent:1,MenuId:1,MenuOrder:1,Module:1,Name:1,SubMenu:1},PushNotifyConfig:{ApiKey:1,AppId:1,Id:1},QualityInspectionTemplate:{Code:1,Details:1,TemplateId:1},QualityInspectionTemplateDetails:{DetailId:1,IsNumeric:1,Max:1,Min:1,Parameter:1,TemplateId:1,Value:1},SendCampaign:{CampaignCode:1,Code:1,DateTime:1,FixedCode:1,Html:1,Image:1,Message:1,Party:1,ProviderId:1,ProviderType:1,Recurring:1,Schedule:1,ScheduleId:1,ScheduleTypeId:1,TemplateId:1,Title:1,UseTemplate:1},SendCampaignDetails:{PartyId:1,ScheduleDetailsId:1,ScheduleId:1},Sequence:{Code:1,Id:1,Name:1,Processes:1},SequenceDetails:{DepartmentId:1,DeptName:1,DetailId:1,Priority:1,ProcessId:1,ProcessName:1,SequenceId:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,User:1,UserId:1,UserRoleId:1,Username:1}},CRM:{ProductCatalog:{Attribute:1,AttributeId:1,BOMDetails:1,BrandId:1,BrandName:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CollectionId:1,CollectionName:1,CostMethodId:1,CreationDate:1,CreationVoucherId:1,DesignId:1,DiamondPieces:1,DiamondWeight:1,ForExchange:1,GroupSieveName:1,HSN:1,HasBom:1,Image1:1,Image2:1,Image3:1,Image4:1,Image5:1,Image6:1,Image7:1,Image8:1,ImageName:1,InspectionDetails:1,IsConfigurable:1,IsCustomerItem:1,IsDefaultSKU:1,IsDisabled:1,IsFeatured:1,IsNew:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,LaborDetails:1,LaborMarkup:1,MaxPurity:1,MetalColorId:1,MetalColorName:1,MetalId:1,MetalName:1,MinPurity:1,MoldsDetails:1,NetWeight:1,OtherPieces:1,OtherWeight:1,ParentDesign:1,Parts:1,Pieces:1,PointerWeight:1,PriceMarkup:1,ProductCode:1,ProductEnquiryType:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,Purity:1,QualityId:1,QualityInspectionId:1,QualityName:1,Rate:1,Remarks:1,SKU:1,SalesPrice:1,SequenceDetails:1,ServerDate:1,SettingId:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,StdPurity:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,SuperTypeName:1,TaxCode:1,UnitLabour:1,Variance:1,Video1:1,Video2:1,Volume:1,Volume1:1,Volume2:1,Weight:1}},CertificationReturn:{CertificationReturnTax:{CCTaxAmount:1,CentralTaxAmount:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,ECommGST:1,EligibilityForITC:1,GrossAmount:1,HSN:1,InputRCMLedgerId:1,IntegratedTaxAmount:1,InvoiceType:1,LedgerId:1,LedgerName:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,PartyTax:1,ProductTypeId:1,ReverseCharge:1,State:1,StateTaxAmount:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransDate:1,TransId:1,TransTaxId:1,VoucherNo:1}},Common:{GiftVoucherTransactions:{Amount:1,CompanyId:1,ExpiryDate:1,GvMasterId:1,GvNumber:1,Id:1,IsRedeemed:1,IsSold:1,IssuedDate:1,RedeemedTransDate:1,RedeemedTransId:1,RedeemedValue:1,RedeemedVoucherTypeId:1,TransDate:1,TransId:1,VoucherTypeId:1},UserPreference:{Name:1,PreferenceType:1,UserId:1,UserPreferenceId:1,Value:1}},ECommerce:{ECommExchange:{AdditionalCharges:1,AutoPosting:1,BaseItemTypeId:1,BillDate:1,BillNo:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsECommExchanged:1,IsPosted:1,ItemDetails:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,ProductItemImage:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ECommExchangeBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ECommExchangeItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,DeliveryDate:1,DepartmentId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},ECommExchangeLabor:{Attribute:1,AttributeId:1,BrandId:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},ECommExchangeTax:{CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},ECommOrder:{AdditionalCharges:1,AddressDetails:1,BaseItemTypeId:1,BillDate:1,BillNo:1,BillingAddress:1,BillingCity:1,BillingCityName:1,BillingCountry:1,BillingCountryName:1,BillingPhone:1,BillingPin:1,BillingState:1,BillingStateName:1,ChallanDate:1,ChallanNo:1,CheckList:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,ECommOrderId:1,ECommOrderNo:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FirstName:1,GrossAmount:1,ItemDetails:1,LastName:1,Mobile:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,ProductItemImage:1,PromoDetails:1,ReasonId:1,ReceiptAmount:1,ReceiptDetails:1,Remark:1,ShipAddressId:1,ShipmentId:1,ShippingAddress:1,ShippingCity:1,ShippingCityName:1,ShippingCountry:1,ShippingCountryName:1,ShippingPhone:1,ShippingPincode:1,ShippingState:1,ShippingStateName:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ECommOrderAddress:{Address1:1,AddressId:1,City:1,CityName:1,Country:1,CountryName:1,POSCustomerId:1,Phone:1,Pincode:1,State:1,StateName:1,TransId:1,Type:1},ECommOrderBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ECommOrderItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,CustomerName:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ECommOrderId:1,ECommOrderItemId:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HasBom:1,ImageName:1,IsConfigurable:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,PosCustomerCode:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,Status:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},ECommOrderLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},ECommOrderPromo:{ProductTypeId:1,ProductTypeName:1,PromoAmount:1,PromoCode:1,PromoId:1,PromoName:1,PromoPer:1,TotalAmount:1,TransId:1,TransPromoId:1},ECommRefund:{CompanyId:1,CurrencyId:1,Date:1,ECommRefundDetails:1,Email:1,EnteredBy:1,ExchangeRate:1,FinancialYearId:1,InvoiceNo:1,LedgerId:1,LedgerName:1,Mobile:1,Narration:1,Num1:1,Num2:1,Num3:1,OrderVoucherNo:1,POSCustomerId:1,PartyBalance:1,PayOutId:1,RefDate:1,RefNo:1,RefTransId:1,RefVoucherId:1,RefundECommsible:1,RefundTotal:1,String1:1,String2:1,String3:1,SysDate:1,TotalAmount:1,TransId:1,Url:1,UserId:1,VoucherNo:1,VoucherTypeId:1},ECommRefundDetails:{Amount:1,ChequeDate:1,ChequeNo:1,ExchangeRateId:1,LedgerId:1,LedgerName:1,Mode:1,Num1:1,Num2:1,Num3:1,OrderId:1,PartyType:1,RefNo:1,String1:1,String2:1,String3:1,SysDate:1,TaxAmount:1,TaxId:1,TaxName:1,TransDetailId:1,TransId:1},ECommRepair:{AdditionalCharges:1,Address:1,Anniversary:1,BalanceAmount:1,BaseItemTypeId:1,BillDate:1,BillNo:1,BirthDate:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GSTState:1,GrossAmount:1,ImageName:1,ItemDetails:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,Receipt:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TaxDetails:1,TaxId:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ECommRepairItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,Day1Amount:1,Day2Amount:1,Day3Amount:1,Day4Amount:1,Day5Amount:1,Day6Amount:1,Day7Amount:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,EmployeeId:1,FancyCharges:1,Footfall1:1,Footfall2:1,Footfall3:1,Footfall4:1,Footfall5:1,FromYear:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsRepairProcess:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,M10Amount:1,M10Pieces:1,M10Weight:1,M11Amount:1,M11Pieces:1,M11Weight:1,M12Amount:1,M12Pieces:1,M12Weight:1,M1Amount:1,M1Pieces:1,M1Weight:1,M2Amount:1,M2Pieces:1,M2Weight:1,M3Amount:1,M3Pieces:1,M3Weight:1,M4Amount:1,M4Pieces:1,M4Weight:1,M5Amount:1,M5Pieces:1,M5Weight:1,M6Amount:1,M6Pieces:1,M6Weight:1,M7Amount:1,M7Pieces:1,M7Weight:1,M8Amount:1,M8Pieces:1,M8Weight:1,M9Amount:1,M9Pieces:1,M9Weight:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,Month:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TimeSlot1:1,TimeSlot2:1,TimeSlot3:1,TimeSlot4:1,TimeSlot5:1,ToYear:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Week:1,WeekAmount:1,Weight:1,WstPer:1,WstWt:1},ECommRepairItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ECommRepairLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},ECommRepairTax:{B2CSType:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,ECommGST:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,State:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},ECommSales:{AdditionalCharges:1,Address:1,AddressDetails:1,Anniversary:1,AutoPosting:1,BalanceAmount:1,BaseItemTypeId:1,BillDate:1,BillNo:1,BillingAddress:1,BillingCity:1,BillingCityName:1,BillingCountry:1,BillingCountryName:1,BillingPhone:1,BillingPin:1,BillingState:1,BillingStateName:1,BirthDate:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,ECommOrderId:1,ECommOrderNo:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GSTState:1,GiftDetails:1,GrossAmount:1,ImageName:1,IsPosted:1,ItemDetails:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,PromoDetails:1,Receipt:1,ReceiptDetails:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,ShippingAddress:1,ShippingCity:1,ShippingCityName:1,ShippingCountry:1,ShippingCountryName:1,ShippingPhone:1,ShippingPincode:1,ShippingState:1,ShippingStateName:1,TaxAmount:1,TaxDetails:1,TaxId:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ECommSalesGiftVoucher:{Amount:1,Expiry:1,GiftMasterId:1,IsPartial:1,Quantity:1,TransGiftId:1,TransId:1,UniqueCode:1,Value:1},ECommSalesItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BalanceAmount:1,BrandId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,Day1Amount:1,Day2Amount:1,Day3Amount:1,Day4Amount:1,Day5Amount:1,Day6Amount:1,Day7Amount:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ECommOrderItemId:1,EmployeeId:1,ExportPieces:1,FancyCharges:1,Footfall1:1,Footfall2:1,Footfall3:1,Footfall4:1,Footfall5:1,FromYear:1,GrossAmount:1,GroupSieveId:1,HSN:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsRepairProcess:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,M10Amount:1,M10Pieces:1,M10Weight:1,M11Amount:1,M11Pieces:1,M11Weight:1,M12Amount:1,M12Pieces:1,M12Weight:1,M1Amount:1,M1Pieces:1,M1Weight:1,M2Amount:1,M2Pieces:1,M2Weight:1,M3Amount:1,M3Pieces:1,M3Weight:1,M4Amount:1,M4Pieces:1,M4Weight:1,M5Amount:1,M5Pieces:1,M5Weight:1,M6Amount:1,M6Pieces:1,M6Weight:1,M7Amount:1,M7Pieces:1,M7Weight:1,M8Amount:1,M8Pieces:1,M8Weight:1,M9Amount:1,M9Pieces:1,M9Weight:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,Month:1,NetAmount:1,NetWeight:1,OrderAmount:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxAmount:1,TaxCode:1,TimeSlot1:1,TimeSlot2:1,TimeSlot3:1,TimeSlot4:1,TimeSlot5:1,ToYear:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Week:1,WeekAmount:1,Weight:1,WstPer:1,WstWt:1},ECommSalesItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ECommSalesLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},ECommSalesPromo:{ProductTypeId:1,ProductTypeName:1,PromoAmount:1,PromoCode:1,PromoId:1,PromoName:1,PromoPer:1,TotalAmount:1,TransId:1,TransPromoId:1},ECommSalesReceipt:{Amount:1,Balance:1,BankId:1,ChequeDate:1,ChequeNo:1,Code:1,LedgerId:1,ModeId:1,ReceiptId:1,RefNo:1,RefTransId:1,RefVoucherType:1,Scheme:1,SchemeEnrollmentId:1,Total:1,TransId:1},ECommSalesReport:{AdditionalCharges:1,AddressId:1,BaseItemTypeId:1,BillDate:1,BillNo:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CompanyName:1,CurrencyId:1,DeppartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GrossAmountDay1:1,GrossAmountDay2:1,GrossAmountDay3:1,GrossAmountDay4:1,GrossAmountDay5:1,GrossAmountDay6:1,GrossAmountSlot1:1,GrossAmountSlot2:1,GrossAmountSlot3:1,GrossAmountSlot4:1,GrossAmountSlot5:1,GrossAmountSlot6:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PartyId:1,Pieces:1,RefVoucherId:1,Remark:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TotalGrossAmount:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},ECommSalesReturn:{AdditionalCharges:1,Address:1,Anniversary:1,AutoPosting:1,BillDate:1,BillNo:1,BirthDate:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,IsReturned:1,ItemDetails:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,ProductItemImage:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TaxDetails:1,TaxId:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ECommSalesReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},ECommSalesReturnItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ECommSalesReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},ECommSalesReturnTax:{CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},ECommSalesTax:{B2CSType:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,ECommGST:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,State:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},OrderManagementCheckList:{CheckListId:1,CheckListName:1,CheckListValue:1,Id:1,TransId:1,TransItemId:1},OrderProcessing:{AckStatus:1,Attribute:1,AttributeId:1,AvailablePieces:1,AvailableWeight:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CalcOnId:1,CategoryId:1,CategoryName:1,CcGrossAmount:1,CcNetAmount:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,CurrentPosition:1,CustomerName:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ECommOrderId:1,ECommOrderItemId:1,ECommOrderNo:1,Email:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,Hallmark:1,HasBom:1,ImageName:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,Mobile:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,ShapeId:1,SieveId:1,SpecialRemark:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,Stoneweight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,TypeDescription:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},OrderReceipt:{Amount:1,BankId:1,ChequeDate:1,ChequeNo:1,Code:1,Id:1,LedgerId:1,ModeId:1,ReceiptDetails:1,RefNo:1,RefTransId:1,RefVoucherType:1,Scheme:1,SchemeEnrollmentId:1,TransId:1},OrdersManagement:{AdditionalCharges:1,AddressId:1,BillDate:1,BillNo:1,CcGrossAmount:1,CcNetAmount:1,ChallanDate:1,ChallanNo:1,CheckList:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,ECommOrderId:1,ECommOrderNo:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,Mobile:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,POSCustomerId:1,PartyId:1,Pieces:1,PosCustomerCode:1,ReasonId:1,ReceiptAmount:1,RefVoucherId:1,Remark:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},PickUp:{AWBNumber:1,AdditionalCharges:1,Address:1,BaseItemTypeId:1,BillDate:1,BillNo:1,ChallanDate:1,ChallanNo:1,CityId:1,CompanyId:1,CountryId:1,CurrencyId:1,CustomerName:1,Discount:1,ECommOrderId:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FirstName:1,FreightId:1,GrossAmount:1,ItemDetails:1,LabelId:1,LastName:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,POSCustomerId:1,PanNumber:1,PartyId:1,PickupDate:1,PickupTime:1,Pieces:1,Pin:1,PosCustomerCode:1,ReceiptAmount:1,Remark:1,ShipAddressId:1,ShipmentId:1,StateId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},PickUpBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,MetalColorId:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},PickUpItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,CustomerName:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ECommOrderId:1,GrossAmount:1,GroupSieveId:1,HSN:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,PosCustomerCode:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,Status:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},Receipt:{CompanyId:1,CurrencyId:1,Date:1,EnteredBy:1,ExchangeRate:1,FinancialYearId:1,InvoiceNo:1,IsAdvance:1,KnockOffTotal:1,LedgerId:1,LedgerName:1,Narration:1,Num1:1,Num2:1,Num3:1,OrderVoucherNo:1,POSCustomerId:1,PartyBalance:1,ReceiptDetails:1,RefDate:1,RefNo:1,RefTransId:1,RefVoucherId:1,String1:1,String2:1,String3:1,SuffixPrefixId:1,SysDate:1,TaxLedgerId:1,TotalAmount:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},ReceiptDetails:{Amount:1,BankId:1,ChequeDate:1,ChequeNo:1,ExchangeRateId:1,LedgerId:1,LedgerName:1,Mode:1,Num1:1,Num2:1,Num3:1,OrderId:1,PartyType:1,RefNo:1,String1:1,String2:1,String3:1,SysDate:1,TaxAmount:1,TaxId:1,TaxName:1,TransDetailId:1,TransId:1},ReturnsManagement:{AdditionalCharges:1,AddressId:1,BillDate:1,BillNo:1,CcGrossAmount:1,CcNetAmount:1,ChallanDate:1,ChallanNo:1,CheckList:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,ECommOrderId:1,ECommOrderNo:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,POSCustomerId:1,PartyId:1,Pieces:1,PosCustomerCode:1,ReasonId:1,ReceiptAmount:1,RefVoucherId:1,Remark:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},Shipping:{AWBNumber:1,AdditionalCharges:1,Address:1,BaseItemTypeId:1,BillDate:1,BillNo:1,ChallanDate:1,ChallanNo:1,CityId:1,CompanyId:1,CountryId:1,CurrencyId:1,CustomerName:1,Discount:1,ECommOrderId:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FirstName:1,FreightId:1,GrossAmount:1,ItemDetails:1,LabelId:1,LastName:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,POSCustomerId:1,PanNumber:1,PartyId:1,PickupDate:1,PickupTime:1,Pieces:1,PosCustomerCode:1,ReceiptAmount:1,Remark:1,ShipAddressId:1,ShipmentId:1,StateId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ShippingBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ShippingItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,CustomerName:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ECommOrderId:1,ECommOrderItemId:1,GrossAmount:1,GroupSieveId:1,HSN:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,PosCustomerCode:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,Status:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1}},Fields:{AWBNumber:1,AccountGroupName:1,AccountingContraDetailId:1,AccountingExpense:1,AccountingPeriodCode:1,AccountingVoucherTypeId:1,AcknowledgementStatus:1,AdditionalChargeCode:1,AdditionalChargeName:1,AdditionalCharges:1,Address:1,Address2:1,AddressType:1,AddtoZiFlow:1,AgainstId:1,AgainstInvoiceNo:1,AgainstVoucherNo:1,AgainstVoucherTypeId:1,AllVouchers:1,Amount:1,ApplicableOn:1,Attribute:1,AttributeCode:1,AttributeName:1,AttributeType:1,AvailablePieces:1,AvailableWeight:1,B2CSType:1,BOMAttributeId:1,BOMProductId:1,BagNo:1,BagStatus:1,Balance:1,BalanceAmount:1,BalanceIsPosted:1,BalancePostingDate:1,BalanceUserId:1,Bank:1,BaseItemTypeId:1,BaseWeight:1,BillDate:1,BillNo:1,BomAmount:1,BomRate:1,Brand:1,BrandCode:1,BrandName:1,Button:1,ButtonWeight:1,CCBomAmount:1,CCCredit:1,CCDebit:1,CCGrossAmount:1,CCLaborAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,CST:1,CalcOn:1,CalcUnit:1,Category:1,CategoryCode:1,CategoryName:1,CenterStone:1,CertificateNo:1,CessId:1,ChallanDate:1,ChallanNo:1,Chargeable:1,CheckListId:1,CheckListValue:1,ChequeDate:1,ChequeNo:1,City:1,Collection:1,CollectionCode:1,CollectionName:1,ColorQualityMapping:1,Comment:1,Company:1,CompanyCode:1,CompanyType:1,ContraId:1,CostMethod:1,Country:1,CreationDate:1,Credit:1,CreditNote:1,CreditPeriod:1,Currency:1,CurrentStatus:1,Customer:1,CustomerCode:1,CustomerName:1,Day1Amount:1,Day2Amount:1,Day3Amount:1,Day4Amount:1,Day5Amount:1,Day6Amount:1,Day7Amount:1,Debit:1,DebitNote:1,Decision:1,DefaultTDS:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignName:1,Designation:1,DetailId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPercentage:1,DiscountType:1,Due:1,ECommGST:1,ECommOrderId:1,ECommOrderItemId:1,ECommOrderNo:1,Email:1,Employee:1,EndDateTime:1,EnteredBy:1,ExchangeRate:1,ExcludeDiscount:1,ExpectedValue:1,Expiry:1,ExportPieces:1,Extra1:1,Extra2:1,ExtraDate:1,FancyCharges:1,FinancialYear:1,FinancialYearId:1,FirstName:1,Flow:1,Footfall1:1,Footfall2:1,Footfall3:1,Footfall4:1,Footfall5:1,ForExchange:1,Freight:1,FromDate:1,FromDepartmentId:1,FromDeptId:1,FromDeptName:1,FromEmployeeId:1,FromEmployeeName:1,FromNetWeight:1,FromPieces:1,FromProcessId:1,FromWeight:1,FromWorkerId:1,FromYear:1,GSTState:1,GiftMasterId:1,GrossAmount:1,GrossAmountDay1:1,GrossAmountDay2:1,GrossAmountDay3:1,GrossAmountDay4:1,GrossAmountDay5:1,GrossAmountDay6:1,GrossAmountSlot1:1,GrossAmountSlot2:1,GrossAmountSlot3:1,GrossAmountSlot4:1,GrossAmountSlot5:1,GrossAmountSlot6:1,GrossWeight:1,Group:1,GroupSieve:1,GroupUnder:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IncludeTax:1,InspectedValue:1,IsAffectGrossProfit:1,IsCustomerItem:1,IsDefault:1,IsDefaultSKU:1,IsDisabled:1,IsECommExchanged:1,IsExisting:1,IsPartial:1,IsPosted:1,IsRepairProcess:1,IsReturned:1,ItemGrossAmount:1,ItemNetAmount:1,ItemType:1,Journal:1,JournalCompany:1,Karat:1,KnockOff:1,KnockOffTotal:1,Lab:1,LaborAmount:1,LaborDiscount:1,LaborMarkup:1,LaborPriceList:1,LaborRate:1,LastName:1,LedgerName:1,LineNo:1,Loss:1,LossPercent:1,LotNo:1,M10Amount:1,M10Pieces:1,M10Weight:1,M11Amount:1,M11Pieces:1,M11Weight:1,M12Amount:1,M12Pieces:1,M12Weight:1,M1Amount:1,M1Pieces:1,M1Weight:1,M2Amount:1,M2Pieces:1,M2Weight:1,M3Amount:1,M3Pieces:1,M3Weight:1,M4Amount:1,M4Pieces:1,M4Weight:1,M5Amount:1,M5Pieces:1,M5Weight:1,M6Amount:1,M6Pieces:1,M6Weight:1,M7Amount:1,M7Pieces:1,M7Weight:1,M8Amount:1,M8Pieces:1,M8Weight:1,M9Amount:1,M9Pieces:1,M9Weight:1,MCredit:1,MDebit:1,MailingName:1,Manage:1,MarkUp:1,MarkUpPolicy:1,MarkUpPolicyCode:1,MarkUpPolicyId:1,MarkUpPolicyName:1,MarkUpType:1,Max:1,MaxDiscountPercent:1,MaximumLabor:1,Metal:1,MetalAmount:1,MetalBalance:1,MetalColor:1,MetalConsumed:1,MetalIssued:1,MetalRequired:1,Min:1,MinimumLabor:1,Mobile:1,Mode:1,Month:1,MovementDate:1,MovementId:1,MultiplicationFactor:1,MultiplicationFactorAmount:1,Narration:1,Nature:1,NetAmount:1,NetWeight:1,NoOfSubBag:1,NoofBags:1,OldBagNo:1,OldLineNo:1,OpeningBalanceType:1,OrderPiece:1,OrderStatusId:1,OrderTransItemId:1,OrderTypeId:1,OrderVoucherNo:1,OriginalLabourAmount:1,OriginalLabourRate:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,OverdueDays:1,PAN:1,PDCType:1,PDCVoucherNo:1,POSCustomer:1,POSCustomerId:1,ParentAttributeId:1,Parties:1,Parts:1,PartsPerSubBag:1,Party:1,PartyBalance:1,PartyBalanceId:1,PartyCode:1,PartyLedgerId:1,PartyName:1,PayOutId:1,PaymentLedger:1,PcsPerSubBag:1,PeriodId:1,PeriodicClosingAccount:1,PeriodicPostingDate:1,Phone:1,PickupDate:1,PickupTime:1,Pieces:1,PiecesPerSubBag:1,Pin:1,Pincode:1,PlaceofSupply:1,PointerWeight:1,PostingDate:1,PriceCode:1,PriceList:1,PriceName:1,PriceType:1,Priority:1,Process:1,ProductCalculateOn:1,ProductCode:1,ProductId:1,ProductItemImage:1,ProductName:1,ProductSize:1,ProductType:1,PromoAmount:1,PromoId:1,PromoPer:1,PurchaseRate:1,PureWeight:1,Purity:1,QCPass:1,Quality:1,Quantity:1,Quarter1:1,Quarter2:1,Quarter3:1,RMDepartmentId:1,Rate:1,RateType:1,Reason:1,ReceiptAmount:1,ReceiptId:1,ReceivedAmount:1,ReceivedWeight:1,RefDepartmentId:1,RefMovementId:1,RefTransBom:1,RefTransId:1,RefVoucherType:1,ReferenceDate:1,ReferenceNo:1,ReferenceTransactionId:1,ReferenceTransactionItemId:1,ReferenceType:1,Refund:1,RefundECommsible:1,RefundTotal:1,Remark:1,RequiredPieces:1,RequiredWeight:1,RoundOff:1,Routing:1,SKU:1,SalesPerson:1,SalesRate:1,Scheme:1,SchemeEnrollmentId:1,ServerDate:1,ServiceId:1,ServiceInwardDetailsMasterId:1,ServiceInwardMasterId:1,ServiceInwards:1,ServiceOutwardDetailsMasterId:1,ServiceOutwardMasterId:1,Setting:1,Shape:1,Share:1,ShipAddress:1,Shipment:1,Sieve:1,SpecialRemark:1,Stamp:1,StartDateTime:1,State:1,Status:1,StockId:1,StoneAmount:1,StoneColor:1,StoneCulet:1,StoneCut:1,StoneDepth:1,StoneDiscount:1,StoneFluorescence:1,StoneGirdle:1,StoneMarkup:1,StonePieces:1,StonePolish:1,StoneRate:1,StoneSize:1,StoneStatusId:1,StoneStatusName:1,StoneSymmetry:1,StoneTable:1,StoneWeight:1,Studded:1,SubBagNo:1,SubCategory:1,SuperType:1,Supplier:1,SupplierCode:1,SupplierName:1,SurplusAccount:1,SysDate:1,TDS:1,TDSAmount:1,TDSRate:1,TDSTotal:1,TaxAmount:1,TaxCode:1,TaxId:1,TaxNumber:1,TaxRate:1,TaxRegistrationType:1,Terms:1,TermsId:1,TimeSlot1:1,TimeSlot2:1,TimeSlot3:1,TimeSlot4:1,TimeSlot5:1,ToAttributeId:1,ToDate:1,ToDepartmentId:1,ToDeptId:1,ToDeptName:1,ToEmployeeId:1,ToEmployeeName:1,ToNetWeight:1,ToPieces:1,ToProcessId:1,ToProduct:1,ToWeight:1,ToWorkerId:1,ToYear:1,Total:1,TotalAmount:1,TotalGrossAmount:1,TransDate:1,TransDetailId:1,TransGiftId:1,TransId:1,TransInspectionId:1,TransItemId:1,TransLbrId:1,TransLossId:1,TransPromoId:1,TransactionCalculateOn:1,TreeId:1,TreeItemId:1,TreeNo:1,TreeWeight:1,Type:1,UOM:1,UniqueCode:1,UnitCost:1,UnitLabor:1,UnitRate:1,Url:1,UserDescription:1,UserId:1,Value:1,VoucherNo:1,VoucherType:1,Vouchers:1,WastagePercentage:1,WastageWeight:1,Week:1,WeekAmount:1,Weight:1,WorkOrder:1,WstPer:1,WstWt:1},Finance:{AccountingPeriod:{Code:1,CompanyId:1,Details:1,FromDate:1,PeriodId:1,ToDate:1},AccountingPeriodDetails:{CompanyId:1,DetailId:1,IsClosed:1,PeriodId:1,TypeOfVoucher:1,VoucherTypeId:1,VoucherTypeName:1},Contra:{CompanyId:1,CurrencyId:1,Details:1,EnteredBy:1,ExchangeRate:1,FinancialYearId:1,InvoiceNo:1,LedgerId:1,LedgerName:1,Narration:1,Num1:1,Num2:1,Num3:1,RefDate:1,RefNo:1,String1:1,String2:1,String3:1,SuffixPrefixId:1,SysDate:1,TaxLedgerId:1,TotalAmount:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},ContraDetail:{Amount:1,ChequeDate:1,ChequeNo:1,ExchangeRateId:1,LedgerId:1,LedgerName:1,Mode:1,Num1:1,Num2:1,Num3:1,PartyType:1,String1:1,String2:1,String3:1,SysDate:1,TransDetailId:1,TransId:1},Expense:{CompanyId:1,CurrencyId:1,Details:1,EnteredBy:1,ExchangeRate:1,FinancialYearId:1,InvoiceNo:1,LedgerId:1,LedgerName:1,Narration:1,Num1:1,Num2:1,Num3:1,RefDate:1,RefNo:1,String1:1,String2:1,String3:1,SuffixPrefixId:1,SysDate:1,TaxAmount:1,TaxLedgerId:1,TotalAmount:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},ExpenseDetail:{Amount:1,ChequeDate:1,ChequeNo:1,ExchangeRateId:1,LedgerId:1,LedgerName:1,Mode:1,Num1:1,Num2:1,Num3:1,PartyType:1,String1:1,String2:1,String3:1,SysDate:1,TaxAmount:1,TaxId:1,TaxName:1,TransDetailsId:1,TransId:1},Journal:{CompanyId:1,CurrencyId:1,Details:1,EnteredBy:1,ExchangeRate:1,FinancialYearId:1,InvoiceNo:1,LedgerId:1,LedgerName:1,Narration:1,Num1:1,Num2:1,Num3:1,RefDate:1,RefNo:1,String1:1,String2:1,String3:1,SuffixPrefixId:1,SysDate:1,TaxLedgerId:1,TotalAmount:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},JournalDetail:{Amount:1,ChequeDate:1,ChequeNo:1,ExchangeRateId:1,LedgerId:1,LedgerName:1,Mode:1,Num1:1,Num2:1,Num3:1,PartyType:1,String1:1,String2:1,String3:1,SysDate:1,TransDetailsId:1,TransId:1},OpeningBalance:{Amount:1,AutoPosting:1,CCAmount:1,CompanyId:1,CurrencyId:1,ExchRate:1,FinancialYearId:1,IsPosted:1,LedgerName:1,OpeningBalanceTypeId:1,PartyId:1,PostingDate:1,Remark:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},PDCClearance:{AgainstId:1,Amount:1,ChequeDate:1,ChequeNo:1,CompanyId:1,CreatedBy:1,Details:1,Extra1:1,Extra2:1,ExtraDate:1,FinancialYearId:1,InvoiceNo:1,LedgerId:1,LedgerName:1,Narration:1,PDCTypeId:1,PDCVoucherNo:1,RefDate:1,RefNo:1,Status:1,TransDate:1,TransId:1,Type:1,VoucherNo:1,VoucherTypeId:1},PDCClearanceDetails:{AgainstId:1,Amount:1,ChequeDate:1,ChequeNo:1,CompanyId:1,CreatedBy:1,Extra1:1,Extra2:1,ExtraDate:1,FinancialYearId:1,InvoiceNo:1,LedgerId:1,LedgerName:1,Narration:1,RefDate:1,RefNo:1,RefTransId:1,Status:1,TransDate:1,TransDetailsId:1,TransId:1,Type:1,VoucherNo:1,VoucherTypeId:1},PDCPayable:{Amount:1,BankId:1,ChequeDate:1,ChequeNo:1,CompanyId:1,CreatedBy:1,Extra1:1,Extra2:1,ExtraDate:1,FinancialYearId:1,InvoiceNo:1,KnockOffTotal:1,LedgerName:1,Narration:1,PartyBalance:1,PartyId:1,RefDate:1,RefNo:1,Status:1,TransDate:1,TransId:1,VoucherNo:1,VoucherTypeId:1},PDCReceivable:{Amount:1,BankId:1,ChequeDate:1,ChequeNo:1,CompanyId:1,CreatedBy:1,Extra1:1,Extra2:1,ExtraDate:1,FinancialYearId:1,InvoiceNo:1,LedgerName:1,Narration:1,POSCustomerId:1,PartyId:1,RefDate:1,RefNo:1,RefVoucherNo:1,Status:1,TransDate:1,TransId:1,VoucherNo:1,VoucherTypeId:1},PartyBalance:{AgainstInvoiceNo:1,AgainstVoucherNo:1,AgainstVoucherTypeId:1,BalanceAmount:1,CCCredit:1,CCDebit:1,CheckRefund:1,CompanyId:1,Credit:1,CreditNote:1,CreditPeriod:1,Debit:1,DebitNote:1,Due:1,ExchangeRate:1,FinancialYearId:1,InvoiceNo:1,KnockOff:1,LedgerId:1,LedgerName:1,MCredit:1,MDebit:1,Num1:1,Num2:1,Num3:1,OverDueDays:1,POSCustomerId:1,PartyBalanceId:1,ReceivedAmount:1,RefTransId:1,ReferenceType:1,String1:1,String2:1,String3:1,SysDate:1,TotalAmount:1,TransDate:1,TransId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1},Payment:{Address1:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Details:1,EnteredBy:1,ExchangeRate:1,FinancialYearId:1,GstVat:1,InvoiceNo:1,KnockOffTotal:1,LedgerId:1,LedgerName:1,Narration:1,Num1:1,Num2:1,Num3:1,Pan:1,PartyBalance:1,Pincode:1,Rate:1,RefDate:1,RefNo:1,State:1,String1:1,String2:1,String3:1,SysDate:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TdsTotal:1,TotalAmount:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},PaymentDetails:{Amount:1,ChequeDate:1,ChequeNo:1,ExchangeRate:1,LedgerId:1,LedgerName:1,Mode:1,Num1:1,Num2:1,Num3:1,PartyType:1,RefNo:1,String1:1,String2:1,String3:1,SysDate:1,TaxAmount:1,TaxId:1,TaxName:1,TransDetailId:1,TransId:1},PeriodicClosing:{CompanyId:1,FinancialYear:1,PostingDate:1,SurplusAccountId:1,TransDate:1,TransId:1,VoucherNo:1,VoucherTypeId:1},Receipt:{Address1:1,BankId:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Details:1,EnteredBy:1,ExchangeRate:1,FinancialYearId:1,GstVat:1,InvoiceNo:1,KnockOffTotal:1,LedgerId:1,LedgerName:1,Narration:1,Num1:1,Num2:1,Num3:1,Pan:1,PartyBalance:1,Pincode:1,RefDate:1,RefNo:1,State:1,String1:1,String2:1,String3:1,SysDate:1,TotalAmount:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},ReceiptDetails:{Amount:1,ChequeDate:1,ChequeNo:1,ExchangeRateId:1,LedgerId:1,LedgerName:1,Mode:1,Num1:1,Num2:1,Num3:1,PartyType:1,RefNo:1,String1:1,String2:1,String3:1,SysDate:1,TransDetailId:1,TransId:1},ServiceInward:{Address1:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Details:1,ExchangeRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,InvoiceNo:1,KnockOffTotal:1,LedgerId:1,LedgerName:1,Narration:1,NetAmount:1,Num1:1,Num2:1,Num3:1,Pan:1,Pincode:1,Rate:1,RefDate:1,RefNo:1,State:1,String1:1,String2:1,String3:1,SysDate:1,TaxAmount:1,TaxDetails:1,TaxId:1,TaxLedgerId:1,TdsTotal:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},ServiceInwardDetails:{Amount:1,CategoryId:1,LedgerId:1,LedgerName:1,ServiceCode:1,ServiceId:1,TaxCode:1,TransDetailId:1,TransId:1},ServiceInwardTax:{B2CSType:1,CCTaxAmount:1,CentralTaxAmount:1,ECommGST:1,EligibilityForITC:1,HSN:1,InputRCMLedgerId:1,IntegratedTaxAmount:1,InvoiceType:1,LedgerId:1,LedgerName:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,PartyTax:1,ProductTypeId:1,ReverseCharge:1,State:1,StateTaxAmount:1,TaxAmount:1,TaxId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},ServiceOutward:{Address1:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Details:1,ExchangeRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,InvoiceNo:1,KnockOffTotal:1,LedgerId:1,LedgerName:1,Narration:1,NetAmount:1,Num1:1,Num2:1,Num3:1,Pan:1,Pincode:1,Rate:1,RefDate:1,RefNo:1,State:1,String1:1,String2:1,String3:1,SysDate:1,TaxAmount:1,TaxDetails:1,TaxId:1,TaxLedgerId:1,TdsTotal:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},ServiceOutwardDetails:{Amount:1,CategoryId:1,LedgerId:1,LedgerName:1,ServiceCode:1,ServiceId:1,TaxCode:1,TransDetailId:1,TransId:1},ServiceOutwardTax:{B2CSType:1,CCTaxAmount:1,CentralTaxAmount:1,ECommGST:1,EligibilityForITC:1,HSN:1,InputRCMLedgerId:1,IntegratedTaxAmount:1,InvoiceType:1,LedgerId:1,LedgerName:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,PartyTax:1,ProductTypeId:1,ReverseCharge:1,State:1,StateTaxAmount:1,TaxAmount:1,TaxId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1}},HR:{Attendance:{CompanyId:1,Details:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},AttendanceDetails:{Absent:1,DetailId:1,EmployeeCode:1,EmployeeId:1,EmployeeName:1,HalfDay:1,OnLeave:1,Present:1,TransDate:1,TransId:1},EmployeeAdvance:{Amount:1,ChequeDate:1,Chequenumber:1,CompanyId:1,Date:1,EmployeeId:1,Extra1:1,Extra2:1,ExtraDate:1,FinancialYearId:1,InvoiceNo:1,LedgerId:1,Narration:1,SalaryMonth:1,SuffixPrefixId:1,TransId:1,VoucherNo:1,VoucherTypeId:1},EmployeeQualification:{Code:1,Name:1,QualificationId:1},EmploymentType:{Code:1,EmploymentTypeId:1,Name:1},HolidayList:{Code:1,Description:1,EndDate:1,HolidayListId:1,Holidays:1,StartDate:1},Holidays:{Date:1,HolidayId:1,HolidayListId:1,HolidayName:1,Narration:1},IncomeTaxSlabDetails:{Condition:1,DetailsId:1,FromAmount:1,IncomeTaxSlabId:1,PerecentDeduction:1,ToAmount:1,Value:1},IncomeTaxSlabs:{AllowTaxExemption:1,Code:1,CompanyId:1,CurrencyId:1,EffectiveFrom:1,IncomeSlabId:1,IsDisabled:1,Narration:1,StdTaxExemption:1,TaxSlabDetails:1},LeaveAllocation:{EmployeeId:1,FromDate:1,LeaveAllocationId:1,LeaveTypeId:1,Leaves:1,ToDate:1},LeavePolicy:{LeavePolicyCode:1,LeavePolicyId:1,LeaveTypes:1},LeavePolicyDetails:{AllocatedDays:1,LeavePolicyDetailId:1,LeavePolicyId:1,LeaveTypeCode:1,LeaveTypeId:1},LeaveType:{AllowEncashment:1,AllowNegativeBalance:1,ApplicableAfter:1,EncashmentComponentId:1,FractionofDailySalaryPerLeave:1,Includeholidayswithinleavesasleaves:1,IsCarryForward:1,IsCompensatory:1,IsLeaveWithoutPay:1,IsOptional:1,IsPartiallyPaidLeaves:1,LeaveTypeCode:1,LeaveTypeId:1,MaxContinuosDays:1,MaxEncashmentDays:1,MaxLeavesAllowed:1},Payroll:{BranchId:1,CompanyId:1,CurrencyId:1,DepartmentId:1,DesignationId:1,Details:1,ExchRate:1,FinancialYearId:1,LedgerId:1,PayrollFrequency:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},PayrollDetails:{Absent:1,CompanyId:1,CompanyName:1,Deductions:1,DepartmentId:1,DeptName:1,DesignationId:1,DesignationName:1,DetailId:1,Earnings:1,EmployeeCode:1,EmployeeDetails:1,EmployeeId:1,EmployeeName:1,GrossSalary:1,HalfDay:1,NetSalary:1,OnLeave:1,Present:1,TaxAmount:1,TransId:1},PayrollEmployeeDetails:{Amount:1,Code:1,ComponentId:1,EmployeeDetailId:1,EmployeeId:1,Percentage:1,Type:1},PayrollPeriod:{FromDate:1,PayrollPeriodCode:1,PayrollPeriodId:1,ToDate:1},SalaryComponent:{Code:1,Narration:1,SalaryComponentId:1,Type:1},SalaryPackage:{Code:1,IsDisabled:1,Narration:1,PackageDetails:1,SalaryPackageId:1,TotalAmount:1},SalaryPackageDetails:{Amount:1,Code:1,ComponentId:1,Narration:1,Percentage:1,SalaryPackageDetailsId:1,SalaryPackageId:1,Type:1}},Inventory:{BranchIn:{AdditionalCharges:1,Authorize:1,AuthorizedBy:1,AuthorizedDate:1,AutoPosting:1,BillDate:1,BillNo:1,BranchId:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CompanyName:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,ItemDetails:1,NetAmount:1,NetWeight:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TaxDetails:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},BranchInBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},BranchInItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},BranchInLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},BranchInTax:{CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},BranchOut:{AdditionalCharges:1,AutoPosting:1,BaseItemTypeId:1,BillDate:1,BillNo:1,BranchId:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CompanyName:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,ItemDetails:1,NetAmount:1,NetWeight:1,Pieces:1,PostingDate:1,ProductItemImage:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TaxDetails:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},BranchOutBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},BranchOutItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},BranchOutLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},BranchOutTax:{CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},CertificationIssue:{AdditionalCharges:1,Address1:1,AutoPosting:1,BaseItemTypeId:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},CertificationIssueBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},CertificationIssueItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProcessId:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},CertificationReturn:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TaxDetails:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},CertificationReturnBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},CertificationReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProcessId:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},CertificationReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},ConvertToWIP:{AdditionalCharges:1,AddressId:1,AutoPosting:1,BagNo:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,ItemDetails:1,Line_No:1,NetAmount:1,NetWeight:1,Pieces:1,PostingDate:1,ProcessId:1,ProductItemImage:1,Remark:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,SubBagNo:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},ConvertToWIPBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ConvertToWIPItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefDepartmentId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubBagNo:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},LocationTransfer:{AdditionalCharges:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FromDepartmentId:1,FromDepartmentName:1,GrossAmount:1,IsPosted:1,ItemDetails:1,NetAmount:1,NetWeight:1,Pieces:1,PostingDate:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,ToDepartmentId:1,ToDepartmentName:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},LocationTransferBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},LocationTransferItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1},LotCreation:{AutoPosting:1,CommonItemDetails:1,CompanyId:1,Details:1,EmployeeId:1,FinancialYearId:1,IsPosted:1,PostingDate:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},LotCreationBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefStockBomId:1,RefTransBomId:1,Remarks:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransactionId:1,Weight:1},LotCreationDetails:{AckStatus:1,AllotedNetWeight:1,AllotedPieces:1,AllotedWeight:1,AttributeId:1,BagNo:1,BagStatus:1,BalanceNetWeight:1,BalancePieces:1,BalanceWeight:1,BrandId:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,GenerateLot:1,GrossAmount:1,GroupId:1,HasBom:1,Hsn:1,ImageName:1,ItemTypeId:1,ItemsDetails:1,KaratId:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,NewGrossWeight:1,NewNetWeight:1,NewPieces:1,NewProductCode:1,NewProductId:1,NewStoneWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,PureWeight:1,Purity:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefTransTypeId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SpecialRemark:1,StockId:1,StoneAmount:1,StonePieces:1,StoneWeight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},LotCreationItems:{AckStatus:1,AttributeId:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,FancyCharges:1,GrossAmount:1,GroupId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,PureWeight:1,Purity:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StonePieces:1,StoneRate:1,StoneWeight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TransItemId:1,TransactionId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1,__id:1},MRP:{AttributeId:1,DetailsId:1,DifferenceQuantity:1,FixedCode:1,InProcessQuantity:1,InStock:1,Maximum0:1,Maximum1:1,Maximum2:1,Minimum0:1,Minimum1:1,Minimum2:1,OrderQuantity:1,ProductCode:1,ProductId:1,TransId:1,UOM:1},MaterialPayment:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,Pan:1,PartyCode:1,PartyId:1,PostingDate:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1},MaterialPaymentItems:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StonePieces:1,StoneRate:1,StoneSizeId:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},MaterialReceipt:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,Pan:1,PartyCode:1,PartyId:1,PostingDate:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1},MaterialReceiptItems:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,Discount:1,GrossAmount:1,GroupId:1,GroupSieveId:1,GroupSieveName:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsConfigurable:1,IsCustomerItem:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherRate:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryId:1,StoneTable:1,Studded:1,SubCategoryId:1,SubCategoryName:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},MaterialRequest:{AdditionalCharges:1,Address1:1,BaseItemTypeId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,CompanyName:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,ItemDetails:1,NetAmount:1,NetWeight:1,PartyId:1,Pieces:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},MaterialRequestBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},MaterialRequestItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,GrossAmount:1,GroupSieveId:1,HSN:1,HasBom:1,ImageName:1,InStock:1,IsClosed:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StonePieces:1,StoneRate:1,StoneSizeId:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},MaterialReturn:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,Pan:1,PartyCode:1,PartyId:1,PostingDate:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1},MaterialReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,Discount:1,GrossAmount:1,GroupId:1,GroupSieveId:1,GroupSieveName:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsConfigurable:1,IsCustomerItem:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherRate:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryId:1,StoneTable:1,Studded:1,SubCategoryId:1,SubCategoryName:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},Melting:{AdditionalCharges:1,AddressId:1,AutoPosting:1,BaseItemTypeId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,IssuedAlloy:1,IssuedPureWeight:1,ItemDetails:1,KaratId:1,Loss:1,LossPercent:1,MetalColorId:1,NetAmount:1,NetWeight:1,OtherPieces:1,OtherWeight:1,Pieces:1,PostingDate:1,Purity:1,ReceivableWeight:1,ReceivedWeight:1,Remark:1,RequiredAlloy:1,RequiredAlloyTemp:1,RequiredPureWeight:1,ReturnDetails:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,StonePieces:1,Stoneweight:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},MeltingItems:{AckStatus:1,AlloyRequired:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CompanyId:1,ConversionFactor:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,GroupId:1,ImageName:1,ItemTypeId:1,Line_No:1,LotNo:1,NetWeight:1,OtherRate:1,Parts:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,ReceivableWeight:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SalesCostMethodId:1,SpecialRemark:1,StockAllocation:1,StoneRate:1,Studded:1,SubCategoryId:1,SubCategoryName:1,TransId:1,TransItemId:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},MeltingReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,GroupId:1,ImageName:1,ItemTypeId:1,KaratName:1,Line_No:1,LotNo:1,MetalColorName:1,NetWeight:1,OtherRate:1,Parts:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SalesCostMethodId:1,SpecialRemark:1,StockAllocation:1,StoneRate:1,Studded:1,SubCategoryId:1,SubCategoryName:1,TransId:1,TransItemId:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},Mixing:{AutoPosting:1,CompanyId:1,Details:1,EmployeeId:1,FinancialYearId:1,IsPosted:1,ItemsDetails:1,PostingDate:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},MixingDetails:{AckStatus:1,AttributeId:1,BagNo:1,BagStatus:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CompanyId:1,DeliveryDate:1,DepartmentId:1,GrossAmount:1,GroupId:1,HasBom:1,Hsn:1,ImageName:1,ItemTypeId:1,Lab:1,Line_No:1,LotNo:1,NetWeight:1,NewPieces:1,NewProductId:1,NewSKU:1,NewWeight:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefTransTypeId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,ShapeId:1,SieveId:1,SpecialRemark:1,StoneColorId:1,StoneSizeId:1,Studded:1,SubCategoryId:1,TransId:1,TransItemId:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},MixingItems:{AckStatus:1,AttributeId:1,BagNo:1,BagStatus:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HasBom:1,Hsn:1,ImageName:1,ItemTypeId:1,Lab:1,Line_No:1,LotNo:1,NetWeight:1,OtherRate:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneColorId:1,StoneRate:1,StoneSizeId:1,Studded:1,SubCategoryId:1,TransId:1,TransactionId:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},ReOrderDetails:{AttributeId:1,CategoryCode:1,CategoryId:1,DetailsId:1,FixedCode:1,Maximum0:1,Maximum1:1,Maximum2:1,Minimum0:1,Minimum1:1,Minimum2:1,ProductCode:1,ProductId:1,ProductTypeCode:1,ProductTypeId:1,SubCategoryCode:1,SubCategoryId:1,TransId:1,UOM:1,Validate:1},Rejection:{AdditionalCharges:1,AddressId:1,AutoPosting:1,BillDate:1,BillNo:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,ItemDetails:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RejectionType:1,Remark:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},RejectionBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},RejectionItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SKUGeneration:{AttributeIdSelected:1,AutoPosting:1,CompanyId:1,Details:1,EmployeeId:1,FinancialYearId:1,GenerateSKU:1,IsPosted:1,LineNoSelected:1,Markup:1,NoofSKU:1,Pieces:1,PostingDate:1,PrintingDetails:1,ProductIdSelected:1,SKUSelected:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},SKUItemBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefStockBomId:1,RefTransBomId:1,Remarks:1,SBomRate:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransactionId:1,Weight:1},SKUItems:{AckStatus:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StonePieces:1,StoneRate:1,StoneSizeId:1,StoneWeight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TransItemId:1,TransactionId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1,__id:1},SKULabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransLbrId:1,TransactionId:1,Weight:1,WstPer:1,WstWt:1},SKURepricing:{AttributeIdSelected:1,AutoPosting:1,CompanyId:1,Details:1,EmployeeId:1,FinancialYearId:1,GenerateSKU:1,IsPosted:1,Items:1,LineNoSelected:1,Markup:1,NoofSKU:1,Pieces:1,PostingDate:1,ProductIdSelected:1,SKUSelected:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},SKURepricingBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefStockBomId:1,RefTransBomId:1,Remarks:1,SBomRate:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransactionId:1,Weight:1},SKURepricingDetails:{AckStatus:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,GrossAmount:1,GroupId:1,GroupSieveId:1,Hallmark:1,HasBom:1,Hsn:1,ImageName:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,NewSKU:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockId:1,StoneAmount:1,StoneColorId:1,StonePieces:1,StoneSizeId:1,Stoneweight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SKURepricingDetailsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefStockBomId:1,RefTransBomId:1,Remarks:1,SBomRate:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},SKURepricingItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TaxCode:1,TransId:1,TransactionId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1,__id:1},SKURepricingLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransLbrId:1,TransactionId:1,Weight:1,WstPer:1,WstWt:1},SKUSplitting:{AutoPosting:1,CommonItemDetails:1,CompanyId:1,CurrencyId:1,Details:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,IsPosted:1,PostingDate:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},SKUSplittingBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefStockBomId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransactionId:1,Weight:1},SKUSplittingDetails:{AckStatus:1,AllotedNetWeight:1,AllotedPieces:1,AllotedWeight:1,AttributeId:1,BagNo:1,BagStatus:1,BalanceNetWeight:1,BalancePieces:1,BalanceWeight:1,BrandId:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,GenerateSKU:1,GrossAmount:1,GroupId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,ItemTypeId:1,ItemsDetails:1,KaratId:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,NewGrossWeight:1,NewNetWeight:1,NewProductCode:1,NewProductId:1,NewSKU:1,NewStoneWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,PureWeight:1,Purity:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefTransTypeId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SpecialRemark:1,StampId:1,StockId:1,StoneAmount:1,StonePieces:1,StoneWeight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SKUSplittingItems:{AckStatus:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,FancyCharges:1,GrossAmount:1,GroupId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,PurchaseCostMethodId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SalesCostMethodId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StonePieces:1,StoneRate:1,StoneWeight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TaxCode:1,TransItemId:1,TransactionId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1,__id:1},SKUSplittingLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransLbrId:1,TransactionId:1,Weight:1,WstPer:1,WstWt:1},SKUStockItem:{AckStatus:1,AttributeId:1,BagNo:1,BagStatus:1,BrandId:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HasBom:1,Hsn:1,ImageName:1,ItemTypeId:1,ItemsDetails:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,NewSKU:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockId:1,StoneAmount:1,StoneColorId:1,StonePieces:1,StoneSizeId:1,Stoneweight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SetItems:{AttributeId:1,ItemId:1,Line_No:1,ProductCode:1,ProductId:1,SKU:1,SetId:1,StockId:1},SetMaster:{Id:1,ItemDetails:1,SKU:1},Sorting:{AutoPosting:1,CategoryId:1,Clear:1,CompanyId:1,DetailItems:1,Details:1,EmployeeId:1,FinancialYearId:1,GenerateLot:1,IsPosted:1,ItemTypeId:1,LotNo:1,NetWeight:1,NewPieces:1,NewProductId:1,NewWeight:1,Pieces:1,PostingDate:1,ProductTypeId:1,QualityId:1,QualityName:1,Rate:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,StoneColorId:1,StoneColoreName:1,StoneSizeId:1,StoneSizeName:1,SubCategoryId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},SortingDetails:{AckStatus:1,AttributeId:1,BagNo:1,BagStatus:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CompanyId:1,DeliveryDate:1,DepartmentId:1,GrossAmount:1,GroupId:1,HasBom:1,Hsn:1,ImageName:1,ItemTypeId:1,ItemsDetails:1,Lab:1,Line_No:1,LotNo:1,NetWeight:1,NewPieces:1,NewProductId:1,NewSKU:1,NewWeight:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,QualityName:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,SpecialRemark:1,StoneColorId:1,StoneColoreName:1,StoneSizeId:1,StoneSizeName:1,Studded:1,SubCategoryId:1,TransId:1,TransItemId:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},SortingItems:{AckStatus:1,AttributeId:1,BagNo:1,BagStatus:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HasBom:1,Hsn:1,ImageName:1,ItemTypeId:1,Lab:1,Line_No:1,LotNo:1,NetWeight:1,OtherRate:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,QualityId:1,QualityName:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,SpecialRemark:1,StockAllocation:1,StoneColorId:1,StoneColoreName:1,StoneRate:1,StoneSizeId:1,StoneSizeName:1,Studded:1,SubCategoryId:1,TransItemId:1,TransactionId:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},StockAllocatedBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransactionId:1,Weight:1},StockAllocatedItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondPieces:1,DiamondWeight:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalColorId:1,MetalId:1,NetWeight:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,TransactionId:1,UserDescription:1,Weight:1,WstPer:1,WstWt:1},StockAllocation:{AutoPosting:1,CompanyId:1,EmployeeId:1,FinancialYearId:1,IsPosted:1,ItemDetails:1,NetWeight:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,Remark:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},StockAllocationItems:{AckStatus:1,AllocatedItems:1,AllocatedPieces:1,AllocatedWeight:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UserDescription:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},StockAllocationItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},StockEnquiry:{Attribute:1,AttributeId:1,BOMCategoryName:1,BOMDetails:1,BOMGroupSieveName:1,BOMKaratName:1,BOMMetalColorName:1,BOMPureWeight:1,BOMPurity:1,BOMQualityName:1,BOMShapeName:1,BOMSieveName:1,BOMStoneColoreName:1,BOMStoneSizeName:1,BOMSubCategoryName:1,BagNo:1,BomAmount:1,BomRate:1,BrandName:1,CalcOnId:1,CategoryName:1,CertificateNo:1,CollectionName:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DepartmentId:1,DeptName:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,ExportPieces:1,FinancialYearId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,HistoryDetails:1,Image1:1,Image2:1,Image3:1,ImageName:1,IsCustomerItem:1,ItemType:1,KaratName:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorName:1,MetalId:1,MetalName:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,POSCustomerId:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SKU:1,SetId:1,ShapeName:1,SieveName:1,StockAllocation:1,StockId:1,StoneAmount:1,StoneColoreName:1,StoneCuletCode:1,StoneCuletId:1,StoneCuletName:1,StoneCutCode:1,StoneCutId:1,StoneCutName:1,StoneDepth:1,StoneFluorescenceCode:1,StoneFluorescenceId:1,StoneFluorescenceName:1,StoneGirdleCode:1,StoneGirdleId:1,StoneGirdleName:1,StonePieces:1,StonePolishCode:1,StonePolishId:1,StonePolishName:1,StoneSizeName:1,StoneSymmetryCode:1,StoneSymmetryId:1,StoneSymmetryName:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryName:1,SuperTypeName:1,TaxCode:1,TransId:1,TransItemId:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1}},ItemFields:{Attribute:1,AttributeId:1,BrandCode:1,BrandId:1,BrandName:1,CategoryCode:1,CategoryId:1,CategoryName:1,CollectionCode:1,CollectionId:1,CollectionName:1,GroupSieveCode:1,GroupSieveId:1,GroupSieveName:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,KaratName:1,MetalCode:1,MetalColorCode:1,MetalColorId:1,MetalColorName:1,MetalId:1,MetalName:1,Num1:1,Num2:1,Num3:1,ProductSizeCode:1,ProductSizeId:1,ProductSizeName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,QualityCode:1,QualityId:1,QualityName:1,SettingName:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveCode:1,SieveId:1,SieveName:1,StampCode:1,StampId:1,StampName:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletCode:1,StoneCuletId:1,StoneCuletName:1,StoneCutCode:1,StoneCutId:1,StoneCutName:1,StoneDepth:1,StoneFluorescenceCode:1,StoneFluorescenceId:1,StoneFluorescenceName:1,StoneGirdleCode:1,StoneGirdleId:1,StoneGirdleName:1,StonePolishCode:1,StonePolishId:1,StonePolishName:1,StoneSizeCode:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryCode:1,StoneSymmetryId:1,StoneSymmetryName:1,StoneTable:1,String1:1,String2:1,String3:1,SubCategoryCode:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,SuperTypeName:1},JobWork:{JobWork:{AdditionalCharges:1,Address1:1,BillAddId:1,BillDate:1,BillNo:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DeliveryDate:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,ItemDetails:1,LedgerName:1,MaterialDetails:1,NetAmount:1,NetWeight:1,PartyCode:1,PartyId:1,Pieces:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},JobWorkBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},JobWorkItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HasBom:1,ImageName:1,IsDisabled:1,ItemReturn:1,ItemTypeId:1,KaratId:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,Status:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},JobWorkReturn:{AdditionalCharges:1,Address1:1,BillAddId:1,BillDate:1,BillNo:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,OrderType:1,PartyCode:1,PartyId:1,Pieces:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TaxDetails:1,TaxRegType:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},JobWorkReturnBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},JobWorkReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,Hallmark:1,HasBom:1,ImageName:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},JobWorkReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},JobWorkReturnTax:{CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1}},Master:{Camlytics:{ChannelId:1,CompanyId:1,Id:1,Url:1},CustomerCategory:{Code:1,Id:1,Name:1,NextLevel:1,UpgradeValue:1},Designation:{AdvanceAmount:1,DesignationId:1,DesignationName:1,Extra1:1,Extra2:1,ExtraDate:1,LeaveDays:1,Level:1,Narration:1},EmployeeDetails:{DepartmentId:1,DetailId:1,EmployeeId:1,EmployeeName:1},EmployeeMaster:{Address:1,BankAccountNumber:1,BankIfsc:1,BankName:1,BloodGroup:1,BranchCode:1,BranchName:1,CompanyId:1,CompanyName:1,DailyWage:1,DepartmentId:1,Departments:1,DesignationId:1,DesignationName:1,Dob:1,Email:1,EmployeeCode:1,EmployeeId:1,EmployeeName:1,EmploymentType:1,EsiNumber:1,Extra1:1,Extra2:1,ExtraDate:1,Gender:1,GrossSalary:1,IsDisabled:1,JoiningDate:1,LabourCardExpiryDate:1,LabourCardNumber:1,LeavePolicyId:1,ManagerId:1,MaritalStatus:1,MobileNumber:1,Narration:1,PanNumber:1,PassportExpiryDate:1,PassportNo:1,PfNumber:1,PhoneNumber:1,Qualification:1,ReportToId:1,SalaryPackageId:1,SalaryType:1,TerminationDate:1,VisaExpiryDate:1,VisaNumber:1},SalesPerson:{Address:1,BankAccountNumber:1,BankIfsc:1,BankName:1,BloodGroup:1,BranchCode:1,BranchName:1,CompanyId:1,DailyWage:1,DefaultPackageId:1,DepartmentId:1,DesignationId:1,Details:1,Dob:1,Email:1,EmployeeCode:1,EmployeeId:1,EmployeeName:1,EmploymentType:1,EsiNumber:1,Extra1:1,Extra2:1,ExtraDate:1,Gender:1,IsDisabled:1,JoiningDate:1,LabourCardExpiryDate:1,LabourCardNumber:1,ManagerId:1,MaritalStatus:1,MobileNumber:1,Narration:1,PanNumber:1,PassportExpiryDate:1,PassportNo:1,PfNumber:1,PhoneNumber:1,Qualification:1,ReportToId:1,SalaryType:1,TerminationDate:1,VisaExpiryDate:1,VisaNumber:1},TargetDistribution:{April:1,August:1,Code:1,December:1,February:1,January:1,July:1,June:1,March:1,May:1,November:1,October:1,September:1,TargetDistributionId:1}},OMS:{AccountGroup:{AccountGroupId:1,AccountGroupName:1,AffectGrossProfit:1,Balance:1,Flow:1,GroupUnder:1,IsDefault:1,Narration:1,Nature:1,Num1:1,Num2:1,Num3:1,Quarter1:1,Quarter2:1,Quarter3:1,Quarter4:1,String1:1,String2:1,String3:1,SysDate:1},AccountLedger:{AccountGroupId:1,AccountGroupName:1,AccountNo:1,BillbyBill:1,DefaultTDSType:1,IFSCCode:1,IsDisabled:1,LedgerId:1,LedgerName:1,MICRCode:1,MailingName:1,Nature:1,Num1:1,Num2:1,Num3:1,PartyCode:1,PartyType:1,String1:1,String2:1,String3:1,Swift:1,SysDate:1,TermId:1},AdditionalCharges:{AdditionalChargeCode:1,AdditionalChargeId:1,AdditionalChargeName:1,ApplicableOn:1,ExcludeDiscount:1,IncludeTax:1,Narration:1,ProductCalculateOn:1,Rate:1,RateType:1,TransactionCalculateOn:1,Vouchers:1},AdditionalChargesVouchers:{AdditionalChargeCode:1,AdditionalChargeId:1,AdditionalChargeName:1,ApplicableOn:1,DetailId:1,ProductCalculateOn:1,Rate:1,RateType:1,TransactionCalculateOn:1,VoucherTypeId:1},AddressMaster:{Address1:1,Address2:1,AddressId:1,AddressType:1,City:1,CityName:1,Country:1,CountryName:1,Default:1,LedgerId:1,Pincode:1,State:1,StateName:1},AttributeMaster:{AttributeCode:1,AttributeId:1,AttributeName:1,AttributeTypeId:1,FixedName:1,GroupSieveId:1,IsParent:1,MaxPurity:1,MinPurity:1,Num1:1,Num2:1,Num3:1,PurchaseFormula:1,SPGravity:1,SalesFormula:1,StdPurity:1,String1:1,String2:1,String3:1,Sys_Date:1},BrandMaster:{AttributeTypeId:1,BrandCode:1,BrandId:1,BrandName:1,Num1:1,Num2:1,Num3:1,String1:1,String2:1,String3:1,Sys_Date:1},CategoryMaster:{CategoryCode:1,CategoryId:1,CategoryName:1,Image:1,IsDisabled:1,IsSizeApplicable:1,ItemTypeId:1},CheckList:{CheckListId:1,CheckListName:1,CheckListType:1,CheckListTypeId:1},CitiesMaster:{Id:1,Name:1,StateId:1},CollectionMaster:{AttributeCode:1,AttributeId:1,AttributeName:1,AttributeTypeId:1,Num1:1,Num2:1,Num3:1,String1:1,String2:1,String3:1,Sys_Date:1},ColorQualityMapping:{Code:1,MappingId:1,QualityCode:1,QualityId:1,StoneColorCode:1,StoneColorId:1},Company:{Address:1,Address2:1,CST:1,City:1,CityName:1,CodeandName:1,CompanyCode:1,CompanyId:1,CompanyName:1,Country:1,CountryName:1,CurrencyId:1,CurrentDate:1,DiscountingPolicyId:1,EmailId:1,IsDefault:1,IsDisabled:1,IsLabourList:1,IsPriceList:1,LedgerId:1,Logo:1,MailingName:1,MarkUpPolicyId:1,Mobile:1,Num1:1,Num2:1,Num3:1,PAN:1,PLMarkup:1,PLabourListId:1,PMarkup:1,PPriceListId:1,ParentCompany:1,Phone:1,Pin:1,SLMarkup:1,SLabourListId:1,SMarkup:1,SPriceListId:1,State:1,StateName:1,String1:1,String2:1,String3:1,Sys_Date:1,TIN:1,TaxGroupId:1,TypeOfCompany:1,Web:1},ContactDetails:{AddtoZiFlow:1,Comment:1,ContactId:1,Decision:1,Designation:1,EmailId:1,FirstName:1,IsDefault:1,LastName:1,LedgerId:1,Manage:1,MobileNo:1,Phone:1,Share:1},CountriesMaster:{Id:1,Name:1,Nationality:1,Phonecode:1,ShortName:1},CurrencyMaster:{CurrencyId:1,CurrencyName:1,CurrencySymbol:1,Extra1:1,Extra2:1,ExtraDate:1,IsDefault:1,Narration:1,NoOfDecimalPlaces:1,SubunitName:1},Customer:{APIEndpoint:1,APIToken:1,AccountGroupId:1,AddressDetails:1,AutoCreateVoucherUsingAPI:1,AutoPosting:1,BillbyBill:1,Coef:1,ContactDetails:1,CostPricegroupId:1,CurrencyId:1,CustomerPrefix:1,Email:1,GstVat:1,IsDisabled:1,LbrAddDisc:1,LbrAddMkp:1,LbrFlag:1,LbrFromDate:1,LbrPricegroupId:1,LbrToDate:1,LedgerId:1,LedgerName:1,MailingName:1,MarkUpPolicyId:1,Nature:1,Num1:1,Num2:1,Num3:1,Pan:1,PartyCode:1,PartyType:1,StnAddDisc:1,StnAddMkp:1,StnFlag:1,StnFromDate:1,StnToDate:1,String1:1,String2:1,String3:1,SysDate:1,TaxRegType:1,TermId:1,Token:1},CustomerOrder:{AccountGroupId:1,BillbyBill:1,CostPricegroupId:1,DefaultTdsType:1,GstVat:1,IsDisabled:1,LbrAddDisc:1,LbrAddMkp:1,LbrFlag:1,LbrFromDate:1,LbrPricegroupId:1,LbrToDate:1,LedgerId:1,LedgerName:1,MailingName:1,Pan:1,PartyCode:1,PartyType:1,PartyTypeId:1,StnAddDisc:1,StnAddMkp:1,StnFlag:1,StnFromDate:1,StnToDate:1,Tan:1,TaxRegType:1,Tds:1,TermId:1},Denomination:{Code:1,DenominationId:1,Name:1},DepartmentMaster:{CompanyId:1,DepartmentTypeId:1,DeptCode:1,DeptId:1,DeptName:1,ItemTypeId:1,Narration:1,ParentDeptId:1,ProcessDetails:1,UserId:1},DepartmentProcessDetails:{DepartmentId:1,DeptName:1,DetailId:1,ProcessCode:1,ProcessId:1,ProcessName:1},Design:{Attribute:1,AttributeId:1,BOMDetails:1,BrandId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CollectionId:1,CreationDate:1,DesignCode:1,DesignId:1,DesignName:1,DiamondPieces:1,DiamondWeight:1,GroupSieveName:1,HasBom:1,Image1:1,Image2:1,Image3:1,Image4:1,Image5:1,Image6:1,Image7:1,Image8:1,ImageName:1,IsConfigurable:1,IsDisabled:1,ItemType:1,ItemTypeId:1,Iteration:1,KaratId:1,KaratName:1,MappingCode:1,MappingId:1,MaxPurity:1,MetalColorId:1,MetalColorName:1,MetalId:1,MinPurity:1,NetWeight:1,OtherPieces:1,OtherWeight:1,Parts:1,Pieces:1,ProductSizeId:1,ProductSizeName:1,ProductTypeId:1,ProductTypeName:1,Purity:1,QualityId:1,QualityName:1,Remarks:1,ServerDate:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,StdPurity:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,Video1:1,Video2:1,Volume:1,Volume1:1,Volume2:1,Weight:1,ZProofId:1},DesignBOM:{Attribute:1,BOMAttributeId:1,BOMDesignId:1,BomId:1,CalcOn:1,CalcOnId:1,CategoryCode:1,CategoryId:1,CenterStone:1,CostMethodId:1,DesignId:1,GroupSieveId:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,MetalColorId:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,Remarks:1,SettingId:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveId:1,StdPurity:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryCode:1,SubCategoryId:1,Sys_Date:1,Weight:1},DiscountingPolicy:{Code:1,CompanyId:1,Details:1,DiscountId:1,Name:1},DiscountingPolicyDetails:{CategoryCode:1,CategoryId:1,DiscountDetailId:1,DiscountId:1,DiscountType:1,MaxDiscountPercent:1,Priority:1,ProcessId:1,ProcessName:1,ProductTypeCode:1,ProductTypeId:1,SubCategoryCode:1,SubCategoryId:1},DocumentFormatMaster:{BranchWise:1,CounterWise:1,Format:1,IncrementBy:1,LastNumber:1,Lock:1,MaterialType:1,Noofzeroes:1,Num1:1,Num2:1,Num3:1,PrefillwithZero:1,Prefix:1,PrefixDate:1,ResetMonthly:1,ResetYearly:1,Separator:1,StartIndex:1,String1:1,String2:1,String3:1,Suffix:1,SuffixprefixId:1,Sys_Date:1,VoucherTypeId:1,VoucherTypeName:1},ExchangeRate:{CurrencyId:1,CurrencyName:1,ExchRate:1,ExchTypeId:1,ExchangeRateId:1,Extra1:1,Extra2:1,FixedName:1,FromDate:1,Narration:1,ToDate:1},FinancialYear:{FinancialYearCode:1,FinancialYearId:1,FromDate:1,Num1:1,Num2:1,Num3:1,String1:1,String2:1,String3:1,SysDate:1,ToDate:1},FixedCode:{FixedCode:1,FixedId:1,FixedName:1,FixedType:1,MasterName:1,Num1:1,Num2:1,Num3:1,String1:1,String2:1,String3:1,Sys_Date:1},FixedRateMaster:{Attribute:1,AttributeId:1,CategoryCode:1,CategoryName:1,CostId:1,FromDate:1,FromWt:1,ItemTypeId:1,ProductCode:1,ProductId:1,ProductTypeCode:1,ProductTypeName:1,PurchaseRate:1,SalesRate:1,SubCategoryCode:1,SubCategoryName:1,ToDate:1,ToWt:1},FormatMaster:{BranchWise:1,CounterWise:1,DesignPrefix:1,DesignPrefixEditor:1,DesignSuffix:1,DesignSuffixEditor:1,Format:1,FormatId:1,FormatType:1,IncrementBy:1,LastMonth:1,LastNumber:1,LastYear:1,Lock:1,Noofzeroes:1,Num1:1,Num2:1,Num3:1,PrefillwithZero:1,Prefix:1,PrefixCode:1,PrefixDate:1,ResetMonthly:1,ResetYearly:1,Separator:1,StartIndex:1,String1:1,String2:1,String3:1,Suffix:1,Sys_Date:1},GiftVoucherDetails:{GvDetailId:1,GvId:1,ProductApplicable:1},GiftVoucherMaster:{Active:1,Code:1,FixedName:1,GvId:1,GvType:1,MinInvoiceValue:1,PartialRedeem:1,ProdApp:1,ProductApplicable:1,Validity:1,Value:1},HSN:{Code:1,Description:1,Id:1,Name:1,Num1:1,Num2:1,Num3:1,RateApplied:1,String1:1,String2:1,String3:1,SysDate:1,TaxCode:1},HSNTaxDetails:{Code:1,DetailsId:1,GroupId:1,InputRCMLedgerId:1,IsInterState:1,LedgerId:1,OutputLedgerId:1,OutputRCMLedgerId:1,TaxId:1,TaxName:1,TaxRate:1},HsnTaxMaster:{Cess1Id:1,Cess1LedgerId:1,Cess2Id:1,Cess2LedgerId:1,CessId:1,CessLedgerId:1,Code:1,Description:1,Details:1,Num1:1,Num2:1,Num3:1,String1:1,String2:1,String3:1,SysDate:1,Tax1Id:1,Tax1LedgerId:1,Tax2Id:1,Tax2LedgerId:1,TaxGroup:1,TaxId:1,TaxLedgerId:1,Type:1},KaratRate:{AttributeId:1,CostId:1,FromDate:1,FromWt:1,ItemTypeId:1,KaratCode:1,KaratId:1,ProductId:1,ProductTypeId:1,ProductTypeName:1,PurStdRate:1,SaleStdRate:1,ToDate:1,ToWt:1},LabourMaster:{Attribute:1,AttributeId:1,BrandId:1,BrandName:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,CollectionName:1,FixedName:1,FromParts:1,FromWt:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,LabourId:1,LossPer:1,MaxLabour:1,MaxOrMin:1,MinLabour:1,Num1:1,Num2:1,Num3:1,ProcessId:1,ProcessName:1,ProcessTypeId:1,ProductTypeId:1,ProductTypeName:1,PurStdLabour:1,QualityId:1,RateType:1,SaleStdLabour:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,String1:1,String2:1,String3:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,SuperTypeName:1,Sys_Date:1,ToParts:1,ToWt:1},LabourPriceList:{FixedName:1,Narration:1,Num1:1,Num2:1,Num3:1,PriceCode:1,PriceListDetails:1,PriceName:1,PriceType:1,PricelistId:1,String1:1,String2:1,String3:1,Sys_Date:1},LabourPriceListDetails:{Amount:1,Attribute:1,AttributeId:1,BrandId:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,FromDate:1,FromWt:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,MarkUp:1,MinLabour:1,Num1:1,Num2:1,Num3:1,PriceListDetailsId:1,PriceListId:1,ProcessId:1,ProcessName:1,ProcessTypeId:1,ProductId:1,ProductTypeId:1,ProductTypeName:1,PurStdRate:1,QualityId:1,SaleStdRate:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,String1:1,String2:1,String3:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,Sys_Date:1,ToDate:1,ToWt:1},LedgerPosting:{AccountGroupId:1,Amount1:1,Amount2:1,Balance:1,Balance1:1,BaseItemTypeId:1,CBalance:1,CCCredit:1,CCDebit:1,ChequeDate:1,ChequeNo:1,CompanyId:1,Credit:1,CurrencyId:1,DBalance:1,Debit:1,DetailsId:1,DrCr:1,ExchangeRate:1,FinancialYearId:1,GroupName:1,InvoiceNo:1,LedgerId:1,LedgerName:1,LedgerPostingId:1,MCredit:1,MDebit:1,Nature:1,Num1:1,Num2:1,Num3:1,OpBalance:1,OpeningBalance:1,POSCustomerId:1,PartyCode:1,RefTransId:1,String1:1,String2:1,String3:1,Sys_Date:1,TransDate:1,TransId:1,VoucherNo:1,VoucherTypeId:1},MarkUpPolicy:{Charges:1,MarkUpPolicyCode:1,MarkUpPolicyId:1,MarkUpPolicyName:1},MarkupCharges:{BrandId:1,CategoryId:1,CollectionId:1,ItemType:1,ItemTypeId:1,KaratId:1,MarkUp:1,MarkUpPolicyId:1,MarkUpRateType:1,MarkUpType:1,MarkupChargesId:1,MetalColorId:1,ProcessId:1,ProductTypeCode:1,ProductTypeId:1,QualityId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SuperTypeId:1},MetalRateMaster:{CompanyId:1,CurrencyId:1,DailyRateId:1,FixedName:1,FromDate:1,IsSysParam:1,LossPercent:1,MetalTypeId:1,Num1:1,Num2:1,Num3:1,ProductTypeName:1,Rate:1,RateOn:1,RateTypeId:1,String1:1,String2:1,String3:1,Sys_Date:1,ToDate:1},MoldMaster:{Code:1,MoldId:1,Name:1,RackNo:1},OrderStatus:{AttributeCode:1,AttributeId:1,AttributeName:1,AttributeTypeId:1},Others:{Attribute:1,AttributeId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,HSN:1,IsDisabled:1,ItemTypeId:1,Num1:1,Num2:1,Num3:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,Rate:1,Remarks:1,ServerDate:1,String1:1,String2:1,String3:1,SubCategoryId:1,SubCategoryName:1,Sys_Date:1,TaxCode:1},PaymentMode:{AllowSelection:1,Code:1,CommissionAccount:1,CommissionPercent:1,FixedName:1,IsDisabled:1,LedgerId:1,LedgerName:1,ModeId:1,Name:1,Num1:1,Num2:1,OnlyForPos:1,String1:1,String2:1,SysDate:1,Type:1},PosCustomerMaster:{Address:1,AllowCredit:1,Anniversary:1,BirthDate:1,CityId:1,CityName:1,CountryId:1,CountryName:1,CreditLimit:1,Email:1,FirstName:1,Gender:1,GroupId:1,HomeBranchId:1,ImagePath:1,IsDisabled:1,LastName:1,MaritialStatus:1,Mobile:1,Mobile2:1,NationalityId:1,POSCustomerId:1,PanNumber:1,ParentId:1,Pin:1,PosCustomerCode:1,Prefix:1,RefId:1,ReligonId:1,StateId:1,StateName:1,TaxId:1,TelO:1,TelR:1},PriceList:{FixedName:1,ItemDetails:1,LaborDetails:1,Narration:1,Num1:1,Num2:1,Num3:1,PriceCode:1,PriceName:1,PriceType:1,PricelistId:1,RateDetails:1,String1:1,String2:1,String3:1,Sys_Date:1},PriceListDetails:{Amount:1,Attribute:1,AttributeId:1,BrandId:1,CategoryId:1,CategoryName:1,CollectionId:1,FromDate:1,FromWt:1,ItemListId:1,ItemTypeId:1,MarkUp:1,PriceListDetailsId:1,PriceListId:1,ProductId:1,ProductTypeId:1,ProductTypeName:1,PurStdRate:1,QualityId:1,SaleStdRate:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,ToDate:1,ToWt:1},ProcessApplicableDetails:{CalcOn:1,CalcOnId:1,ProcessId:1},ProcessInspection:{Id:1,IsNumeric:1,Max:1,Min:1,Parameter:1,ProcessId:1,TemplateId:1,Value:1},ProcessMaster:{CalcOnId:1,CalculateTo:1,FixedName:1,InspectionDetails:1,IsDisabled:1,IsSetting:1,ItemTypeId:1,Num1:1,Num2:1,Num3:1,ProcessApplicableDetails:1,ProcessCode:1,ProcessId:1,ProcessName:1,ProcessTypeId:1,QualityInspectionId:1,String1:1,String2:1,String3:1,SysParam:1,Sys_Date:1},ProductBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomId:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CategoryCode:1,CategoryId:1,CenterStone:1,CertificateNo:1,CostMethodId:1,GrossWeight:1,GroupSieveId:1,HSN:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Num1:1,Num2:1,Num3:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,Remarks:1,SettingId:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveId:1,StdPurity:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,String1:1,String2:1,String3:1,SubCategoryCode:1,SubCategoryId:1,Sys_Date:1,TaxCode:1,TextureId:1,Weight:1},ProductImages:{Image:1,Image1:1,Image2:1,Image3:1,ProductId:1,ProductImageId:1},ProductInspection:{Id:1,IsNumeric:1,Max:1,Min:1,Parameter:1,ProcessId:1,ProductId:1,TemplateId:1,Value:1},ProductMaster:{Attribute:1,AttributeId:1,BOMDetails:1,BrandId:1,BrandName:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CollectionId:1,CollectionName:1,CostId:1,CostMethodId:1,CreationDate:1,CreationVoucherId:1,DesignId:1,DiamondDiscountPercent:1,DiamondPieces:1,DiamondWeight:1,ForExchange:1,GroupSieveName:1,HSN:1,HasBom:1,Image1:1,Image2:1,Image3:1,Image4:1,Image5:1,Image6:1,Image7:1,Image8:1,ImageName:1,InspectionDetails:1,IsConfigurable:1,IsCustomerItem:1,IsDefaultSKU:1,IsDisabled:1,IsFeatured:1,IsNew:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,LaborDetails:1,LaborMarkup:1,MFAmount:1,MappingId:1,MaxPurity:1,MetalColorId:1,MetalColorName:1,MetalId:1,MetalName:1,MinPurity:1,MoldsDetails:1,NetWeight:1,OtherPieces:1,OtherWeight:1,ParentDesign:1,Parts:1,Pieces:1,PointerWeight:1,PriceMarkup:1,ProductCode:1,ProductEnquiryType:1,ProductId:1,ProductName:1,ProductPartyDetails:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PurchaseRate:1,Purity:1,QualityId:1,QualityInspectionId:1,QualityName:1,Rate:1,Remarks:1,SKU:1,SalesCostMethodId:1,SalesPrice:1,SalesRate:1,SequenceDetails:1,ServerDate:1,SettingId:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,StdPurity:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,SuperTypeName:1,TaxCode:1,UnitLabour:1,Variance:1,Video1:1,Video2:1,Volume:1,Volume1:1,Volume2:1,Weight:1},ProductMasterLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductId:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},ProductMolds:{Code:1,MoldId:1,Pcs:1,ProductId:1,ProductMoldId:1,RackNo:1},ProductPartyDetails:{DetailId:1,LedgerName:1,PartyCode:1,PartyId:1,ProductId:1,SKU:1},ProductSequence:{Complexity:1,DepartmentId:1,DeptName:1,Duration:1,Id:1,MaxLoss:1,Priority:1,ProcessId:1,ProcessName:1,ProductId:1,StdLoss:1},ProductSizeMaster:{CM:1,CategoryId:1,CategoryName:1,INCH:1,MM:1,Num1:1,Num2:1,Num3:1,ProductSizeCode:1,ProductSizeId:1,SizeType:1,String1:1,String2:1,String3:1,Sys_Date:1},ProductType:{HSN:1,ItemId:1,ItemTypeId:1,Narration:1,Num1:1,Num2:1,Num3:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,Purity:1,SalesCostMethodId:1,String1:1,String2:1,String3:1,Sys_Date:1,TaxCode:1},PromotionDetails:{ApplicableOn:1,CodeRequired:1,CompanyId:1,CompanyName:1,DiscountAmount:1,DiscountOn:1,DiscountPercentage:1,FreeProductId:1,FromDate:1,IsApproved:1,IsDisabled:1,MaximumRedeemCount:1,MinimumSalesAmount:1,PrdTypeId:1,ProductTypeId:1,ProductTypeName:1,PromoCode:1,PromoId:1,PromoName:1,PromotionDetailsId:1,ToDate:1},PromotionMaster:{ApplicableOn:1,ApprovedBy:1,CodeRequired:1,DiscountAmount:1,DiscountOn:1,DiscountPercentage:1,FreeProductId:1,FromDate:1,IsApproved:1,IsDisabled:1,MaximumRedeemCount:1,MinimumSalesAmount:1,PromoCode:1,PromoId:1,PromoName:1,PromoType:1,PromotionDetails:1,ToDate:1,VoucherCode:1},RateMaster:{Attribute:1,AttributeId:1,CategoryId:1,CategoryName:1,CostId:1,FromDate:1,FromWt:1,ItemTypeId:1,ProductId:1,ProductTypeId:1,ProductTypeName:1,PurStdRate:1,QualityId:1,QualityName:1,SaleStdRate:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,StoneColorId:1,StoneColoreName:1,StoneSizeId:1,StoneSizeName:1,SubCategoryId:1,SubCategoryName:1,ToDate:1,ToWt:1},RawMaterialMaster:{Attribute:1,AttributeId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CostId:1,CostMethodId:1,CreationDate:1,CreationVoucherId:1,ForExchange:1,GroupSieveId:1,HSN:1,HasBom:1,IsConfigurable:1,IsCustomerItem:1,IsDefaultSKU:1,IsDisabled:1,IsFeatured:1,IsNew:1,ItemType:1,ItemTypeId:1,KaratId:1,MetalColorId:1,MetalId:1,Num1:1,Num2:1,Num3:1,ParentDesign:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PurchaseRate:1,Purity:1,QualityId:1,Rate:1,Remarks:1,SKU:1,SalesCostMethodId:1,SalesPrice:1,SalesRate:1,ServerDate:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,String1:1,String2:1,String3:1,SubCategoryId:1,SubCategoryName:1,Sys_Date:1,TaxCode:1,Variance:1,Weight:1},ReasonStatus:{IsDefault:1,Notification:1,NotifyCustomer:1,ReasonStatusId:1,Type:1,TypeDescription:1,TypeId:1,TypeName:1,UpdateECommerce:1},RewardsDetails:{CategoryId:1,CategoryName:1,ProductTypeId:1,ProductTypeName:1,PurchasePoints:1,PurchaseValue:1,RDetailsId:1,RMasterId:1,SubCategoryId:1,SubCategoryName:1},RewardsMaster:{CustomerCategoryId:1,EmailPoints:1,ExchangeRate:1,MobilePoints:1,ProductWise:1,PurchaseValue:1,RMasterId:1,ReferencePoints:1,RewardCode:1,RewardsDetails:1},Role:{ItemDiscount:1,RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},ServicesMaster:{CategoryId:1,DefaultTdsType:1,ServiceCode:1,ServiceId:1,ServiceName:1,TaxCode:1},Settings:{Description:1,Id:1,Name:1,Num1:1,Num2:1,Num3:1,String1:1,String2:1,String3:1,Sys_Date:1,Type:1,Value:1},SieveSizeMapping:{Depth:1,FromWeight:1,Id:1,IsParent:1,Length:1,Parent:1,ParentId:1,ProductTypeId:1,Shape:1,ShapeId:1,Sieve:1,SieveId:1,Size:1,StoneSizeId:1,SubCategoryId:1,ToWeight:1,Width:1},StatesMaster:{CountryId:1,Id:1,StateName:1},SubCategoryDetails:{CategoryId:1,DetailId:1,SubCategoryCode:1,SubCategoryId:1,SubCategoryName:1},SubCategoryMaster:{CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CostMethodId:1,Details:1,FixedName:1,IsDisabled:1,ItemTypeId:1,PointerWeight:1,SubCategoryCode:1,SubCategoryId:1,SubCategoryName:1},TargetMaster:{Amount:1,AprilAchieved:1,AprilTarget:1,AugustAchieved:1,AugustTarget:1,BaseItemTypeId:1,DecemberAchieved:1,DecemberTarget:1,EmployeeId:1,EmployeeName:1,FebruaryAchieved:1,FebruaryTarget:1,FinancialYearId:1,JanuaryAchieved:1,JanuaryTarget:1,JulyAchieved:1,JulyTarget:1,JuneAchieved:1,JuneTarget:1,MarchAchieved:1,MarchTarget:1,MayAchieved:1,MayTarget:1,NovemberAchieved:1,NovemberTarget:1,Num1:1,Num2:1,Num3:1,OctoberAchieved:1,OctoberTarget:1,ProductTypeName:1,Quantity:1,SeptemberAchieved:1,SeptemberTarget:1,String1:1,String2:1,String3:1,Sys_Date:1,TargetDistributionId:1,TargetId:1,UserId:1},Tax:{ApplicableOn:1,CalculatingMode:1,CumulativeTrans:1,FixedName:1,GroupId:1,HasThreshold:1,InputRCMLedgerId:1,IsDisabled:1,ItemDetails:1,LedgerId:1,Narration:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductType:1,Rate:1,SingleTrans:1,TaxId:1,TaxName:1,TaxType:1,ThresholdValue:1},TaxDetails:{GroupId:1,Num1:1,Num2:1,Num3:1,SelectedtaxId:1,String1:1,String2:1,String3:1,Sys_Date:1,TaxId:1,TaxName:1,TaxdetailsId:1},TaxItemDetails:{BaseItemTypeId:1,GroupId:1,TaxId:1,TaxItemDetailsId:1},TaxRateHistory:{Date:1,Rate:1,TaxId:1},ToDoMaster:{Completed:1,Description:1,EndDate:1,FixedName:1,Num1:1,Num2:1,Num3:1,StartDate:1,String1:1,String2:1,String3:1,SysDate:1,TaskTypeId:1,ToDoId:1,UserId:1,Username:1},User:{AuthPassword:1,Branch:1,CatalogueAccessPassword:1,CompanyId:1,Department:1,DisplayName:1,EditPassword:1,Email:1,FinYear:1,HasAuth:1,HasCatalogueAccess:1,HasEdit:1,InsertDate:1,InsertUserId:1,IsActive:1,ItemDiscount:1,LastDirectoryUpdate:1,PartyId:1,Password:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,Source:1,Type:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserImage:1,Username:1},UserDetails:{CompanyId:1,DepartmentId:1,RackId:1,UserId:1,UserdetailsId:1,Username:1},Vendor:{APIEndpoint:1,APIToken:1,AccountGroupId:1,AddressDetails:1,AutoCreateVoucherUsingAPI:1,AutoPosting:1,BillbyBill:1,ContactDetails:1,CostPricegroupId:1,CurrencyId:1,GstVat:1,IsDisabled:1,LbrAddDisc:1,LbrAddMkp:1,LbrFlag:1,LbrFromDate:1,LbrPricegroupId:1,LbrToDate:1,LedgerId:1,LedgerName:1,MailingName:1,Nature:1,Num1:1,Num2:1,Num3:1,Pan:1,PartyCode:1,PartyType:1,StnAddDisc:1,StnAddMkp:1,StnFlag:1,StnFromDate:1,StnToDate:1,String1:1,String2:1,String3:1,SysDate:1,TaxRegType:1,TermId:1,Token:1},VoucherMaster:{AllowBackDatedEntry:1,AutoPosting:1,BranchWise:1,CounterWise:1,Declaration:1,DefaultJewelleryDepartment:1,DefaultMetalDepartment:1,DefaultOthersDepartment:1,DefaultStoneDepartment:1,Details:1,Format:1,Heading1:1,Heading2:1,Heading3:1,Heading4:1,IncrementBy:1,IsDefault:1,IsDisabled:1,IsTaxApplicable:1,LastNumber:1,LedgerId:1,Lock:1,MasterId:1,MaterialType:1,MenuId:1,MethodOfVoucherNumbering:1,Narration:1,Noofzeroes:1,Num1:1,Num2:1,Num3:1,PrefillwithZero:1,Prefix:1,PrefixDate:1,ResetMonthly:1,ResetYearly:1,Separator:1,StockUpdateMode:1,String1:1,String2:1,String3:1,Suffix:1,Sys_Date:1,Terms:1,TypeOfVoucher:1,VoucherCode:1,VoucherTypeId:1,VoucherTypeName:1},VoucherTaxDetails:{DetailsId:1,GroupId:1,IsInterState:1,TaxId:1,TaxName:1,TaxRate:1,TaxType:1,VoucherTypeId:1}},OpeningStock:{OpeningStock:{AdditionalCharges:1,AutoPosting:1,BaseItemTypeId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GSTState:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,Remark:1,ShipAddressId:1,ShipmentId:1,Shrt:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},OpeningStockItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,ParentDesign:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},OpeningStockItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},OpeningStockLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1}},ProductDevelopment:{CustomerRequirement:{AdditionalCharges:1,Address1:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,ProductItemImage:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},CustomerRequirementBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},CustomerRequirementItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,Budget:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CenterStone:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,DualToneKarat:1,DualToneKaratId:1,DualToneMetalColorId:1,DualToneMetalId:1,DualTonePurity:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,Image1:1,Image2:1,Image3:1,Image4:1,Image5:1,ImageName:1,IsDisabled:1,ItemTypeId:1,Iteration:1,KaratId:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MappingId:1,MetalAmount:1,MetalColorId:1,MetalId:1,MetalName:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StatusId:1,StockAllocation:1,StoneAmount:1,StoneCategoryId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StoneItems:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSubCategoryId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,ToneType:1,TransId:1,TransItemId:1,TripleToneKarat:1,TripleToneKaratId:1,TripleToneMetalColorId:1,TripleToneMetalId:1,TripleTonePurity:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,UserId:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},CustomerRequirementStoneItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDetailId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},DesignRequest:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,Code:1,CollectionId:1,CompanyId:1,CostMethodId:1,CustomerPrefix:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DesignName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,Image1:1,Image2:1,Image3:1,ImageName:1,IsDisabled:1,IsSmartStone:1,IsSubmitted:1,ItemTypeId:1,Iteration:1,KaratCode:1,KaratId:1,KaratName:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MappingId:1,MetalAmount:1,MetalColorCode:1,MetalColorId:1,MetalColorName:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductSizeName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1,ZProofId:1},DesignRequestBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CategoryCode:1,CategoryId:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalColorId:1,MetalColorName:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,SettingName:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveId:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSizeName:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryCode:1,SubCategoryId:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},PDInterface:{AdditionalCharges:1,AddressId:1,BillDate:1,BillNo:1,CcGrossAmount:1,CcNetAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,CustomerRequirements:1,Designing:1,Discount:1,ECommOrderId:1,ECommOrderNo:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,POSCustomerId:1,PartyId:1,Pieces:1,PosCustomerCode:1,Quotations:1,ReasonId:1,ReceiptAmount:1,RefVoucherId:1,Remark:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,SpecSheets:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},PDQuotation:{AdditionalCharges:1,Address1:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsApproved:1,IsSubmitted:1,ItemDetails:1,LedgerName:1,MarkUpPolicyId:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PriceListId:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},PDQuotationAdditionalCharges:{AdditionalChargeCode:1,AdditionalChargeId:1,AdditionalChargeName:1,Amount:1,ApplicableOn:1,Chargeable:1,ProductCalculateOn:1,Rate:1,RateType:1,TransChargesId:1,TransItemId:1},PDQuotationBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalColorId:1,MetalColorName:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SettingId:1,SettingName:1,ShapeId:1,ShapeName:1,SieveId:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSizeName:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Volume:1,Weight:1},PDQuotationItems:{AckStatus:1,AdditionalAmount:1,AdditionalCharges:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DesignName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,Image1:1,Image2:1,Image3:1,ImageName:1,IsDisabled:1,ItemType:1,ItemTypeId:1,Iteration:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorCode:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StatusId:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,Video1:1,Video2:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},PDQuotationLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},RequirementItems:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,BrandId:1,Budget:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CenterStone:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,DualToneKarat:1,DualToneKaratId:1,DualToneMetalColorId:1,DualToneMetalId:1,DualTonePurity:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,Image1:1,Image2:1,Image3:1,Image4:1,Image5:1,ImageName:1,IsDisabled:1,ItemTypeId:1,Iteration:1,KaratId:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MappingId:1,MetalAmount:1,MetalColorId:1,MetalId:1,MetalName:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StatusId:1,StockAllocation:1,StoneAmount:1,StoneCategoryId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StoneItems:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSubCategoryId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,ToneType:1,TransId:1,TransItemId:1,TripleToneKarat:1,TripleToneKaratId:1,TripleToneMetalColorId:1,TripleToneMetalId:1,TripleTonePurity:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,UserId:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},RequirementStoneItems:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDetailId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SpecSheet:{AdditionalCharges:1,Address1:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsApproved:1,IsSubmitted:1,ItemDetails:1,LedgerName:1,MarkUpPolicyId:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PriceListId:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},SpecSheetBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,DesignId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SettingId:1,SettingName:1,ShapeId:1,ShapeName:1,SieveId:1,StoneColorId:1,StoneColoreName:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSizeName:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Volume:1,Weight:1},SpecSheetItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DesignName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HUID:1,HasBom:1,Image1:1,Image2:1,Image3:1,Image4:1,Image5:1,Image6:1,Image7:1,Image8:1,ImageName:1,IsDisabled:1,ItemType:1,ItemTypeId:1,Iteration:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StatusId:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,Video1:1,Video2:1,Volume:1,Volume1:1,Volume2:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SpecSheetLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},StageMembers:{Comment:1,Decision:1,Email:1,Manage:1,MemberName:1,MemeberId:1,Share:1,StageId:1},Stages:{AllowPrivateComment:1,AllowPublicComment:1,Members:1,Narration:1,SendEmail:1,StageId:1,StageName:1}},Production:{Dismantling:{AdditionalCharges:1,AutoPosting:1,CompanyId:1,CurrencyId:1,DiamondPieces:1,DiamondWeight:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,ItemDetails:1,NetAmount:1,NetWeight:1,OtherPieces:1,OtherWeight:1,Pieces:1,PostingDate:1,ProductItemImage:1,Remark:1,Roundoff:1,StonePieces:1,StoneWeight:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},DismantlingBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BagNo:1,BomAmount:1,BomRate:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,LotNo:1,Markup:1,MetalColorId:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TransBomId:1,TransItemId:1,Weight:1},DismantlingItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefDepartmentId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubBagNo:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},DismantlingReturn:{AutoPosting:1,CompanyId:1,EmployeeId:1,FinancialYearId:1,IsPosted:1,ItemDetails:1,NetWeight:1,Pieces:1,PostingDate:1,ProductItemImage:1,Remark:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},DismantlingReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,BrandId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LossPieces:1,LossWeight:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,ReceivedPieces:1,ReceivedWeight:1,RefDepartmentId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubBagNo:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},IssueMaterial:{AutoPosting:1,BagNo:1,CompanyId:1,DepartmentId:1,Details:1,EmployeeId:1,FinancialYearId:1,ImageName:1,IsPosted:1,Line_No:1,Pieces:1,PostingDate:1,ProductCode:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},IssueMaterialDetails:{Attribute:1,AttributeId:1,BagNo:1,CompanyId:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,FinancialYearId:1,ItemDetails:1,Line_No:1,NetWeight:1,OtherPieces:1,OtherWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,RefTransDetailId:1,RefTransId:1,RefVoucherId:1,RequiredPieces:1,RequiredWeight:1,SKU:1,StonePieces:1,StoneWeight:1,SubBagNo:1,TransDate:1,TransDetailId:1,TransId:1,VoucherTypeId:1,Weight:1},IssueMaterialItems:{Amount:1,Attribute:1,AttributeId:1,BagNo:1,CalcOnId:1,CertificateNo:1,DeliveryDate:1,DepartmentId:1,HSN:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Line_No:1,LotNo:1,MetalColorId:1,MetalColorName:1,NetWeight:1,OldBagNo:1,OldLineNo:1,OrderPieces:1,OrderWeight:1,ParentAttributeId:1,ParentMetalId:1,Pieces:1,ProductCode:1,ProductId:1,ProductTypeId:1,PureWeight:1,Purity:1,QualityCode:1,QualityName:1,Rate:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SKU:1,SettingId:1,SettingName:1,ShapeCode:1,ShapeName:1,SieveCode:1,SieveName:1,StockAllocation:1,StockDepartmentId:1,StoneColorCode:1,StoneColoreName:1,StoneSizeCode:1,StoneSizeName:1,StoneStatusId:1,StoneStatusName:1,SubBagNo:1,TaxCode:1,TransDate:1,TransDetailId:1,TransId:1,TransItemId:1,VoucherNo:1,Weight:1},JWReceiptInspectionValues:{ExpectedValue:1,InspectedValue:1,Max:1,Min:1,Parameter:1,Remark:1,Status:1,TransInspectionId:1,TransItemId:1},JobWorkIssue:{CompanyId:1,DepartmentId:1,EmployeeId:1,FinancialYearId:1,ItemDetails:1,LedgerName:1,PartyId:1,RefTransId:1,RefVoucherId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},JobWorkIssueBOM:{Attribute:1,AttributeId:1,BagNo:1,BomProductId:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,FromDeptId:1,FromWorkerId:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,Markup:1,MetalColorId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SettingId:1,SettingName:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneStatusName:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,ToDeptId:1,ToWorkerId:1,TransBomId:1,TransId:1,TransItemId:1,Weight:1},JobWorkIssueItems:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,CategoryName:1,CertificateNo:1,CompanyId:1,CustomerName:1,DepartmentId:1,EndDateTime:1,FinancialYearId:1,FromDeptId:1,FromNetWeight:1,FromPieces:1,FromWeight:1,FromWorkerId:1,GroupSieveId:1,Hallmark:1,HasBom:1,IsDisabled:1,KaratId:1,Lab:1,Line_No:1,Loss:1,LossPercent:1,LotNo:1,MetalColorId:1,NewBOMDetails:1,OrderNo:1,OrderTransId:1,OrderTransItemId:1,OrderTypeId:1,Parts:1,PartyId:1,ProductCode:1,ProductId:1,ProductSizeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remarks:1,ShapeId:1,SieveId:1,StartDateTime:1,StockAllocation:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,SubBagNo:1,SubCategoryName:1,TransDate:1,TransId:1,TransItemId:1,TreeId:1,TreeItemId:1,TreeNo:1,UserId:1,VoucherNo:1,VoucherTypeId:1},JobWorkReceipt:{CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,CompanyId:1,CurrencyId:1,DepartmentId:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,PartyId:1,Pieces:1,RefTransId:1,RefVoucherId:1,RoundOff:1,TaxAmount:1,TaxDetails:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},JobWorkReceiptBOM:{Attribute:1,AttributeId:1,BagNo:1,BomAmount:1,BomProductId:1,BomRate:1,CalcOn:1,CalcOnId:1,CategoryId:1,CategoryName:1,CertificateNo:1,GroupSieveId:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,Markup:1,MetalColorId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SettingId:1,SettingName:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TransBomId:1,TransId:1,TransItemId:1,Weight:1},JobWorkReceiptItems:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,CompanyId:1,CustomerName:1,DepartmentId:1,EndDateTime:1,FinancialYearId:1,FromDeptId:1,FromNetWeight:1,FromPieces:1,FromWeight:1,FromWorkerId:1,KaratId:1,LaborDetails:1,Line_No:1,Loss:1,LossPercent:1,LotNo:1,MetalId:1,NewBOMDetails:1,OrderNo:1,OrderTransId:1,OrderTransItemId:1,OrderTypeId:1,Parts:1,ProcessId:1,ProductCode:1,ProductId:1,PureWeight:1,Purity:1,QualityInspection:1,QualityInspectionValue:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,StartDateTime:1,StockAllocation:1,SubBagNo:1,TransDate:1,TransId:1,TransItemId:1,TreeId:1,TreeItemId:1,TreeNo:1,UserId:1,VoucherNo:1,VoucherTypeId:1},JobWorkReceiptLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},JobWorkReceiptTax:{CCTaxAmount:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},JobWorkSettlement:{CompanyId:1,CurrencyId:1,Details:1,ExchRate:1,FinancialYearId:1,KnockOff:1,LedgerName:1,PartyId:1,ProductTypeId:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},JobWorkSettlementDetails:{Amount:1,KnockOff:1,ProductId:1,ProductTypeCode:1,ProductTypeId:1,PureWeight:1,Rate:1,TransDetailId:1,TransId:1,Type:1},MFGInspectionValues:{ExpectedValue:1,InspectedValue:1,Max:1,Min:1,Parameter:1,Remark:1,Status:1,TransInspectionId:1,TransItemId:1},MFGTransaction:{DepartmentId:1,EmployeeId:1,ItemDetails:1,RefTransId:1,RefVoucherId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},MFGTransactionBOM:{Attribute:1,AttributeId:1,BagNo:1,BomProductId:1,CalcOnId:1,CategoryId:1,CertificateNo:1,FromDeptId:1,FromWorkerId:1,IsCustomerItem:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,Markup:1,MetalColorId:1,Pieces:1,ProductCode:1,ProductId:1,ProductTypeId:1,PureWeight:1,Purity:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SettingId:1,SettingName:1,StoneStatusId:1,StoneStatusName:1,ToDeptId:1,ToWorkerId:1,TransBomId:1,TransId:1,TransItemId:1,Weight:1},MFGTransactionItems:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,Button:1,CompanyId:1,DepartmentId:1,EndDateTime:1,FinancialYearId:1,FromDeptId:1,FromDiamondPieces:1,FromDiamondWeight:1,FromNetWeight:1,FromOtherPieces:1,FromOtherWeight:1,FromPieces:1,FromProcessId:1,FromStonePieces:1,FromStoneWeight:1,FromWeight:1,FromWorkerId:1,ImageName:1,KaratId:1,Line_No:1,Loss:1,LossDetails:1,LossPercent:1,LotNo:1,MetalColorId:1,MetalId:1,OrderTransId:1,OrderTransItemId:1,OrderTypeId:1,Parts:1,ProductCode:1,ProductId:1,ProductItemImage:1,PureWeight:1,Purity:1,QualityInspection:1,QualityInspectionValue:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,StartDateTime:1,StockAllocation:1,SubBagNo:1,ToDeptId:1,ToDiamondPieces:1,ToDiamondWeight:1,ToNetWeight:1,ToOtherPieces:1,ToOtherWeight:1,ToPieces:1,ToProcessId:1,ToStonePieces:1,ToStoneWeight:1,ToWeight:1,ToWorkerId:1,TransDate:1,TransId:1,TransItemId:1,TreeId:1,TreeItemId:1,TreeNo:1,UserId:1,VoucherNo:1,VoucherTypeId:1},MFGTransactionLoss:{Attribute:1,AttributeId:1,BagNo:1,BomProductId:1,CalcOnId:1,CertificateNo:1,FromDeptId:1,FromWorkerId:1,IsCustomerItem:1,ItemTypeId:1,Line_No:1,LotNo:1,Pieces:1,ProductCode:1,ProductId:1,PureWeight:1,Purity:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,ToDeptId:1,ToWorkerId:1,TransId:1,TransItemId:1,TransLossId:1,Weight:1},Merging:{BagNo:1,CompanyId:1,DepartmentId:1,Details:1,EachSubBagParts:1,EachSubBagPieces:1,EmployeeId:1,FinancialYearId:1,NoOfSubBag:1,Parts:1,Pieces:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},MergingBOM:{AttributeId:1,BagNo:1,BomProductId:1,CalcOnId:1,CertificateNo:1,CompanyId:1,FinancialYearId:1,IsCustomerItem:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,Markup:1,MetalColorId:1,Pieces:1,ProductId:1,PureWeight:1,Purity:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SettingId:1,SettingName:1,StoneStatusId:1,StoneStatusName:1,TransBomId:1,TransId:1,TransItemId:1,UserId:1,Weight:1},MergingItems:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,CalcOnId:1,DeliveryDate:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,EmployeeId:1,HasBom:1,ItemTypeId:1,KaratId:1,LedgerName:1,Line_No:1,LotNo:1,MetalColorId:1,NetWeight:1,OrderTypeId:1,OtherPieces:1,OtherWeight:1,POSCustomerId:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,PureWeight:1,Purity:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RefVoucherNo:1,StockAllocation:1,StonePieces:1,StoneWeight:1,SubBagNo:1,TransDate:1,TransId:1,TransItemId:1,TreeId:1,TreeItemId:1,TreeNo:1,UserId:1,VoucherNo:1,Weight:1},Production:{CompanyId:1,DepartmentId:1,EmployeeId:1,FinancialYearId:1,ItemDetails:1,ProcessId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},ProductionBOM:{Attribute:1,AttributeId:1,BagNo:1,BomAmount:1,BomProductId:1,BomRate:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,Markup:1,MetalColorId:1,Pieces:1,ProductCode:1,ProductId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SettingId:1,SettingName:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneStatusName:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TransBomId:1,TransId:1,TransItemId:1,Weight:1},ProductionItems:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,CalcOnId:1,CertificateNo:1,CompanyId:1,CustomerName:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,EndDateTime:1,FinancialYearId:1,HasBom:1,ItemTypeId:1,KaratId:1,Line_No:1,Loss:1,LossPercent:1,LotNo:1,MetalId:1,NetWeight:1,OrderNo:1,OrderTransId:1,OrderTransItemId:1,OrderTypeId:1,OtherPieces:1,OtherWeight:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,PureWeight:1,Purity:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,StartDateTime:1,StockAllocation:1,StonePieces:1,StoneWeight:1,SubBagNo:1,TransDate:1,TransId:1,TransItemId:1,TreeId:1,TreeItemId:1,TreeNo:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},QualityInspection:{EmployeeId:1,Items:1,RefTransId:1,RefVoucherId:1,RefVoucherNo:1,TransDate:1,TransId:1,UserId:1},QualityInspectionItems:{AttributeId:1,BagNo:1,DepartmentId:1,DeptName:1,EmployeeName:1,ProcessId:1,ProcessName:1,ProductCode:1,ProductId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RefVoucherNo:1,Status:1,TransDate:1,TransId:1,TransItemId:1,Values:1,WorkerId:1},QualityInspectionValues:{ExpectedValue:1,InspectedValue:1,Max:1,Min:1,Parameter:1,Remark:1,Status:1,TransInspectionId:1,TransItemId:1},ReceiptMaterial:{BagNo:1,CompanyId:1,DepartmentId:1,Details:1,EmployeeId:1,FinancialYearId:1,ImageName:1,Line_No:1,Pieces:1,ProductCode:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},ReceiptMaterialDetails:{Attribute:1,AttributeId:1,BagNo:1,CompanyId:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,FinancialYearId:1,ItemDetails:1,Line_No:1,NetWeight:1,OtherPieces:1,OtherWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,RefTransDetailId:1,RefTransId:1,RefVoucherId:1,SKU:1,StonePieces:1,StoneWeight:1,SubBagNo:1,TransDate:1,TransDetailId:1,TransId:1,VoucherTypeId:1,Weight:1},ReceiptMaterialItems:{Amount:1,Attribute:1,AttributeId:1,BagNo:1,CalcOnId:1,CertificateNo:1,DeliveryDate:1,DepartmentId:1,HSN:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Line_No:1,LotNo:1,MetalColorId:1,MetalColorName:1,NetWeight:1,OldBagNo:1,OldLineNo:1,Pieces:1,ProductCode:1,ProductId:1,ProductTypeId:1,PureWeight:1,Purity:1,QualityName:1,Rate:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SKU:1,SettingId:1,SettingName:1,ShapeName:1,SieveName:1,StockAllocation:1,StoneColoreName:1,StoneSizeName:1,StoneStatusId:1,SubBagNo:1,TaxCode:1,ToAttributeId:1,ToProductId:1,TransDate:1,TransDetailId:1,TransId:1,TransItemId:1,VoucherNo:1,Weight:1},Splitting:{BagNo:1,CompanyId:1,Details:1,EachSubBagParts:1,EachSubBagPieces:1,EmployeeId:1,FinancialYearId:1,NoOfSubBag:1,Parts:1,Pieces:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},SplittingBOM:{AttributeId:1,BagNo:1,BomProductId:1,CalcOnId:1,CertificateNo:1,CompanyId:1,FinancialYearId:1,IsCustomerItem:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,Markup:1,MetalColorId:1,Pieces:1,ProductId:1,PureWeight:1,Purity:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SettingId:1,SettingName:1,StoneStatusId:1,StoneStatusName:1,TransBomId:1,TransId:1,TransItemId:1,UserId:1,Weight:1},SplittingItems:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,CalcOnId:1,CustomerId:1,DeliveryDate:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,EmployeeId:1,HasBom:1,ItemTypeId:1,KaratId:1,LedgerName:1,Line_No:1,LotNo:1,MetalColorId:1,NetWeight:1,OrderTypeId:1,OtherPieces:1,OtherWeight:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,PureWeight:1,Purity:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RefVoucherNo:1,StockAllocation:1,StonePieces:1,StoneWeight:1,SubBagNo:1,TransDate:1,TransId:1,TransItemId:1,TreeId:1,TreeItemId:1,TreeNo:1,UserId:1,VoucherNo:1,Weight:1},TreeMaking:{AdditionalCharges:1,AddressId:1,BaseWeight:1,ButtonWeight:1,CompanyId:1,ConversionFactor:1,CurrencyId:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IssueDetails:1,ItemDetails:1,KaratId:1,Loss:1,LossPercent:1,MetalBalance:1,MetalColorId:1,MetalConsumed:1,MetalIssued:1,MetalRequired:1,NetAmount:1,NetWeight:1,OtherPieces:1,OtherWeight:1,Pieces:1,ProcessId:1,Purity:1,RMDepartmentId:1,ReceiptDetail:1,Remark:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,StonePieces:1,StoneWeight:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,TreeNo:1,TreeWeight:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},TreeMakingBOM:{AttributeId:1,BagNo:1,BomProductId:1,CalcOnId:1,CertificateNo:1,CompanyId:1,FinancialYearId:1,IsCustomerItem:1,IsExisting:1,ItemTypeId:1,Lab:1,Line_No:1,LotNo:1,Markup:1,Pieces:1,ProductId:1,PureWeight:1,Purity:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SettingId:1,SettingName:1,StoneStatusId:1,StoneStatusName:1,TransBomId:1,TransId:1,TransItemId:1,UserId:1,Weight:1},TreeMakingIssue:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,CalcOnId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CompanyId:1,DeliveryDate:1,DepartmentId:1,GroupId:1,ImageName:1,ItemTypeId:1,Line_No:1,LotNo:1,NetWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefTransTypeId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SpecialRemark:1,Studded:1,SubCategoryId:1,SubCategoryName:1,TransId:1,TransItemId:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},TreeMakingItems:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,CalcOnId:1,DeliveryDate:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,EmployeeId:1,HasBom:1,ItemTypeId:1,LedgerName:1,Line_No:1,LotNo:1,MovementId:1,NetWeight:1,OrderTypeId:1,OtherPieces:1,OtherWeight:1,POSCustomerId:1,Pieces:1,ProductCode:1,ProductId:1,PureWeight:1,Purity:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RefVoucherNo:1,StockAllocation:1,StonePieces:1,StoneWeight:1,SubBagNo:1,TransDate:1,TransId:1,TransItemId:1,UserId:1,VoucherNo:1,Weight:1},TreeMakingReceipt:{AckStatus:1,Attribute:1,AttributeId:1,BagNo:1,BagStatus:1,CalcOnId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CompanyId:1,DeliveryDate:1,DepartmentId:1,GroupId:1,ImageName:1,ItemTypeId:1,KaratName:1,Line_No:1,LotNo:1,MetalColorName:1,NetWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefTransTypeId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SpecialRemark:1,Studded:1,SubCategoryId:1,SubCategoryName:1,TransId:1,TransItemId:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1},WIPMovement:{Attribute:1,AttributeId:1,BagNo:1,CalcOnId:1,CompanyId:1,CustomerName:1,DepartmentId:1,DeptCode:1,DeptName:1,DiamondPieces:1,DiamondWeight:1,EmployeeId:1,EmployeeName:1,FinancialYearId:1,FromDepartmentId:1,FromDeptName:1,FromEmployeeId:1,FromEmployeeName:1,FromNetWeight:1,FromPieces:1,FromWeight:1,HasBom:1,ImageName:1,ItemTypeId:1,KaratId:1,Line_No:1,Loss:1,LossPercent:1,MetalColorId:1,MetalId:1,MovementDate:1,MovementId:1,NetWeight:1,OrderId:1,OrderPiece:1,OrderTypeId:1,OrderVoucherNo:1,OtherPieces:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProcessId:1,ProcessName:1,ProductCode:1,ProductId:1,PureWeight:1,Purity:1,RefMovementId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SKU:1,StonePieces:1,StoneWeight:1,SubBagNo:1,ToDepartmentId:1,ToDeptName:1,ToEmployeeId:1,ToEmployeeName:1,ToNetWeight:1,ToPieces:1,ToWeight:1,TransDate:1,TransId:1,TransItemId:1,TreeId:1,TreeItemId:1,TreeNo:1,VoucherNo:1,VoucherTypeId:1,Weight:1},WIPTransaction:{Attribute:1,AttributeId:1,BagNo:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CompanyId:1,CostMethodId:1,DepartmentId:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,EmployeeId:1,FinancialYearId:1,GroupId:1,HSN:1,ImageName:1,IsCustomerItem:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,MetalColorId:1,MetalColorName:1,MovementId:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,PartyId:1,Pieces:1,ProcessId:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,PureWeight:1,Purity:1,QualityId:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SKU:1,SettingId:1,SettingName:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,StockId:1,StoneAmount:1,StoneColorId:1,StoneColoreName:1,StonePieces:1,StoneSizeId:1,StoneSizeName:1,StoneStatusId:1,StoneStatusName:1,StoneWeight:1,Studded:1,SubBagNo:1,TaxCode:1,TransId:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1},WorkOrder:{CompanyId:1,DepartmentId:1,EmployeeId:1,FinancialYearId:1,ItemDetails:1,NoofBags:1,Pieces:1,SelectDetails:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},WorkOrderBOM:{Attribute:1,AttributeId:1,BagNo:1,BomProductId:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CompanyId:1,FinancialYearId:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Line_No:1,LotNo:1,Markup:1,MetalColorId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SettingId:1,SettingName:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneStatusName:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TransBomId:1,TransId:1,TransItemId:1,UserId:1,Weight:1},WorkOrderItems:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BrandId:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CollectionId:1,DeliveryDate:1,DepartmentId:1,DiamondPieces:1,DiamondWeight:1,EmployeeId:1,GroupSieveId:1,HSN:1,HasBom:1,Image1:1,Image2:1,Image3:1,ImageName:1,ItemType:1,ItemTypeId:1,KaratId:1,LedgerName:1,Line_No:1,MetalColorId:1,MetalId:1,NetWeight:1,OrderTypeId:1,OtherPieces:1,OtherWeight:1,POSCustomerId:1,Parts:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RefVoucherNo:1,Remarks:1,ShapeId:1,SieveId:1,StockAllocation:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,SubBagNo:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UserId:1,VoucherNo:1,Weight:1}},Purchase:{ApprovalIn:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ApprovalInBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SBomRate:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ApprovalInItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,ChallanDate:1,ChallanNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,FinancialYearId:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PurchasePieces:1,PurchaseVoucher:1,PurchaseWeight:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RemainingPieces:1,RemainingWeight:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,SalesPieces:1,SalesVoucher:1,SalesWeight:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},ApprovalInLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},ApprovalInReturn:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ApprovalInReturnBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ApprovalInReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RefVoucherTypeId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},ApprovalInReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},MaterialIn:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},MaterialInBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},MaterialInItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsCustomerItem:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},Order:{AdditionalCharges:1,Address1:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,ProductItemImage:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},OrderItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,InStock:1,IsClosed:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},OrderLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},PurchaseItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BillDate:1,BillNo:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CCUnitCost:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,ChallanDate:1,ChallanNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,FinancialYearId:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,PurityName:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},PurchaseItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HSN:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TaxCode:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},PurchaseLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},PurchaseMaster:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GSTState:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,Shrt:1,State:1,TaxAmount:1,TaxDetails:1,TaxRegType:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},PurchaseReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},PurchaseReturnItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HSN:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TaxCode:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},PurchaseReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},PurchaseReturnMaster:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TaxDetails:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},PurchaseReturnTax:{CCTaxAmount:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},PurchaseTax:{CCTaxAmount:1,CentralTaxAmount:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,ECommGST:1,EligibilityForITC:1,GrossAmount:1,HSN:1,InputRCMLedgerId:1,IntegratedTaxAmount:1,InvoiceType:1,LedgerId:1,LedgerName:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,PartyTax:1,ProductTypeId:1,ReverseCharge:1,State:1,StateTaxAmount:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransDate:1,TransId:1,TransTaxId:1,VoucherNo:1},Quotation:{AdditionalCharges:1,Address1:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,ProductItemImage:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},QuotationBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},QuotationItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},QuotationLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},RateFixing:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,Pan:1,PartyCode:1,PartyId:1,PostingDate:1,Rate:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TaxDetails:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},RateFixingItems:{AckStatus:1,AttributeId:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,FancyCharges:1,GrossAmount:1,GroupId:1,HSN:1,HasBom:1,ImageName:1,IsPosted:1,ItemTypeId:1,KaratId:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,PureWeight:1,Purity:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SpecialRemark:1,StoneAmount:1,StonePieces:1,StoneRate:1,StoneWeight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},RateFixingTax:{CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1}},Repair:{Repair:{ActiveCustomers:1,AdditionalCharges:1,Address1:1,AutoPosting:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,CustomerType:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FrequencyPoints:1,GSTState:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,MonetaryPoints:1,NetAmount:1,NetWeight:1,POSCustomerId:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RecencyPoints:1,Remark:1,RepairTypeId:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TaxDetails:1,TermsId:1,TotalPoints:1,TotalRepair:1,TotalRepairAmount:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},RepairItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,IsRepairProcess:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefOrderId:1,RefOrderItemId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},RepairItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},RepairLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},RepairTax:{B2CSType:1,CCTaxAmount:1,CentralTaxAmount:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,Code:1,ECommGST:1,EligibilityForITC:1,GrossAmount:1,HSN:1,InputRCMLedgerId:1,IntegratedTaxAmount:1,InvoiceType:1,LedgerId:1,LedgerName:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,PartyTax:1,ProductTypeId:1,ReverseCharge:1,State:1,StateTaxAmount:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransDate:1,TransId:1,TransTaxId:1,VoucherNo:1}},Reports:{ItemsRegister:{AttributeId:1,CompanyCode:1,DeptName:1,DiamondWeight:1,GrossAmount:1,Image:1,ImageLength:1,MF:1,MFAmount:1,MetalGrossWeight:1,MetalNetWeight:1,OrderNo:1,Party:1,PartyId:1,Pieces:1,PreciousStoneWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,RefNo:1,SemiPreciousStoneWeight:1,StampCode:1,Status:1,SuperTypeCode:1,TotalDiamondWeight:1,TransId:1,TransItemId:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1},PriceBifurcation:{AttributeId:1,CompanyCode:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondRate:1,DiamondType:1,DiamondWeight:1,Discount:1,GrossAmount:1,Image:1,ImageLength:1,KaratId:1,MF:1,MFAmount:1,MetalColorName:1,MetalGrossWeight:1,MetalName:1,MetalNetAmount:1,MetalNetWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductLink:1,ProductName:1,ProductSizeCode:1,PureWeight:1,Purity:1,RefNo:1,Remark:1,StampCode:1,Status:1,StoneAmount:1,StonePieces:1,StoneRate:1,StoneType:1,StoneWeight:1,SuperTypeCode:1,TotalDiamondWeight:1,TotalLabour:1,TotalStoneWeight:1,TransId:1,TransItemId:1,UnitLabour:1,VoucherNo:1,VoucherTypeId:1},ShortList:{AttributeId:1,CompanyCode:1,DeptName:1,DiamondWeight:1,GrossAmount:1,Image:1,ImageLength:1,MF:1,MFAmount:1,MetalGrossWeight:1,MetalNetWeight:1,OrderNo:1,PartyId:1,Pieces:1,PreciousStoneWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,RefNo:1,SemiPreciousStoneWeight:1,StampCode:1,Status:1,SuperTypeCode:1,TotalDiamondWeight:1,TransId:1,TransItemId:1,VoucherNo:1,VoucherTypeId:1},ShortListCategoryWise:{AttributeId:1,CategoryCode:1,CompanyCode:1,DeptName:1,DiamondWeight:1,GrossAmount:1,Image:1,ImageLength:1,MF:1,MFAmount:1,MetalGrossWeight:1,MetalNetWeight:1,OrderNo:1,PartyId:1,Pieces:1,PreciousStoneWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,RefNo:1,SemiPreciousStoneWeight:1,StampCode:1,Status:1,SuperTypeCode:1,TotalDiamondWeight:1,TransId:1,TransItemId:1,VoucherNo:1,VoucherTypeId:1},StockBifurcation:{AttributeId:1,Company:1,CustomerName:1,DepartmentName:1,Discount:1,GrossAmount:1,GroupSieveName:1,Image:1,ImageLength:1,KaratId:1,KaratName:1,LedgerName:1,MF:1,MFAmount:1,MetalColorName:1,MetalGrossWeight:1,MetalName:1,MetalNetAmount:1,MetalNetWeight:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,PurchasePieces:1,PurchaseVoucher:1,PurchaseWeight:1,PureWeight:1,Purity:1,QualityName:1,RemainingPieces:1,RemainingWeight:1,Remark:1,SKU:1,SalesPieces:1,SalesVoucher:1,SalesWeight:1,ShapeName:1,SieveName:1,Status:1,StoneColoreName:1,StonePieces:1,StoneProductType:1,StoneSizeName:1,StoneType:1,StoneWeight:1,TotalLabour:1,TotalStoneWeight:1,TransDate:1,TransId:1,TransItemId:1,UnitLabour:1,VoucherNo:1,VoucherTypeId:1,Weight:1},StoneBifurcation:{AttributeId:1,CompanyCode:1,DeptName:1,DiamondAmount:1,DiamondPieces:1,DiamondRate:1,DiamondType:1,DiamondWeight:1,Discount:1,GrossAmount:1,Image:1,ImageLength:1,KaratId:1,MF:1,MFAmount:1,MetalColorName:1,MetalGrossWeight:1,MetalName:1,MetalNetAmount:1,MetalNetWeight:1,PartyId:1,Pieces:1,PreciousStonePieces:1,PreciousStoneType:1,PreciousStoneWeight:1,ProductCode:1,ProductId:1,ProductLink:1,ProductName:1,ProductSizeCode:1,PureWeight:1,Purity:1,RefNo:1,Remark:1,SemiPreciousStonePieces:1,SemiPreciousStoneType:1,SemiPreciousStoneWeight:1,StampCode:1,Status:1,SuperTypeCode:1,TotalDiamondWeight:1,TotalPreciousStoneWeight:1,TotalSemiPreciousStoneWeight:1,TransId:1,TransItemId:1,VoucherNo:1,VoucherTypeId:1},UserRoles:{RoleId:1,UserId:1,UserRoleId:1}},Retail:{Exchange:{AdditionalCharges:1,Address:1,Anniversary:1,AutoPosting:1,BillDate:1,BillNo:1,BirthDate:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FirstName:1,GrossAmount:1,IsExchanged:1,IsPosted:1,ItemDetails:1,LastName:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,ProductItemImage:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ExchangeItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},ExchangeItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ExchangeLabor:{Attribute:1,AttributeId:1,BrandId:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},ExchangeTax:{CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},GiftVoucherAllocate:{CompanyId:1,CompanyName:1,EmployeeId:1,ItemDetails:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},GiftVoucherAllocateDetails:{Amount:1,Code:1,CompanyId:1,EmployeeId:1,GvMasterId:1,GvNumber:1,RefTransId:1,RefTransItemId:1,RefVoucherTypeId:1,TransId:1,TransItemId:1,UserId:1,Value:1},GiftVoucherIssue:{GiftMasterId:1,ItemDetails:1,Quantity:1,TransDate:1,TransId:1,VoucherNo:1,VoucherTypeId:1},GiftVoucherItemDetails:{Amount:1,Code:1,Expiry:1,FixedName:1,GiftMasterId:1,Id:1,IsIssued:1,IsPartial:1,IsRedeemed:1,MinInvoiceValue:1,RedeemedDate:1,RedeemedValue:1,RefVoucherId:1,TransId:1,TransItemId:1,UniqueNo:1,Value:1},GiftVoucherItems:{GiftMasterId:1,ItemDetails:1,Quantity:1,TransId:1,TransItemId:1},GiftVoucherSales:{CompanyId:1,EmployeeId:1,ItemDetails:1,POSCustomerId:1,ReceiptDetails:1,TotalAmount:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1},GiftVoucherSalesDetails:{Amount:1,Code:1,CompanyId:1,EmployeeId:1,GvMasterId:1,GvNumber:1,RefTransId:1,RefTransItemId:1,RefVoucherTypeId:1,TransId:1,TransItemId:1,UserId:1,Value:1},GiftVoucherSalesReceipt:{Amount:1,ChequeDate:1,ChequeNo:1,Code:1,Id:1,LedgerId:1,ModeId:1,RefNo:1,RefTransId:1,RefVoucherType:1,Scheme:1,SchemeEnrollmentId:1,TransId:1},OrderBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},POSApproval:{AdditionalCharges:1,Address:1,Anniversary:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,BirthDate:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,DepartmentId:1,Discount:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,ItemDetails:1,MF:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,ProductItemImage:1,ReceiptAmount:1,ReceiptDetails:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},POSApprovalBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},POSApprovalItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,CustomerName:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,FirstName:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LastName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PurchasePieces:1,PurchaseVoucher:1,PurchaseWeight:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RemainingPieces:1,RemainingWeight:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,SalesPieces:1,SalesVoucher:1,SalesWeight:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},POSApprovalLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},POSApprovalReturn:{AdditionalCharges:1,Address:1,Anniversary:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,BirthDate:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,DepartmentId:1,Discount:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,ItemDetails:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,ProductItemImage:1,ReceiptAmount:1,ReceiptDetails:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},POSApprovalReturnBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},POSApprovalReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,CustomerName:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},POSApprovalReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},POSOrder:{AdditionalCharges:1,Address:1,AddressDetails:1,Anniversary:1,BillDate:1,BillNo:1,BillingAddress:1,BillingCity:1,BillingCityName:1,BillingCountry:1,BillingCountryName:1,BillingPin:1,BillingState:1,BillingStateName:1,BirthDate:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,CheckList:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,ECommOrderId:1,ECommOrderNo:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FirstName:1,GrossAmount:1,ItemDetails:1,LastName:1,MF:1,Mobile:1,NetAmount:1,NetWeight:1,OrderStatusId:1,OrderStatusName:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,ProductItemImage:1,ReasonId:1,ReceiptAmount:1,ReceiptDetails:1,Remark:1,ShipAddressId:1,ShipmentId:1,ShippingAddress:1,ShippingCity:1,ShippingCityName:1,ShippingCountry:1,ShippingCountryName:1,ShippingPincode:1,ShippingState:1,ShippingStateName:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},POSOrderAddress:{Address1:1,AddressId:1,City:1,CityName:1,Country:1,CountryName:1,POSCustomerId:1,Pincode:1,State:1,StateName:1,TransId:1,Type:1},POSOrderBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,SettingName:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},POSOrderItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,CustomerName:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ECommOrderId:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OrderStatus:1,OrderStatusId:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,PosCustomerCode:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,Status:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},POSOrderLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},POSQuotation:{AdditionalCharges:1,Address:1,Anniversary:1,BaseItemTypeId:1,BillDate:1,BillNo:1,BirthDate:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,CityId:1,CompanyId:1,CountryId:1,CurrencyId:1,CustomerName:1,Discount:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FirstName:1,GrossAmount:1,ImageName:1,ItemDetails:1,LastName:1,MF:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,Remark:1,ShipAddressId:1,ShipmentId:1,StateId:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},POSQuotationBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},POSQuotationItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,CustomerName:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,PosCustomerCode:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,Status:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},POSQuotationLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},POSReturn:{AdditionalCharges:1,Address:1,Anniversary:1,AutoPosting:1,BaseItemTypeId:1,BillDate:1,BillNo:1,BirthDate:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,IsPosted:1,IsReturned:1,ItemDetails:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,ProductItemImage:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TaxDetails:1,TaxId:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},POSReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},POSReturnItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},POSReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},POSReturnTax:{CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},POSSales:{AdditionalCharges:1,Address:1,Anniversary:1,AutoPosting:1,BalanceAmount:1,BillDate:1,BillNo:1,BirthDate:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GSTState:1,GiftDetails:1,GrossAmount:1,ImageName:1,IsPosted:1,ItemDetails:1,MF:1,Mobile:1,Month:1,MonthlySales:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,PromoDetails:1,Receipt:1,ReceiptDetails:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TaxDetails:1,TaxId:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},POSSalesGiftVoucher:{Amount:1,Expiry:1,GiftMasterId:1,IsPartial:1,Quantity:1,TransGiftId:1,TransId:1,UniqueCode:1,Value:1},POSSalesItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,BrandName:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CollectionName:1,CompanyId:1,CostMethodId:1,CustomerName:1,Day1Amount:1,Day2Amount:1,Day3Amount:1,Day4Amount:1,Day5Amount:1,Day6Amount:1,Day7Amount:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,EmployeeId:1,ExportPieces:1,FancyCharges:1,Footfall1:1,Footfall2:1,Footfall3:1,Footfall4:1,Footfall5:1,FromYear:1,GrossAmount:1,GrossAmountPercent:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,IsRepairProcess:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,LaborDetails:1,Line_No:1,LotNo:1,M10Amount:1,M10Pieces:1,M10Weight:1,M11Amount:1,M11Pieces:1,M11Weight:1,M12Amount:1,M12Pieces:1,M12Weight:1,M1Amount:1,M1Pieces:1,M1Weight:1,M2Amount:1,M2Pieces:1,M2Weight:1,M3Amount:1,M3Pieces:1,M3Weight:1,M4Amount:1,M4Pieces:1,M4Weight:1,M5Amount:1,M5Pieces:1,M5Weight:1,M6Amount:1,M6Pieces:1,M6Weight:1,M7Amount:1,M7Pieces:1,M7Weight:1,M8Amount:1,M8Pieces:1,M8Weight:1,M9Amount:1,M9Pieces:1,M9Weight:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,Month:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TimeSlot1:1,TimeSlot2:1,TimeSlot3:1,TimeSlot4:1,TimeSlot5:1,ToYear:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Week:1,WeekAmount:1,Weight:1,WstPer:1,WstWt:1},POSSalesItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,SettingName:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},POSSalesLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,OriginalLabourAmount:1,OriginalLabourRate:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},POSSalesReceipt:{Amount:1,Balance:1,BankId:1,ChequeDate:1,ChequeNo:1,Code:1,Denominations:1,LedgerId:1,ModeId:1,ReceiptId:1,RefNo:1,RefTransId:1,RefVoucherType:1,Scheme:1,SchemeEnrollmentId:1,TempAmount:1,Total:1,TransId:1},POSSalesReceiptDetails:{Amount:1,Code:1,Count:1,DenominationId:1,ReceiptDetailsId:1,ReceiptId:1},POSSalesReport:{AdditionalCharges:1,AddressId:1,BillDate:1,BillNo:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CompanyName:1,CurrencyId:1,DeppartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GrossAmountDay1:1,GrossAmountDay2:1,GrossAmountDay3:1,GrossAmountDay4:1,GrossAmountDay5:1,GrossAmountDay6:1,GrossAmountSlot1:1,GrossAmountSlot2:1,GrossAmountSlot3:1,GrossAmountSlot4:1,GrossAmountSlot5:1,GrossAmountSlot6:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PartyId:1,Pieces:1,RefVoucherId:1,Remark:1,Roundoff:1,ShipAddressId:1,ShipmentId:1,TaxAmount:1,TermsId:1,TotalGrossAmount:1,TransDate:1,TransId:1,UserId:1,VoucherNo:1,VoucherTypeId:1,Weight:1},POSSalesTax:{B2CSType:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,ECommGST:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,State:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},POSSalesWithoutTax:{AdditionalCharges:1,Address:1,Anniversary:1,AutoPosting:1,BalanceAmount:1,BillDate:1,BillNo:1,BirthDate:1,ChallanDate:1,ChallanNo:1,CompanyId:1,CurrencyId:1,CustomerName:1,Discount:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GSTState:1,GiftDetails:1,GrossAmount:1,ImageName:1,IsPosted:1,ItemDetails:1,Mobile:1,NetAmount:1,NetWeight:1,POSCustomerId:1,PanNumber:1,PartyId:1,Pieces:1,PosCustomerCode:1,PostingDate:1,PromoDetails:1,Receipt:1,ReceiptDetails:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,TaxId:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},PosSalesPromo:{ProductTypeId:1,ProductTypeName:1,PromoAmount:1,PromoCode:1,PromoId:1,PromoName:1,PromoPer:1,TotalAmount:1,TransId:1,TransPromoId:1},Receipt:{BankId:1,CompanyId:1,CurrencyId:1,Date:1,EnteredBy:1,ExchangeRate:1,FinancialYearId:1,InvoiceNo:1,IsAdvance:1,KnockOffTotal:1,LedgerId:1,LedgerName:1,Narration:1,Num1:1,Num2:1,Num3:1,OrderVoucherNo:1,POSCustomerId:1,PartyBalance:1,PosCustomerCode:1,ReceiptDetails:1,RefDate:1,RefNo:1,RefTransId:1,RefVoucherId:1,RefVoucherNo:1,String1:1,String2:1,String3:1,SuffixPrefixId:1,SysDate:1,TaxLedgerId:1,TotalAmount:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1},ReceiptDenominationDetails:{Amount:1,Code:1,Count:1,DenominationId:1,ReceiptDetailsId:1,ReceiptId:1},ReceiptDetails:{Amount:1,BankId:1,ChequeDate:1,ChequeNo:1,Denominations:1,ExchangeRateId:1,LedgerId:1,LedgerName:1,Mode:1,Num1:1,Num2:1,Num3:1,OrderId:1,PartyType:1,ReceiptId:1,RefNo:1,RefTransId:1,RefVoucherId:1,String1:1,String2:1,String3:1,SysDate:1,TaxAmount:1,TaxId:1,TaxName:1,TransId:1}},Sales:{ApprovalOut:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,MF:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ApprovalOutBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,BrandCode:1,BrandName:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionCode:1,CollectionName:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveCode:1,GroupSieveId:1,GroupSieveName:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalCode:1,MetalColorCode:1,MetalColorId:1,MetalColorName:1,MetalName:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveCode:1,SieveId:1,SieveName:1,StampCode:1,StampName:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletCode:1,StoneCuletId:1,StoneCuletName:1,StoneCutCode:1,StoneCutId:1,StoneCutName:1,StoneDepth:1,StoneFluorescenceCode:1,StoneFluorescenceId:1,StoneFluorescenceName:1,StoneGirdleCode:1,StoneGirdleId:1,StoneGirdleName:1,StonePolishCode:1,StonePolishId:1,StonePolishName:1,StoneSizeCode:1,StoneSizeId:1,StoneSizeName:1,StoneStatusId:1,StoneSymmetryCode:1,StoneSymmetryId:1,StoneSymmetryName:1,StoneTable:1,SubCategoryCode:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ApprovalOutItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandCode:1,BrandId:1,BrandName:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionCode:1,CollectionId:1,CollectionName:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,FinancialYearId:1,GrossAmount:1,GroupId:1,GroupSieveCode:1,GroupSieveId:1,GroupSieveName:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,KaratName:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalCode:1,MetalColorCode:1,MetalColorId:1,MetalColorName:1,MetalId:1,MetalName:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductSizeName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveCode:1,SieveId:1,SieveName:1,SpecialRemark:1,StampCode:1,StampId:1,StampName:1,StockAllocation:1,StoneAmount:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletCode:1,StoneCuletId:1,StoneCuletName:1,StoneCutCode:1,StoneCutId:1,StoneCutName:1,StoneDepth:1,StoneFluorescenceCode:1,StoneFluorescenceId:1,StoneFluorescenceName:1,StoneGirdleCode:1,StoneGirdleId:1,StoneGirdleName:1,StonePieces:1,StonePolishCode:1,StonePolishId:1,StonePolishName:1,StoneRate:1,StoneSizeCode:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryCode:1,StoneSymmetryId:1,StoneSymmetryName:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryCode:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,SuperTypeName:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},ApprovalOutLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},ApprovalOutReturn:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,RefVoucherId:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},ApprovalOutReturnBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,BrandCode:1,BrandName:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionCode:1,CollectionName:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveCode:1,GroupSieveId:1,GroupSieveName:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalCode:1,MetalColorCode:1,MetalColorId:1,MetalColorName:1,MetalName:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveCode:1,SieveId:1,SieveName:1,StampCode:1,StampName:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletCode:1,StoneCuletId:1,StoneCuletName:1,StoneCutCode:1,StoneCutId:1,StoneCutName:1,StoneDepth:1,StoneFluorescenceCode:1,StoneFluorescenceId:1,StoneFluorescenceName:1,StoneGirdleCode:1,StoneGirdleId:1,StoneGirdleName:1,StonePolishCode:1,StonePolishId:1,StonePolishName:1,StoneSizeCode:1,StoneSizeId:1,StoneSizeName:1,StoneStatusId:1,StoneSymmetryCode:1,StoneSymmetryId:1,StoneSymmetryName:1,StoneTable:1,SubCategoryCode:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},ApprovalOutReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,Status:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},ApprovalOutReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},DeliveryChallan:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},DeliveryChallanBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,BrandCode:1,BrandName:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionCode:1,CollectionName:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveCode:1,GroupSieveId:1,GroupSieveName:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,KaratName:1,Lab:1,Markup:1,MetalCode:1,MetalColorCode:1,MetalColorId:1,MetalColorName:1,MetalName:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,RefTransBomId:1,Remarks:1,SettingId:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveCode:1,SieveId:1,SieveName:1,StampCode:1,StampName:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletCode:1,StoneCuletId:1,StoneCuletName:1,StoneCutCode:1,StoneCutId:1,StoneCutName:1,StoneDepth:1,StoneFluorescenceCode:1,StoneFluorescenceId:1,StoneFluorescenceName:1,StoneGirdleCode:1,StoneGirdleId:1,StoneGirdleName:1,StonePolishCode:1,StonePolishId:1,StonePolishName:1,StoneSizeCode:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryCode:1,StoneSymmetryId:1,StoneSymmetryName:1,StoneTable:1,SubCategoryCode:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},DeliveryChallanItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandCode:1,BrandId:1,BrandName:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionCode:1,CollectionId:1,CollectionName:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveCode:1,GroupSieveId:1,GroupSieveName:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,KaratName:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalCode:1,MetalColorCode:1,MetalColorId:1,MetalColorName:1,MetalId:1,MetalName:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductSizeName:1,ProductTypeCode:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityCode:1,QualityId:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,ServerDate:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveCode:1,SieveId:1,SieveName:1,SpecialRemark:1,StampCode:1,StampId:1,StampName:1,StockAllocation:1,StoneAmount:1,StoneColorCode:1,StoneColorId:1,StoneColoreName:1,StoneCuletCode:1,StoneCuletId:1,StoneCuletName:1,StoneCutCode:1,StoneCutId:1,StoneCutName:1,StoneDepth:1,StoneFluorescenceCode:1,StoneFluorescenceId:1,StoneFluorescenceName:1,StoneGirdleCode:1,StoneGirdleId:1,StoneGirdleName:1,StonePieces:1,StonePolishCode:1,StonePolishId:1,StonePolishName:1,StoneRate:1,StoneSizeCode:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryCode:1,StoneSymmetryId:1,StoneSymmetryName:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryCode:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,SuperTypeName:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},DeliveryChallanLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},MaterialOut:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,DepartmentId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,Weight:1},MaterialOutBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},MaterialOutItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,FancyCharges:1,GrossAmount:1,GroupId:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsCustomerItem:1,IsDisabled:1,IsPosted:1,ItemTypeId:1,KaratId:1,Lab:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,RoutingId:1,SKU:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},RateFixing:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillAddId:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,Pan:1,PartyCode:1,PartyId:1,PostingDate:1,Rate:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TaxDetails:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},RateFixingItems:{AckStatus:1,AttributeId:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CategoryId:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,FancyCharges:1,GrossAmount:1,GroupId:1,HSN:1,HasBom:1,ImageName:1,IsPosted:1,ItemTypeId:1,KaratId:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,RoutingId:1,SKU:1,SalesCostMethodId:1,SpecialRemark:1,StoneAmount:1,StonePieces:1,StoneRate:1,StoneWeight:1,Studded:1,SubCategoryId:1,SuperTypeId:1,TaxCode:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},RateFixingTax:{Cess1Amount:1,Cess1Id:1,Cess1LedgerId:1,Cess1Rate:1,Cess2Amount:1,Cess2Id:1,Cess2LedgerId:1,Cess2Rate:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,NetAmount:1,ProductTypeId:1,Tax1Amount:1,Tax1Id:1,Tax1LedgerId:1,Tax1Rate:1,Tax2Amount:1,Tax2Id:1,Tax2LedgerId:1,Tax2Rate:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxRate:1,TransId:1,TransTaxId:1},SalesItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BillDate:1,BillNo:1,BrandId:1,BrandName:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CollectionName:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,FinancialYearId:1,Friday:1,GrossAmount:1,GrossAmountPercent:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,IsRepairProcess:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,Monday:1,Month:1,Month1:1,Month2:1,Month3:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,PriceRange1:1,PriceRange2:1,PriceRange3:1,PriceRange4:1,PriceRange5:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Quarter:1,Quarter1Amount:1,Quarter1Pieces:1,Quarter2Amount:1,Quarter2Pieces:1,Quarter3Amount:1,Quarter3Pieces:1,Quarter4Amount:1,Quarter4Pieces:1,Rate:1,RefNo:1,RefOrderId:1,RefOrderItemId:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,Saturday:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,Thursday:1,TransDate:1,TransId:1,TransItemId:1,Tuesday:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Wednesday:1,Week:1,Week1Pieces:1,Week1Sales:1,Week2Pieces:1,Week2Sales:1,Week3Pieces:1,Week3Sales:1,Week4Pieces:1,Week4Sales:1,Weight:1,WstPer:1,WstWt:1},SalesItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},SalesLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},SalesMaster:{ActiveCustomers:1,AdditionalCharges:1,Address1:1,AutoPosting:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,CustomerType:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,FrequencyPoints:1,GSTState:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,MF:1,MonetaryPoints:1,Month:1,MonthlySales:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RecencyPoints:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TaxDetails:1,TermsId:1,TotalPoints:1,TotalSales:1,TotalSalesAmount:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},SalesQuotation:{AdditionalCharges:1,Address1:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsApproved:1,IsSubmitted:1,ItemDetails:1,LedgerName:1,MarkUpPolicyId:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PriceListId:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},SalesQuotationBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,MetalColorName:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},SalesQuotationItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,ItemType:1,ItemTypeId:1,Iteration:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalColorName:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,StatusId:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SalesQuotationLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1},SalesReturnItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryCode:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyCode:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsDisabled:1,IsPosted:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampCode:1,StampId:1,Status:1,StockAllocation:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeCode:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SalesReturnItemsBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},SalesReturnLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1},SalesReturnMaster:{AdditionalCharges:1,Address1:1,AutoPosting:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,IsPosted:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,PostingDate:1,ProductItemImage:1,RefTransId:1,RefVoucherId:1,Remark:1,RoundOff:1,ShipAddressId:1,ShipmentId:1,State:1,TaxAmount:1,TaxDetails:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},SalesReturnTax:{CCTaxAmount:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,HSN:1,InputRCMLedgerId:1,LedgerId:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,ProductTypeId:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransId:1,TransTaxId:1},SalesTax:{B2CSType:1,CCTaxAmount:1,CentralTaxAmount:1,CessAmount:1,CessId:1,CessLedgerId:1,CessRate:1,Code:1,ECommGST:1,EligibilityForITC:1,GrossAmount:1,HSN:1,InputRCMLedgerId:1,IntegratedTaxAmount:1,InvoiceType:1,LedgerId:1,LedgerName:1,NetAmount:1,OutputLedgerId:1,OutputRCMLedgerId:1,PartyTax:1,ProductTypeId:1,ReverseCharge:1,State:1,StateTaxAmount:1,TaxAmount:1,TaxId:1,TaxLedgerId:1,TaxName:1,TaxRate:1,TaxType:1,TransDate:1,TransId:1,TransTaxId:1,VoucherNo:1}},SalesOrder:{SalesOrder:{AdditionalCharges:1,Address1:1,BillDate:1,BillNo:1,CCGrossAmount:1,CCNetAmount:1,CCRoundOff:1,CCTaxAmount:1,ChallanDate:1,ChallanNo:1,City:1,CompanyId:1,Country:1,CurrencyId:1,Discount:1,Email:1,EmployeeId:1,ExchRate:1,FinancialYearId:1,GrossAmount:1,GstVat:1,ItemDetails:1,LedgerName:1,NetAmount:1,NetWeight:1,Pan:1,PartyCode:1,PartyId:1,Pieces:1,ProductItemImage:1,Remark:1,ShipAddressId:1,ShipmentId:1,State:1,Status:1,TaxAmount:1,TermsId:1,TransDate:1,TransId:1,UserId:1,Username:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},SalesOrderBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CCBomAmount:1,CalcOn:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,Discount:1,DiscountPercent:1,GrossWeight:1,GroupSieveId:1,HasBom:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,Markup:1,MetalColorId:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,RefTransBomId:1,Remarks:1,SalesCostMethodId:1,SettingId:1,SettingName:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePolishId:1,StoneSizeId:1,StoneStatusId:1,StoneSymmetryId:1,StoneTable:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,TransBomId:1,TransItemId:1,Weight:1},SalesOrderItems:{AckStatus:1,Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BagStatus:1,BrandId:1,CCGrossAmount:1,CCNetAmount:1,CalcOnId:1,CalcUnitId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CompanyId:1,CostMethodId:1,DeliveryDate:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,Discount:1,DiscountPer:1,ExportPieces:1,FancyCharges:1,GrossAmount:1,GroupSieveId:1,HSN:1,HUID:1,HasBom:1,ImageName:1,IsDisabled:1,ItemType:1,ItemTypeId:1,KaratId:1,Lab:1,LaborDetails:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MetalAmount:1,MetalColorId:1,MetalId:1,NetAmount:1,NetWeight:1,OtherAmount:1,OtherCharges:1,OtherPieces:1,OtherRate:1,OtherWeight:1,Parts:1,PartyId:1,Pieces:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,Remark:1,Remarks:1,SKU:1,SalesCostMethodId:1,ServerDate:1,ShapeId:1,SieveId:1,SpecialRemark:1,StampId:1,Status:1,StoneAmount:1,StoneColorId:1,StoneCuletId:1,StoneCutId:1,StoneDepth:1,StoneFluorescenceId:1,StoneGirdleId:1,StonePieces:1,StonePolishId:1,StoneRate:1,StoneSizeId:1,StoneSymmetryId:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TaxCode:1,TransDate:1,TransId:1,TransItemId:1,UnitCost:1,UnitLabour:1,UnitRate:1,UserDescription:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1,WstPer:1,WstWt:1},SalesOrderLabor:{Attribute:1,AttributeId:1,BrandId:1,CCLabourAmount:1,CalcOn:1,CalcOnId:1,CalculateTo:1,CategoryId:1,CategoryName:1,CollectionId:1,Discount:1,DiscountPercent:1,IsCustomerItem:1,ItemTypeId:1,LabourAmount:1,LabourRate:1,MarkUp:1,Parts:1,Pieces:1,ProcessId:1,ProcessName:1,ProductTypeId:1,ProductTypeName:1,QualityId:1,ShapeId:1,SieveId:1,StoneColorId:1,StoneSizeId:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,TransItemId:1,TransLbrId:1,Weight:1,WstPer:1,WstWt:1}},Scheme:{SchemeEnrollment:{BonusValue:1,IsCancelled:1,IsMatured:1,IsRedeemed:1,POSCustomerId:1,PosCustomerCode:1,SchemeAmount:1,SchemeCode:1,SchemeEnrollmentId:1,SchemeId:1,Tenure:1},SchemeMaster:{AllowCancellation:1,BonusType:1,BonusValue:1,CancellationCharge:1,Description:1,Frequency:1,SchemeAmount:1,SchemeCode:1,SchemeId:1,SchemeType:1,Tenure:1},SchemePayment:{Address:1,Amount:1,CustomerName:1,FirstName:1,LedgerId:1,LedgerName:1,Mobile:1,POSCustomerId:1,PanNumber:1,PosCustomerCode:1,SchemeCode:1,SchemeId:1,SchemePaymentDetails:1,SchemePaymentId:1,TransDate:1,VoucherNo:1,VoucherTypeId:1},SchemePaymentDetails:{Amount:1,ChequeDate:1,ChequeNo:1,Code:1,LedgerId:1,ModeId:1,RefNo:1,SchemeDetailsId:1,SchemePaymentId:1}},Stock:{JobTransaction:{Attribute:1,AttributeId:1,BagNo:1,CalcOnId:1,CertificateNo:1,CompanyId:1,CostMethod:1,DepartmentId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,FinancialYearId:1,GroupId:1,HSN:1,ImageName:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratCode:1,KaratId:1,LedgerName:1,Line_No:1,LotNo:1,MetalAmount:1,MetalCode:1,MetalColorId:1,MovementId:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,PartyId:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductTypeCode:1,ProductTypeId:1,PureWeight:1,Purity:1,QualityId:1,Rate:1,RefNo:1,RefTransId:1,RefVoucherId:1,SKU:1,ShapeId:1,SieveId:1,Status:1,StockId:1,StoneAmount:1,StoneColorId:1,StonePieces:1,StoneSizeId:1,StoneStatusId:1,StoneWeight:1,Studded:1,TransId:1,Variance:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1},StockItem:{Attribute:1,AttributeId:1,BOMDetails:1,BagNo:1,BrandId:1,BrandName:1,CalcOnId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CollectionId:1,CollectionName:1,CompanyCode:1,CompanyId:1,CostMethodId:1,CustomerName:1,DepartmentId:1,DeptName:1,DesignCode:1,DesignId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,ExportPieces:1,Fancy2Pieces:1,Fancy2Size:1,Fancy2Weight:1,FancyPieces:1,FancySize:1,FancyWeight:1,FinancialYearId:1,HSN:1,HUID:1,Hallmark:1,HasBom:1,ImageName:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,LedgerName:1,Line_No:1,LotNo:1,MF:1,MFAmount:1,MarquisePieces:1,MarquiseWeight:1,MetalAmount:1,MetalColorId:1,MetalColorName:1,MetalId:1,MetalName:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherSize:1,OtherWeight:1,POSCustomerId:1,POSSalesAmount:1,POSSalesPieces:1,POSSalesReturnAmount:1,POSSalesReturnPieces:1,Parts:1,PartyCode:1,PartyId:1,Pieces:1,PreciousPieces:1,PreciousWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductSizeCode:1,ProductSizeId:1,ProductTypeId:1,ProductTypeName:1,PurchaseAmount:1,PurchasePieces:1,PurchaseReturnAmount:1,PurchaseReturnPieces:1,PureWeight:1,Purity:1,QualityId:1,QualityName:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,RoundPieces:1,RoundSize:1,RoundWeight:1,SKU:1,SalesAmount:1,SalesPieces:1,SalesReturnAmount:1,SalesReturnPieces:1,SemiPreciousPieces:1,SemiPreciousWeight:1,SetId:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,StampCode:1,StampId:1,StockAllocation:1,StockId:1,StoneAmount:1,StoneColorId:1,StoneColoreName:1,StoneCuletCode:1,StoneCuletId:1,StoneCuletName:1,StoneCutCode:1,StoneCutId:1,StoneCutName:1,StoneDepth:1,StoneFluorescenceCode:1,StoneFluorescenceId:1,StoneFluorescenceName:1,StoneGirdleCode:1,StoneGirdleId:1,StoneGirdleName:1,StonePieces:1,StonePolishCode:1,StonePolishId:1,StonePolishName:1,StoneRate:1,StoneSizeId:1,StoneSizeName:1,StoneSymmetryCode:1,StoneSymmetryId:1,StoneSymmetryName:1,StoneTable:1,StoneWeight:1,Studded:1,SubCategoryId:1,SubCategoryName:1,SuperTypeId:1,SuperTypeName:1,TaxCode:1,TransId:1,TransItemId:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,VoucherTypeName:1,Weight:1},StockItemBOM:{Attribute:1,BOMAttributeId:1,BOMProductId:1,BomAmount:1,BomRate:1,CalcOn:1,CalcOnId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CostMethodId:1,GroupSieveId:1,GroupSieveName:1,IsCustomerItem:1,ItemType:1,ItemTypeId:1,KaratId:1,KaratName:1,Lab:1,Line_No:1,MetalColorId:1,MetalColorName:1,Parts:1,Pieces:1,PointerWeight:1,ProductCode:1,ProductId:1,ProductName:1,ProductTypeId:1,ProductTypeName:1,PurchaseCostMethodId:1,PureWeight:1,Purity:1,QualityId:1,QualityName:1,Remarks:1,SalesCostMethodId:1,SettingId:1,ShapeCode:1,ShapeId:1,ShapeName:1,SieveId:1,SieveName:1,StockBomId:1,StockId:1,StoneColorId:1,StoneColoreName:1,StoneSizeId:1,StoneSizeName:1,StoneStatusId:1,SubCategoryId:1,SubCategoryName:1,TextureId:1,Weight:1},StockReport:{AttributeId:1,BagNo:1,CalcOnId:1,CategoryId:1,CategoryName:1,CertificateNo:1,CompanyId:1,DepartmentId:1,DiamondAmount:1,DiamondPieces:1,DiamondWeight:1,FinancialYearId:1,GroupId:1,HSN:1,ImageName:1,ItemTypeId:1,Lab:1,Line_No:1,LotNo:1,MetalAmount:1,NetWeight:1,OtherAmount:1,OtherPieces:1,OtherWeight:1,POSCustomerId:1,PartyId:1,Pieces:1,Pieces0:1,Pieces120:1,Pieces150:1,Pieces180:1,Pieces30:1,Pieces60:1,Pieces90:1,ProductCode:1,ProductId:1,ProductTypeId:1,ProductTypeName:1,Profit:1,ProfitPercent:1,PurchaseTotal:1,PureWeight:1,Purity:1,Rate:1,RefNo:1,RefTransId:1,RefTransItemId:1,RefVoucherId:1,SKU:1,SalesTotal:1,SetId:1,StockId:1,StoneAmount:1,StonePieces:1,StoneStatusId:1,StoneWeight:1,Studded:1,TotalPieces:1,TransId:1,TransItemId:1,VoucherDate:1,VoucherNo:1,VoucherTypeId:1,Weight:1}},_Ext:{AuditLog:{ADate:1,ATime:1,ActionDate:1,ActionType:1,EntityId:1,EntityTableName:1,Id:1,IpAddress:1,NewEntity:1,OldEntity:1,SessionId:1,UserId:1,Username:1,VersionNo:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{FacebookButton:1,ForgotPassword:1,FormTitle:1,GoogleButton:1,OR:1,RememberMe:1,SignInButton:1,SignUpButton:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,BackToLogin:1,ConfirmEmail:1,ConfirmPassword:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,Password:1,SubmitButton:1,Success:1}}},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContentDescription:1},Layout:{FooterCopyright:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AuthenticationError:1,CantFindUserWithEmail:1,CurrentPasswordMismatch:1,CustomerLogin:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,InvalidActivateToken:1,InvalidCompany:1,InvalidResetToken:1,MinRequiredPasswordLength:1,SavePrimaryKeyError:1}});
}
